/* grip-quiz.js — Grips4Less Grip Finder v35 sitemap-trust speed pass  (build 2026-07-16-sitemap-trust-no-html-404-checks)

   2026-07-16 (v35) speed pass: live diagnostics showed the dominant
   results-screen cost was per-handle "product HTML page (404 check)" fetches
   (4.5s timeout each) issued by verifyPublicProductPage for handles absent from
   the sitemap. v35 trusts Shopify's product sitemap — the authoritative list of
   Online-Store-published products — as the publication gate: when the sitemap
   index has loaded and a handle is DEFINITIVELY absent, the product is failed
   closed WITHOUT a per-handle HTML fetch. This removes those checks entirely.
   The v34 tokenless bulk collection feed was removed: it was multi-MB, only
   trimmed a few stock calls, and shadowed the sitemap (making 404 checks
   worse). No scoring/ranking/size/color/format/price change — 300/300 ranking
   combinations identical to v33. Sold-out still requires available===true; not-
   live still fails closed (now via the sitemap). Toggle:
   window.GRIP_QUIZ_TRUST_SITEMAP=false restores per-handle HTML confirmation.
   See CHANGELOG-v35.txt.
   Prior header: v28 + Tour TRAXION correction (build 2026-07-15-tour-traxion-runtime-correction)
   Requires window.GRIP_SPECS (grip-specs.js) loaded first — MUST be
   grip-specs-with-descriptions.js (or a later export that still carries the
   `shopify_description` field per record) for the description-based scoring
   below to do anything. If GRIP_SPECS lacks `shopify_description`, this file
   degrades gracefully to the 07-09 jumbomax-dedup baseline (all description
   checks are no-ops on an empty string).

   2026-07-14 fix: putter style-priority results could render blank because
   putterMatchPhrases()/putterTradeoffPhrases() referenced an undeclared
   `target` variable only when style scoring was active. Both helpers now
   receive the render target explicitly, preventing the style-only runtime
   exception while leaving recommendation ranking unchanged.
   Renders inside <div id="gripQuiz"></div>. CSS = grip-quiz.css (asset).
   PostHog: posthog.init() runs in grip-quiz.liquid.

   2026-07-09 addition: descriptionSignals()/descriptionBoost() mine the new
   `shopify_description` field (real Shopify product copy, matched 649/649,
   619 non-empty) for a short whitelist of high-confidence phrases that the
   curated spec fields don't already capture — water resistance, reduced
   torque/taper, non-slip/high-traction claims, shock-absorption language.
   Kept deliberately small and separate from the curated-field checks in
   scoreClub/scorePutter, per the 2026-07-08 lesson from the alignment/
   "ribbed" false-positive bug: free text is a weaker signal than curated
   fields and must never be allowed to swing score by more than a tie-break
   amount. See MEMORY grip-quiz-alignment-ribbed-false-positive-fix-2026-07-08. */
(function(){
"use strict";

/* ================================================================== *
 *  QUESTION CONFIG
 *  option: {v,label,desc,icon}.  question: hint (short guidance),
 *  measure (long "how to" shown in an expandable help panel).
 * ================================================================== */
var ROUTER = { id:'regrip', eye:'Start here', q:'What are you shopping for?',
  hint:'We’ll use your answers to suggest the best grip size, feel, and product options.',
  options:[
    {v:'set',   icon:'club',  label:'Golf grips for my clubs', desc:'Driver, woods, irons, wedges, or a full regrip'},
    {v:'putter',icon:'putter',label:'A putter grip',             desc:'Putter-specific size, shape, and feel'},
    {v:'both',  icon:'bag',   label:'Club grips + putter grip',  desc:'Get one recommendation for clubs and one for your putter'}
  ]};

var CLUB = [
  {id:'hand', eye:'Hand size', q:'What best describes your hand size?',
   hint:'No measuring needed — just pick the closest answer.',
   measure:'Optional: if you want a more exact fit, measure from your wrist crease to the tip of your middle finger. Most golfers can skip measuring and answer by feel.',
   options:[
     {v:'small',icon:'ruler',label:'Smaller hands', desc:'Usually fits smaller grips or smaller glove sizes'},
     {v:'average',icon:'hand',label:'Average hands', desc:'The most common adult hand size'},
     {v:'large',icon:'fist',label:'Larger hands', desc:'Usually fits larger grips or large/XL glove sizes'},
     {v:'verylarge',icon:'fist',label:'Very large hands', desc:'Usually XXL glove size or bigger'},
     {v:'unsure',icon:'help',label:'Not sure', desc:'Start at standard and fine-tune from your other answers'}
   ]},
  {id:'finger', eye:'Current fit', q:'How do grips usually feel in your fingers?',
   hint:'This fine-tunes size based on what you actually feel when holding the club.',
   measure:'If your fingertips dig in or the grip feels skinny, choose “too thin.” If it feels bulky or hard to wrap your fingers around, choose “too thick.” If you’re unsure, choose “about right / not sure.”',
   options:[
     {v:'thick',icon:'pinch',label:'A little too thick', desc:'Grips can feel bulky or hard to wrap your fingers around'},
     {v:'right',icon:'thumb',label:'About right', desc:'Current grip thickness feels comfortable'},
     {v:'thin',icon:'circle',label:'A little too thin', desc:'Grips feel skinny or your fingers wrap too far around'},
     {v:'unsure',icon:'help',label:'Not sure', desc:'No size change from this answer'}
   ]},
  {id:'tension', eye:'Pressure & comfort', q:'Do you squeeze tightly or experience hand discomfort?',
   hint:'This helps us decide whether a larger, softer, or reduced-taper grip may help.',
   options:[
     {v:'none', icon:'feather',label:'No — relaxed and comfortable', desc:'Normal grip pressure with no hand or wrist discomfort'},
     {v:'tight',icon:'fist',label:'I tend to squeeze tightly', desc:'A slightly larger or reduced-taper grip may help'},
     {v:'pain', icon:'health',label:'My hands or wrists get tired or sore', desc:'We’ll favor cushioning and vibration reduction'},
     {v:'both', icon:'cushion',label:'Both — tight pressure and discomfort', desc:'We’ll prioritize reduced tension, cushioning, and size'}
   ]},
  {id:'sweat', eye:'Traction', q:'Do your grips ever feel slippery?',
   hint:'Cord and all-weather grips help when your hands or conditions get wet.',
   options:[
     {v:'dry',   icon:'sun',  label:'Rarely', desc:'Mostly dry hands and fair-weather golf'},
     {v:'sweaty',icon:'drop', label:'Yes, my hands get sweaty', desc:'You need more traction in heat or humidity'},
     {v:'wet',   icon:'rain', label:'Yes, I play in rain/wet conditions', desc:'You need maximum wet-weather traction'}
   ]},
  {id:'feel', eye:'Feel', q:'What kind of grip feel do you like?',
   hint:'There’s no wrong answer — this is mostly personal preference.',
   options:[
     {v:'soft',    icon:'cushion',label:'Soft and comfortable', desc:'More cushion, less harsh feedback'},
     {v:'balanced',icon:'balance',label:'Balanced', desc:'Not too soft, not too firm'},
     {v:'firm',    icon:'target', label:'Firm and responsive', desc:'More feedback and control'}
   ]},
  {id:'musthave', eye:'Specific feature', q:'Is there a specific grip feature you definitely want?',
   hint:'We’ll first find grips that include this construction feature. Choose no specific feature if you want the best overall fit.',
   options:[
     {v:'corded',icon:'grid',label:'Corded surface', desc:'I definitely want cord in the grip construction'},
     {v:'wrap',icon:'spiral',label:'Wrap-style grip', desc:'I definitely want a classic wrapped surface'},
     {v:'align',icon:'plus',label:'Alignment ridge', desc:'I definitely want a raised reminder ridge for repeatable hand placement'},
     {v:'round',icon:'circle',label:'Standard round grip', desc:'I specifically do not want a raised ridge'},
     {v:'reducedtaper',icon:'fist',label:'Reduced taper / larger lower hand', desc:'I definitely want less taper through the lower hand'},
     {v:'none',icon:'help',label:'No specific feature', desc:'Choose the best overall match from my other answers'}
   ]},
  {id:'priority', eye:'Main goal', q:'What is your main goal with your new grips?',
   hint:'We’ll use this goal to rank the grips that fit your size, conditions, and selected feature.',
   options:[
     {v:'comfort', icon:'cushion',label:'Reduce hand fatigue', desc:'Favor cushioning, comfort, and less harsh feedback'},
     {v:'traction',icon:'grid',   label:'Improve traction in moisture', desc:'Favor grip security in heat, humidity, or wet conditions'},
     {v:'control', icon:'target', label:'Get more feedback and control', desc:'Favor a connected feel and consistent hand placement'},
     {v:'size',    icon:'fist',   label:'Reduce grip pressure', desc:'Favor shapes and sizes that can reduce squeezing'},
     {v:'style',   icon:'plus',   label:'Add more color and personality', desc:'Favor strong color ranges, patterns, and special designs'},
     {v:'value',   icon:'thumb',  label:'Get the best value', desc:'Favor a reliable full-set option at a lower per-grip cost'}
   ]}
];

var PUTTER = [
  {id:'stroke', eye:'Stroke', q:'Which putting stroke sounds most like yours?',
   hint:'If you’re not sure, choose “Slight arc” — it fits most golfers.',
   measure:'Watch the putter head during a few practice strokes. If it goes mostly straight back and through, choose straight. If it opens/closes a little, choose slight arc. If it clearly swings inside and releases, choose strong arc.',
   options:[
     {v:'straight', icon:'ruler', label:'Mostly straight back and through', desc:'The putter face stays fairly square'},
     {v:'slight',   icon:'moon',  label:'Slight arc / not sure', desc:'The most common putting stroke'},
     {v:'arc',      icon:'rotate',label:'Strong arc', desc:'The putter face opens and releases more'}
   ]},
  {id:'wristaction', eye:'Hands', q:'Do your wrists get too active when putting?',
   hint:'Bigger grips can calm the hands; slimmer grips keep more feel.',
   options:[
     {v:'wristy',  icon:'hand', label:'Yes — I get wristy', desc:'We’ll lean more stable/larger'},
     {v:'neutral', icon:'hand', label:'Sometimes / average', desc:'Balanced recommendation'},
     {v:'quiet',   icon:'zen',  label:'No — my hands stay quiet', desc:'You may prefer more feel'}
   ]},
  {id:'psize', eye:'Size', q:'What putter grip thickness do you like?',
   hint:'Bigger grips quiet the hands. Slimmer grips give more feel.',
   options:[
     {v:'standard', icon:'pinch',label:'Standard / slim', desc:'Most feel, traditional size'},
     {v:'midsize',  icon:'fist', label:'Midsize', desc:'Balanced and popular'},
     {v:'oversize', icon:'hand', label:'Oversize / jumbo', desc:'Most stable, quietest hands'},
     {v:'nopref',   icon:'help', label:'No preference', desc:'Recommend for me'}
   ]},
  {id:'pweight', eye:'Weight', q:'What putter grip weight do you prefer?',
   hint:'Heavier grips feel steadier. Lighter grips keep more head feel.',
   options:[
     {v:'light',  icon:'feather',label:'Lighter — more feel', desc:'Keeps the putter head feeling lively'},
     {v:'medium', icon:'balance',label:'Medium / not sure', desc:'Balanced recommendation'},
     {v:'heavy',  icon:'weight', label:'Heavier — more stable', desc:'Can smooth out the stroke'},
     {v:'nopref', icon:'help',   label:'No preference', desc:'Recommend for me'}
   ]},
  {id:'pfeel', eye:'Feel', q:'What feel do you want in a putter grip?',
   hint:'',
   options:[
     {v:'soft',  icon:'cushion',label:'Soft and tacky', desc:'Comfortable and grippy'},
     {v:'firm',  icon:'target', label:'Firm and responsive', desc:'More feedback at impact'},
     {v:'nopref',icon:'help',   label:'No preference', desc:'Either is fine'}
   ]},
  {id:'pcomfort', eye:'Comfort', q:'Do you want your putter grip to reduce hand tension?',
   hint:'Larger, softer, or wrist-stabilizing putter grips can help quiet the hands.',
   options:[
     {v:'yes',   icon:'health',label:'Yes — reduce tension', desc:'Help calm wrist action or hand pressure'},
     {v:'no',    icon:'target',label:'No — keep more feedback', desc:'Prefer a more traditional connected feel'},
     {v:'nopref',icon:'help',  label:'No preference', desc:'Recommend what fits best'}
   ]},
  {id:'ppriority', eye:'Priority', q:'What matters most in your putter grip?',
   hint:'This helps us rank your best-fitting putter grips based on what matters most to you.',
   options:[
     {v:'stability',icon:'fist',   label:'More stability', desc:'Quiet my wrists and reduce hand action'},
     {v:'control',  icon:'target', label:'Face control', desc:'Help me feel the putter face and start line'},
     {v:'comfort',  icon:'cushion',label:'Soft comfort', desc:'Tacky, comfortable feel'},
     {v:'style',    icon:'plus',   label:'Color and style', desc:'A look that stands out'},
     {v:'value',    icon:'thumb',  label:'Best value', desc:'Reliable putter grip without overthinking it'}
   ]}
];

var ALLQ={}; [ROUTER].concat(CLUB,PUTTER).forEach(function(q){ALLQ[q.id]=q;});
function labelOf(qid,v){var q=ALLQ[qid];if(!q)return v;for(var i=0;i<q.options.length;i++)if(q.options[i].v===v)return q.options[i].label;return v;}


/* The shortened club flow translates only the combined tension answer into
   the legacy pressure/comfort fields. Must-have answers remain separate and
   are used as product eligibility requirements, preventing duplicate profile
   and hard-preference scoring when the final goal points to the same need.
   Legacy console profiles that explicitly pass texture/alignment still work. */
function normalizeQuizAnswers(a){
  var out=Object.assign({},a||{});

  /* v22 removes the separate putter-style question. Preserve old saved/test
     answer objects by translating the strongest legacy style response only
     when no final putter priority was recorded. The final priority is now the
     single authoritative style signal. */
  if(!out.ppriority&&out.pstyle==='high')out.ppriority='style';

  if(out.tension){
    if(out.tension==='none'){
      out.pressure='light';out.comfort='no';
    }else if(out.tension==='tight'){
      out.pressure='tight';out.comfort='no';
    }else if(out.tension==='pain'){
      out.pressure='moderate';out.comfort='yes';
    }else if(out.tension==='both'){
      out.pressure='tight';out.comfort='yes';
    }
  }

  if(out.musthave){
    /* Must-have answers are product requirements only. They no longer write
       cord/wrap/alignment choices into the legacy scoring fields, which used
       to make the final feature and goal questions count the same need twice.
       Keep neutral legacy values so the rest of the scoring engine remains
       backward-compatible without adding profile or hard-preference points. */
    if(out.texture==null)out.texture='nopref';
    if(out.alignment==null)out.alignment='nopref';
  }

  /* Infer a customer-facing must-have value for legacy test profiles so the
     new explanation layer can still describe old pressure/texture/alignment
     answer objects accurately. */
  if(!out.musthave){
    if(out.texture==='corded'&&out.alignment==='yes')out.musthave='cordedalign';
    else if(out.texture==='corded')out.musthave='corded';
    else if(out.texture==='wrap')out.musthave='wrap';
    else if(out.alignment==='yes')out.musthave='align';
    else if(out.alignment==='round')out.musthave='round';
    else out.musthave='none';
  }
  if(!out.tension){
    if(out.pressure==='tight'&&out.comfort==='yes')out.tension='both';
    else if(out.pressure==='tight')out.tension='tight';
    else if(out.comfort==='yes')out.tension='pain';
    else out.tension='none';
  }
  return out;
}
function syncDerivedQuizAnswers(a){
  var target=a||ans;
  var normalized=normalizeQuizAnswers(target);
  ['pressure','comfort','texture','alignment'].forEach(function(k){target[k]=normalized[k];});
  return target;
}

/* inline stroke-style icons */
var IC={
 club:'M14 3l-1 8-5 7a2 2 0 102 2l6-6 6-1', putter:'M6 4v9a4 4 0 008 0M18 8h2', bag:'M7 8V6a5 5 0 0110 0v2M5 8h14l-1 12H6z',
 ruler:'M3 7h18v10H3zM7 7v4M11 7v4M15 7v4M19 7v4', help:'M9 9a3 3 0 114 2.8c-1 .5-1 1-1 2M12 17h.01',
 feather:'M20 4L8 16l-4 4M20 4l-9 1-3 8M14 10H6', hand:'M7 11V6a1.5 1.5 0 013 0v4M10 10V4.5a1.5 1.5 0 013 0V10M14 10V6a1.5 1.5 0 013 0v6a6 6 0 01-6 6H10a4 4 0 01-3-1.5L4 13a1.6 1.6 0 012.4-2L8 13',
 fist:'M6 10V8a2 2 0 014 0M10 8V7a2 2 0 014 0v1M14 8a2 2 0 014 0v5a6 6 0 01-6 6H9a4 4 0 01-3-1.4L4 15',
 sun:'M12 4V2M12 22v-2M4 12H2M22 12h-2M6 6L4.5 4.5M18 6l1.5-1.5M6 18l-1.5 1.5M18 18l1.5 1.5M12 8a4 4 0 100 8 4 4 0 000-8z',
 drop:'M12 3s6 6 6 10a6 6 0 01-12 0c0-4 6-10 6-10z', rain:'M7 14l-1 3M12 14l-1 3M17 14l-1 3M5 12a4 4 0 011-7 5 5 0 019-1 4 4 0 010 8',
 cushion:'M4 8a4 4 0 014-4h8a4 4 0 014 4v8a4 4 0 01-4 4H8a4 4 0 01-4-4z', balance:'M12 4v16M6 8h12M6 8l-3 5a3 3 0 006 0zM18 8l-3 5a3 3 0 006 0z',
 target:'M12 3a9 9 0 100 18 9 9 0 000-18zM12 7a5 5 0 100 10 5 5 0 000-10zM12 12h.01',
 health:'M11 4H8a4 4 0 00-4 4v3M13 4h3a4 4 0 014 4v3M12 8v8M8 12h8', thumb:'M7 11v8M7 11l3-7a2 2 0 013 1v4h5a2 2 0 012 2l-1.5 6a2 2 0 01-2 1.5H7',
 circle:'M12 4a8 8 0 100 16 8 8 0 000-16z', grid:'M4 9h16M4 15h16M9 4v16M15 4v16', spiral:'M12 12a2 2 0 112-2 4 4 0 11-4 4 6 6 0 116-6',
 plus:'M12 5v14M5 12h14', moon:'M6 9l6 6 6-6', rotate:'M3 11a9 9 0 0115-6l3 3M21 13a9 9 0 01-15 6l-3-3',
 zen:'M12 4a4 4 0 100 8 4 4 0 000-8zM4 20c1.5-4 4.5-6 8-6s6.5 2 8 6', pinch:'M9 4v6M15 4v6M9 10c-2 1-2 4 0 6h6c2-2 2-5 0-6', weight:'M6 8h12l1 12H5zM9 8a3 3 0 016 0'
};
function icon(n){var p=IC[n]||IC.help;return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+p.split('M').filter(Boolean).map(function(seg){return '<path d="M'+seg+'"/>';}).join('')+'</svg>';}

/* emoji answer icons — keeps the old friendly look for option buttons */
var EMOJI={
  club:'🏌️', putter:'⛳', bag:'🎒', ruler:'📏', help:'🤷',
  feather:'🪶', hand:'✋', fist:'✊', sun:'☀️', drop:'💧', rain:'🌧️',
  cushion:'🛋️', balance:'⚖️', target:'🎯', health:'🩹', thumb:'👍',
  circle:'🟢', grid:'🧵', spiral:'🌀', plus:'➕', moon:'🌙', rotate:'🔄',
  zen:'🧘', pinch:'🤏', weight:'🪨'
};
function emojiIcon(n){return EMOJI[n]||'•';}

/* ================================================================== *  STATE + EVENTS  */
var ans={}, order=['regrip'], idx=0, started=false, completed=false, root=null;

/* ─────────────────────────────────────────────
   POSTHOG QUIZ TRACKING  (parallel to iron-shaft-quiz.js)
   Events: grip_quiz_started, grip_quiz_completed,
           grip_quiz_product_clicked, grip_quiz_add_to_cart (theme.liquid),
           grip_quiz_checkout_started (custom pixel),
           grip_quiz_purchase_completed (Shopify Flow).
─────────────────────────────────────────────── */
function getGripQuizSessionId(){
  try{
    var k='grip_quiz_session_id', e=localStorage.getItem(k);
    if(e)return e;
    var id='grip_'+Date.now()+'_'+Math.random().toString(36).slice(2);
    localStorage.setItem(k,id);return id;
  }catch(e){return 'grip_ns_'+Date.now();}
}
var _gripSuperProps=null;
function registerGripQuizPostHogProps(props){
  try{
    if(!props)return;
    _gripSuperProps=Object.assign({},_gripSuperProps||{},props);
    if(window.posthog&&typeof posthog.register==='function'){posthog.register(props);return;}
    var n=0,t=setInterval(function(){n++;
      if(window.posthog&&typeof posthog.register==='function'){posthog.register(props);clearInterval(t);}
      else if(n>20)clearInterval(t);
    },250);
  }catch(e){}
}
function track(name,props){
  try{
    var payload=Object.assign(
      {quiz:'grip_finder',quiz_type:'grip_finder',quiz_session_id:getGripQuizSessionId()},
      _gripSuperProps||{},
      props||{}
    );
    if(window.posthog&&typeof posthog.capture==='function'){posthog.capture(name,payload);return;}
    var n=0,t=setInterval(function(){n++;
      if(window.posthog&&typeof posthog.capture==='function'){posthog.capture(name,payload);clearInterval(t);}
      else if(n>20)clearInterval(t);
    },250);
  }catch(e){}
}

/* Page mode classes — used for background height only.
   The quiz card itself stays natural height and can grow/shrink per question. */
function setQuizMode(mode){
  if(!root)return;
  root.style.removeProperty('--gq-stable-height');
  root.classList.remove('gq-question-mode','gq-loading-mode','gq-results-mode');

  if(mode==='results'){
    root.classList.add('gq-results-mode');
  }else if(mode==='loading'){
    /* Keep the same tall background while live inventory is checked,
       so the page does not collapse into a tiny loading state. */
    root.classList.add('gq-loading-mode');
  }else{
    root.classList.add('gq-question-mode');
  }
}

function progressPct(){
  if(!order || !order.length)return '0%';
  if(order.length<=1)return '0%';
  return Math.max(0,Math.min(100,Math.round((idx/(order.length-1))*100)))+'%';
}
function setProgress(v){
  var fill=root&&root.querySelector?root.querySelector('#gqFill'):null;
  if(!fill)return;
  if(typeof v==='number')v=Math.max(0,Math.min(100,Math.round(v)))+'%';
  /* The CSS defines progress fill width with !important, so a normal
     inline width assignment was being ignored. Set inline width as
     important too so the green bar actually grows. */
  fill.style.setProperty('width',v,'important');

  var pct=parseInt(v,10)||0;
  fill.setAttribute('aria-valuenow',String(pct));

  if(root){
    root.classList.toggle('gq-progress-complete',pct>=100);
  }

  if(pct>=100){
    fill.classList.remove('gq-progress-pop');
    void fill.offsetWidth;
    fill.classList.add('gq-progress-pop');

    if(root){
      root.classList.remove('gq-results-celebrate');
      void root.offsetWidth;
      root.classList.add('gq-results-celebrate');

      if(root._gqCelebrateTimer)clearTimeout(root._gqCelebrateTimer);
      root._gqCelebrateTimer=setTimeout(function(){
        if(root)root.classList.remove('gq-results-celebrate');
      },2200);
    }
  }
}

/* ================================================================== *  SIZING — official two-measurement chart  */
var SIZE_ORDER=['Undersize','Standard','Midsize','Jumbo/Oversize'];
var CHART={
 h0:['Undersize','Undersize','Undersize'], h1:['Undersize','Standard','Standard'],
 h2:['Standard','Standard','Standard'],    h3:['Standard','Midsize','Midsize'],
 h4:['Standard','Midsize','Midsize'],      h5:['Midsize','Midsize','Midsize'],
 h6:['Midsize','Jumbo/Oversize','Jumbo/Oversize'], h7:['Midsize','Jumbo/Oversize','Jumbo/Oversize'] };
function chartSize(h,f){var row=CHART[h]||CHART.h3;var fi={f0:0,f1:1,f2:2}[f];if(fi==null)fi=1;return row[fi];}
function recommendSize(a){
  a=normalizeQuizAnswers(a);
  var why=[], base='Standard';

  /* Customer-friendly sizing:
     1) Hand size gives the starting grip size.
     2) Finger/grip-feel answer adjusts up or down.
     3) Tight pressure and comfort can add a soft size bump.
     4) Smaller/average hands are capped so the quiz does not overreact. */

  var hand=a.hand||'unsure';

  if(hand==='small'){
    base='Undersize';
    why.push('you described your hands as smaller');
  }else if(hand==='average'){
    base='Standard';
    why.push('you described your hands as average size');
  }else if(hand==='large'){
    base='Midsize';
    why.push('you described your hands as larger');
  }else if(hand==='verylarge'){
    base='Jumbo/Oversize';
    why.push('you described your hands as very large');
  }else{
    base='Standard';
    why.push('the standard starting point because you were not sure on hand size');
  }

  var baseI=SIZE_ORDER.indexOf(base);
  if(baseI<0)baseI=1;

  var i=baseI;

  if(a.finger==='thick'){
    i-=1;
    why.push('you said grips can feel a little too thick in your fingers');
  }else if(a.finger==='thin'){
    i+=1;
    why.push('you said grips can feel a little too thin in your fingers');
  }else if(a.finger==='right'){
    why.push('you said your current grip thickness feels about right');
  }

  i=Math.max(0,Math.min(3,i));

  var bumps=0,bumpWhy=[];

  if(a.comfort==='yes'){
    bumps++;
    bumpWhy.push('extra hand and joint comfort');
  }

  if(a.pressure==='tight'){
    bumps++;
    bumpWhy.push('firmer grip pressure');
  }

  var bigHand=(hand==='large'||hand==='verylarge');

  if(!bigHand&&bumps>1)bumps=1;

  var beforeSoft=i;
  i+=bumps;

  /* 2026-07-09 fix: "large" hands (not "verylarge") were escalating straight to
     Jumbo/Oversize off a single bump reason (e.g. tight pressure alone, or
     comfort alone). Large hands already start at Midsize — that is usually the
     right answer for "large + tight." Only let a large hand escalate one size
     past Midsize when there are two stacking reasons (tight pressure AND
     comfort both selected), which is a genuinely stronger signal. Verylarge
     hands are unaffected — they were never the reported problem. */
  if(hand==='large'){
    var largeCap=(bumps>=2)?SIZE_ORDER.indexOf('Jumbo/Oversize'):SIZE_ORDER.indexOf('Midsize');
    i=Math.min(i,largeCap);
  }else if(!bigHand){
    i=Math.min(i,SIZE_ORDER.indexOf('Midsize'));
  }

  i=Math.max(0,Math.min(3,i));

  /* 2026-07-09 fix: when finger=thick sizes DOWN and a bump (tight pressure /
     comfort) sizes back UP, the two can cancel out and land the customer
     right back at their hand-based baseline (Case 19: average hands ->
     Standard, thick fingers -> Undersize, tight pressure bump -> back to
     Standard). The old text only ever said "we sized you up for firmer grip
     pressure," with no mention that this was undoing an earlier downsize —
     read on its own next to "grips can feel a little too thick in your
     fingers," it sounded contradictory (thick fingers normally means sizing
     DOWN, not up). Detect the net-zero-versus-baseline case and explain it
     as an offset instead of a one-directional "sized up." */
  if(i>beforeSoft&&bumpWhy.length){
    if(i===baseI&&a.finger==='thick'){
      why.push('that increase balances out the smaller size from your finger feedback, so you land back at '+SIZE_ORDER[i]+' overall');
    }else{
      why.push('we sized you up for '+bumpWhy.join(' and '));
    }
  }

  return {size:SIZE_ORDER[i],why:why.join(', ')};
}

/* ================================================================== *  SCORING  */
function has(re,s){return re.test(s||'');}
function adjacent(a,b){var i=SIZE_ORDER.indexOf(a),j=SIZE_ORDER.indexOf(b);return i>=0&&j>=0&&Math.abs(i-j)===1;}
function avgWeight(s){var v=[],k;for(k in (s.weight_g_by_size||{}))v.push(s.weight_g_by_size[k]);if(!v.length)return null;var t=0;v.forEach(function(x){t+=x;});return t/v.length;}

/* Player-profile scoring layer.
   The quiz now slots every answer set into the same 10 player profiles used in
   the product-profile spreadsheet, then uses those profiles as a recommendation
   layer on top of size/feel/texture/stroke scoring. */
var PLAYER_PROFILES=[
  'Humid / Sweaty Hands Player',
  'Arthritis / Joint Pain Player',
  'Maximum Comfort Player',
  'Control / Shotmaker Player',
  'High-Traction Player',
  'Beginner / Casual Player',
  'Oversize / Reduced Grip Pressure Player',
  'All-Weather Player',
  'Style / Color-Matching Player',
  'Value / Regrip Set Player'
];
var PROFILE_TIE_PRIORITY={
  'Arthritis / Joint Pain Player':10,
  'Humid / Sweaty Hands Player':9,
  'Oversize / Reduced Grip Pressure Player':8,
  'Control / Shotmaker Player':7,
  'High-Traction Player':6,
  'Maximum Comfort Player':5,
  'All-Weather Player':4,
  'Style / Color-Matching Player':3,
  'Value / Regrip Set Player':2,
  'Beginner / Casual Player':1
};
function profileScoreBlank(){var out={};PLAYER_PROFILES.forEach(function(p){out[p]=0;});return out;}
function addProfileScore(scores,profile,points){if(scores[profile]==null)scores[profile]=0;scores[profile]+=points;}
function sortProfileScores(scores){return PLAYER_PROFILES.slice().sort(function(a,b){
  var d=(scores[b]||0)-(scores[a]||0);
  if(d)return d;
  return (PROFILE_TIE_PRIORITY[b]||0)-(PROFILE_TIE_PRIORITY[a]||0);
});}
function profileSummary(scores){
  var sorted=sortProfileScores(scores);
  if((scores[sorted[0]]||0)<=0){
    addProfileScore(scores,'Beginner / Casual Player',3);
    addProfileScore(scores,'Value / Regrip Set Player',1);
    sorted=sortProfileScores(scores);
  }
  return {
    primaryProfile:sorted[0],
    primaryScore:scores[sorted[0]]||0,
    secondaryProfile:sorted[1],
    secondaryScore:scores[sorted[1]]||0,
    allProfileScores:scores
  };
}
function getCustomerProfiles(a){
  a=normalizeQuizAnswers(a||{});
  var scores=profileScoreBlank();

  /* Club/swing-grip answers */
  if(a.hand==='small')addProfileScore(scores,'Beginner / Casual Player',1);
  else if(a.hand==='large'){addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',3);addProfileScore(scores,'Control / Shotmaker Player',1);}
  else if(a.hand==='verylarge'){addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',5);addProfileScore(scores,'Control / Shotmaker Player',1);}
  else if(a.hand==='unsure'){addProfileScore(scores,'Beginner / Casual Player',2);addProfileScore(scores,'Value / Regrip Set Player',1);}

  if(a.finger==='thin')addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',3);
  else if(a.finger==='thick')addProfileScore(scores,'Control / Shotmaker Player',1);
  else if(a.finger==='right')addProfileScore(scores,'Beginner / Casual Player',1);

  if(a.pressure==='tight'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',5);
    addProfileScore(scores,'Arthritis / Joint Pain Player',2);
    addProfileScore(scores,'Maximum Comfort Player',2);
  }else if(a.pressure==='light')addProfileScore(scores,'Control / Shotmaker Player',1);
  else if(a.pressure==='moderate')addProfileScore(scores,'Beginner / Casual Player',1);

  if(a.sweat==='sweaty'){
    /* The required Priority question otherwise made Humid/Sweaty mathematically
       unable to win as a primary profile: every priority contributes at least
       6 points while the direct sweaty-hands signal contributed only 5. Give
       the golfer's actual condition enough weight to remain the primary need;
       corded must-haves can still move High-Traction ahead when appropriate. */
    addProfileScore(scores,'Humid / Sweaty Hands Player',7);
    addProfileScore(scores,'High-Traction Player',3);
    addProfileScore(scores,'All-Weather Player',2);
  }else if(a.sweat==='wet'){
    /* 2026-07-09 polish: wet/rain answers should be able to win the
       All-Weather primary profile. Previously wet players often still landed
       as High-Traction because texture=corded and priority=traction both fed
       High-Traction more heavily than All-Weather, leaving All-Weather
       reachable only as a secondary profile across all club combos. */
    addProfileScore(scores,'All-Weather Player',8);
    addProfileScore(scores,'High-Traction Player',4);
    addProfileScore(scores,'Humid / Sweaty Hands Player',2);
  }else if(a.sweat==='dry')addProfileScore(scores,'Beginner / Casual Player',1);

  if(a.feel==='soft'){
    addProfileScore(scores,'Maximum Comfort Player',5);
    addProfileScore(scores,'Arthritis / Joint Pain Player',2);
  }else if(a.feel==='firm'){
    addProfileScore(scores,'Control / Shotmaker Player',5);
    addProfileScore(scores,'High-Traction Player',1);
  }else if(a.feel==='balanced'){
    addProfileScore(scores,'Beginner / Casual Player',2);
    addProfileScore(scores,'Value / Regrip Set Player',1);
  }

  if(a.comfort==='yes'){
    addProfileScore(scores,'Arthritis / Joint Pain Player',6);
    addProfileScore(scores,'Maximum Comfort Player',4);
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',3);
  }else if(a.comfort==='no')addProfileScore(scores,'Control / Shotmaker Player',1);

  if(a.texture==='corded'){
    addProfileScore(scores,'High-Traction Player',6);
    addProfileScore(scores,'Humid / Sweaty Hands Player',4);
    addProfileScore(scores,'All-Weather Player',2);
  }else if(a.texture==='wrap'){
    addProfileScore(scores,'Maximum Comfort Player',3);
    addProfileScore(scores,'Style / Color-Matching Player',2);
    addProfileScore(scores,'Beginner / Casual Player',1);
  }else if(a.texture==='smooth'){
    addProfileScore(scores,'Beginner / Casual Player',2);
    addProfileScore(scores,'Value / Regrip Set Player',1);
  }

  if(a.alignment==='yes')addProfileScore(scores,'Control / Shotmaker Player',6);
  else if(a.alignment==='round')addProfileScore(scores,'Beginner / Casual Player',1);

  if(a.priority==='comfort'){
    addProfileScore(scores,'Maximum Comfort Player',6);
    addProfileScore(scores,'Arthritis / Joint Pain Player',3);
  }else if(a.priority==='traction'){
    /* The explicit goal should be able to make High-Traction the primary
       profile for sweaty/dry golfers. Wet-weather golfers can still land in
       All-Weather because the rain answer carries its own stronger signal. */
    addProfileScore(scores,'High-Traction Player',9);
    addProfileScore(scores,'Humid / Sweaty Hands Player',2);
    addProfileScore(scores,'All-Weather Player',a.sweat==='wet'?8:1);
  }else if(a.priority==='control'){
    addProfileScore(scores,'Control / Shotmaker Player',6);
    addProfileScore(scores,'High-Traction Player',2);
  }else if(a.priority==='size'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',6);
    addProfileScore(scores,'Arthritis / Joint Pain Player',2);
  }else if(a.priority==='style'){
    addProfileScore(scores,'Style / Color-Matching Player',10); /* 2026-07-08: harmonized with the validated club-track weight (was 6, cut Style/Color reachability from 10.8% to 2.3%) */
  }else if(a.priority==='value'){
    addProfileScore(scores,'Value / Regrip Set Player',6);
    addProfileScore(scores,'Beginner / Casual Player',3);
  }

  /* Must-have selections intentionally add no player-profile points.
     They filter/order eligible products; the final goal and the golfer's
     conditions determine the profile and ranking inside that eligible set. */

  /* Putter answers use the same 10 profile labels: control = face control,
     oversize = wrist/pressure reduction, comfort = softer/tackier feel.

     2026-07-08 rebalance (ported from the profile-map-only build): the original
     weights gave Control/Shotmaker a small bonus on nearly every question
     regardless of answer, so it won as primary on 62.6% of all 19,440 possible
     putter-track answer combinations, and Arthritis/Beginner/Humid-Sweaty/
     High-Traction/All-Weather were mathematically impossible to reach as primary.
     This removes Control's incidental "everything defaults to me" leakage, keeps
     it strong only where it's the genuine signal (arc stroke, firm feel, the
     dedicated control priority), and gives Arthritis/Beginner real point paths.
     Verified via brute-force sweep of all 19,440 combos: new distribution tops
     out at 28.2%, no profile above ~30%, Arthritis and Beginner now reachable
     (7.3% / 10.4%). Humid/Sweaty, High-Traction, and All-Weather remain
     unreachable on the putter track because no putter question asks about
     heat/humidity/wet conditions — that needs a new question, a UX/scope call. */
  if(a.stroke==='straight'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',3);
  }else if(a.stroke==='slight'){
    addProfileScore(scores,'Beginner / Casual Player',3);
  }else if(a.stroke==='arc')addProfileScore(scores,'Control / Shotmaker Player',3);

  if(a.wristaction==='wristy'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',6);
    addProfileScore(scores,'Control / Shotmaker Player',2);
    addProfileScore(scores,'Arthritis / Joint Pain Player',3);
  }else if(a.wristaction==='quiet')addProfileScore(scores,'Control / Shotmaker Player',2);
  else if(a.wristaction==='neutral')addProfileScore(scores,'Beginner / Casual Player',3);

  if(a.psize==='standard')addProfileScore(scores,'Control / Shotmaker Player',1);
  else if(a.psize==='midsize'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',3);
  }else if(a.psize==='oversize'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',6);
    addProfileScore(scores,'Control / Shotmaker Player',1);
    addProfileScore(scores,'Arthritis / Joint Pain Player',4);
  }else if(a.psize==='nopref')addProfileScore(scores,'Beginner / Casual Player',3);

  if(a.pweight==='heavy'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',2);
    addProfileScore(scores,'Control / Shotmaker Player',1);
  }else if(a.pweight==='light')addProfileScore(scores,'Control / Shotmaker Player',2);
  else if(a.pweight==='medium')addProfileScore(scores,'Beginner / Casual Player',2);
  else if(a.pweight==='nopref')addProfileScore(scores,'Beginner / Casual Player',1);

  if(a.pfeel==='soft'){
    addProfileScore(scores,'Maximum Comfort Player',5);
    addProfileScore(scores,'Arthritis / Joint Pain Player',4);
  }else if(a.pfeel==='firm')addProfileScore(scores,'Control / Shotmaker Player',4);
  else if(a.pfeel==='nopref')addProfileScore(scores,'Beginner / Casual Player',2);

  if(a.pcomfort==='yes'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',3);
    addProfileScore(scores,'Maximum Comfort Player',4);
    addProfileScore(scores,'Arthritis / Joint Pain Player',5);
  }else if(a.pcomfort==='no')addProfileScore(scores,'Control / Shotmaker Player',1);
  else if(a.pcomfort==='nopref')addProfileScore(scores,'Beginner / Casual Player',2);

  if(a.ppriority==='stability'){
    addProfileScore(scores,'Oversize / Reduced Grip Pressure Player',6);
    addProfileScore(scores,'Control / Shotmaker Player',3);
  }else if(a.ppriority==='control')addProfileScore(scores,'Control / Shotmaker Player',6);
  else if(a.ppriority==='comfort'){
    addProfileScore(scores,'Maximum Comfort Player',6);
    addProfileScore(scores,'Arthritis / Joint Pain Player',3);
  }else if(a.ppriority==='style')addProfileScore(scores,'Style / Color-Matching Player',22);
  else if(a.ppriority==='value'){
    addProfileScore(scores,'Value / Regrip Set Player',6);
    addProfileScore(scores,'Beginner / Casual Player',2);
  }

  return profileSummary(scores);
}
function normBrandName(brand){
  var b=(brand||'').toLowerCase().replace(/[^a-z0-9]+/g,'');
  if(b==='superstroke'||b==='superstrokeusa')return 'SuperStroke';
  if(b==='golfpride')return 'Golf Pride';
  if(b==='iomic')return 'Iomic';
  if(b==='jumbomax')return 'JumboMax';
  if(b==='lamkin')return 'Lamkin';
  return (brand||'').replace(/\s+/g,' ').trim();
}
function isExcludedGripBrand(s){return normBrandName(s&&s.brand)==='Lamkin';}
/* 2026-07-09: "Bubble"/.810"-core grips (Tacki-Mac Bubble Replacement,
   Tacki-Mac Pro Lite 865 Bubble, TaylorMade Crossline Bubble) are
   specialty/oversized build-up replacement grips, not a normal recommendation
   for a general quiz answer set — hard-excluded from the ranking pool the
   same way Lamkin is, rather than just penalized, per explicit request. */
var SPECIALTY_BUILDUP_RE=/\bbubble\b|\.810/i;
function isSpecialtyBuildupGrip(s){return SPECIALTY_BUILDUP_RE.test((s&&s.model)||'');}

/* 2026-07-09 fix: recommendation pools must contain actual grips only.
   Some accessory products are classified close enough to putter/grip products
   in the data that they can enter the scoring pool (example: Super Stroke
   Counter Balance Weight Insert). These should never be recommended as a grip.

   2026-07-09 safety update: do NOT exclude a full grip kit merely because one
   of its variant titles/format labels mentions tape or solvent. Kits are still
   grip products. Only exclude products whose primary product identity is an
   accessory/tool/insert/tape/solvent item. */
/* 2026-07-10 correction: a live test run flagged "Tacki-Mac Itomic Wrap Black
   Jumbo Black Cap With White Cap" (record id "tacki-mac-tacki", model="Tacki")
   as "Accessory/non-grip appeared." That first read like a headwear/cap
   listing, so a same-day fix here added a "<color> cap" phrase pattern to
   NON_GRIP_ACCESSORY_RE. Checked against the actual source data
   (grip-specs-with-descriptions.js) and that diagnosis was WRONG — this is a
   real, legitimate grip. Its Shopify handle/URL is literally
   tacki-mac-itomic-wrap-black-jumbo-grip-black-cap-with-white-cap: "Black Cap
   With White Cap" describes the grip's two-tone contrast END CAP color, the
   same naming convention already used elsewhere in this exact catalog
   ("Black with Blue Cap", "Black Grip / Red Cap", "Grey with Blue cap" all
   appear on other real, in-stock grips). The "<color> cap" phrase pattern has
   been removed — keeping it risked silently excluding legitimate two-tone
   grips from ever being recommended, which is worse than the false-positive
   test failure it was trying to fix. The "Accessory/non-grip appeared" flag
   on this product is a false positive in the external QA harness's own
   keyword check (it isn't part of this file), not a bug in grip-quiz.js —
   flagging for whoever owns that harness to add a color-cap exception rather
   than treating "cap" as inherently suspicious.
   Kept: the unambiguous headwear/accessory terms below (head cover, divot
   tool, ball marker, golf towel, golf umbrella, snapback, trucker/golf/
   baseball cap) — none of these collide with the "<color> cap" grip-color
   naming pattern, and a scan of all 649 catalog records confirmed zero false
   positives from them (only match: two legitimate "Super Stroke Replacement
   End Cap (Grip Not Included)" accessory records, which is correct to
   exclude). Same category of guard as the existing weight-insert/tool/tape
   exclusions below. */
/* 2026-07-10 fix: title-text guessing for "counter core / counter balance
   weight" turned up 18 false positives against the real catalog — real,
   purchasable Super Stroke putter grips that build in a counterweight, e.g.
   "Fatso 5.0 Putter Grip with CounterCore 50g Weight". A first attempt
   fixed that by requiring the weight terms NOT be accompanied by the word
   "grip" — but that missed "Super Stroke +Series 2.0 CounterCore Flatso XL
   (13.75")", a real armlock/long putter grip whose own name never happens
   to say "grip" or "putter" at all. Text alone can't reliably tell a real
   weighted grip apart from the standalone weight-insert accessory SKU.

   Checked the actual Shopify product export this data comes from
   (build_grip_specs.py reads products_export_*.csv) and found a much better
   signal already flowing through the pipeline: `source_tags` (Shopify's own
   product tags, carried into every grip-specs.js record). The standalone
   accessory SKUs are tagged with the literal, exact tags "Weight Insert" /
   "ball marker" / "ball markers" / "golf ball markers" — and the real
   CounterCore grip is not. These are curated merchant tags, not free text,
   so they don't have the collision risk that title guessing does. Verified
   against all 649 catalog records: exact-tag matching flags only the 2 real
   weight-insert SKUs + 1 real ball-marker SKU, and does not flag the
   CounterCore Flatso XL grip or any of the other 17 real weighted grips.

   Root cause note: all of these accessory SKUs are themselves tagged
   Shopify product_type "Golf Grips" upstream (build_grip_specs.py's own
   ingestion filter — `Type == "Golf Grips"` — already lets them through),
   so they're miscategorized in Shopify itself, not just guessed wrong here.
   The exact-tag check below is a solid guard either way, but the durable
   fix is recategorizing these SKUs' product_type/collection in Shopify so
   they never reach this pipeline as "Golf Grips" in the first place. */
var NON_GRIP_ACCESSORY_RE=/\b(?:wrench|installation\s*tool|grip\s*tool|grip\s*tape|shaft\s*tape|solvent|plug|head\s*cover|divot\s*tool|golf\s*towel|golf\s*umbrella|snapback|trucker\s*cap|golf\s*cap|baseball\s*cap)\b/i;
var NON_GRIP_ACCESSORY_TAGS=['weight insert','ball marker','ball markers','golf ball markers'];
var GRIP_KIT_PRODUCT_RE=/\b(?:grip\s*kit|regrip\s*kit|kit\s*with\s*grips|\d+\s*pc\s*(?:grip\s*)?(?:kit|set)|\d+\s*piece\s*(?:grip\s*)?(?:kit|set))\b/i;
function isNonGripAccessory(s){
  if(!s)return false;

  var primaryParts=[
    s.model,s.display_name,s.displayName,s.product_title,s.productTitle,
    s.title,s.name,s.full_title,s.fullTitle,s.category,s.product_type,s.productType
  ].filter(Boolean);
  var primaryText=primaryParts.join(' ');

  /* Grip kits/bundles are valid recommendation targets. They may include tape
     and solvent, but the product being recommended is still a grip/kit, not an
     accessory. */
  if(GRIP_KIT_PRODUCT_RE.test(primaryText))return false;

  /* If the actual product title/model unconditionally says it is an
     accessory/tool, exclude it regardless of anything else in the text. */
  if(NON_GRIP_ACCESSORY_RE.test(primaryText))return true;

  /* Exact-tag check for accessory categories that title text can't reliably
     distinguish from real grips (weight inserts, ball markers) — see
     2026-07-10 fix comment above. */
  var tags=String(s.source_tags||'').split(',').map(function(t){return t.trim().toLowerCase();});
  if(NON_GRIP_ACCESSORY_TAGS.some(function(t){return tags.indexOf(t)>=0;}))return true;

  return false;
}

function normalizeGripProfileKeyPart(v){
  return String(v||'').toLowerCase()
    .replace(/&/g,' and ')
    .replace(/\bgrips?\b/g,' ')
    .replace(/\bgolf\b/g,' ')
    .replace(/\bclub\b/g,' ')
    .replace(/\bputter\b/g,' ')
    .replace(/\bswing\b/g,' ')
    .replace(/\b13\s*pc\b|\b13pc\b|\b14\s*pc\b|\b14pc\b|\b9\s*pc\b|\b9pc\b|\b8\s*pc\b|\b8pc\b/g,' ')
    .replace(/\bkit\b|\bbundle\b|\bsingle\b/g,' ')
    .replace(/\+/g,' plus ')
    .replace(/[^a-z0-9]+/g,'');
}
function gripProfileTypeKey(s){
  if(!s)return 'club';
  if(String(s.type||'').toLowerCase()==='putter')return 'putter';
  if(/putter/i.test(String(s.category||s.grip_category||s.gripCategory||'')))return 'putter';
  return 'club';
}
function normalizeGripProfileBrandKey(v){
  return String(v||'').toLowerCase().replace(/[^a-z0-9]+/g,'');
}
function gripProfileModelKey(brand,model,type){
  return normalizeGripProfileBrandKey(normBrandName(brand))+'|'+(type||'club')+'|'+normalizeGripProfileKeyPart(model);
}
function mappedProfileFromKey(key){
  var map=window.GRIP_PROFILE_MAP||window.GRIP_PLAYER_PROFILE_MAP||null;
  if(!map||!map.models||!key)return null;
  var row=map.models[key];
  if(!row)return null;
  var secs=row.secondaryProfiles||row.secondary_profiles||[];
  if(typeof secs==='string')secs=secs.split(/[;,|]/).map(function(x){return x.trim();}).filter(Boolean);
  return {
    primaryProfile:row.primaryProfile||row.primary_profile||row.primary_player_profile,
    secondaryProfiles:secs,
    allProfileScores:{},
    confidenceScore:row.confidenceScore||row.confidence_score||null,
    profileReasoning:row.reasoning||'',
    profileSource:'exact-map',
    profileMapKey:key
  };
}
function getMappedGripProfiles(s){
  s=s||{};
  var map=window.GRIP_PROFILE_MAP||window.GRIP_PLAYER_PROFILE_MAP||null;
  if(!map||!map.models)return null;

  var handles=[];
  var directHandle=getProductHandleFromSpec(s);
  if(directHandle)handles.push(directHandle);
  (s.variants||[]).forEach(function(v){
    if(!v)return;
    var h=v.handle||getProductHandleFromUrl(v.url||'');
    if(h)handles.push(h);
  });

  if(map.handles){
    for(var i=0;i<handles.length;i++){
      var hk=map.handles[handles[i]];
      var byHandle=mappedProfileFromKey(hk);
      if(byHandle)return byHandle;
    }
  }

  var type=gripProfileTypeKey(s);
  var candidates=[
    s.model,
    s.display_name,
    s.displayName,
    s.product_title,
    s.productTitle,
    s.title,
    s.name
  ].filter(Boolean);

  for(var j=0;j<candidates.length;j++){
    var key=gripProfileModelKey(s.brand,candidates[j],type);
    var byModel=mappedProfileFromKey(key);
    if(byModel)return byModel;
  }

  return null;
}

function addProductProfile(scores,profile,points){addProfileScore(scores,profile,points);}
function inferGripProfiles(s){
  s=s||{};
  if(s.primaryProfile||s.primary_profile||s.primary_player_profile){
    var primary=s.primaryProfile||s.primary_profile||s.primary_player_profile;
    var secs=s.secondaryProfiles||s.secondary_profiles||s.secondary_player_profiles||[];
    if(typeof secs==='string')secs=secs.split(/[;,|]/).map(function(x){return x.trim();}).filter(Boolean);
    return {primaryProfile:primary,secondaryProfiles:secs,allProfileScores:{},profileSource:'spec-fields'};
  }

  var mapped=getMappedGripProfiles(s);
  if(mapped&&mapped.primaryProfile)return mapped;

  var scores=profileScoreBlank();
  /* 2026-07-09: s.source_tags intentionally excluded here. It is a raw Shopify
     merchandising/collection tag string, not a curated spec field, and it has
     repeatedly produced false-positive matches (e.g. "ribbed-reminder-golf-grips"
     falsely tagging round-alignment grips as alignment-reminder products; "blue
     star"/"green star" size tags on Golf Pride PRO Only falsely tagging an
     all-black grip as Style/Color). Only curated fields + the actual product
     name are trusted for profile inference now. */
  var isPutter=s.type==='putter';
  /* Club records occasionally inherit putter-only fields from imperfect source
     rows. Never let putter_shape or putter_size influence a swing-grip profile;
     those fields are considered only for actual putter grips. */
  var profileTextParts=[s.brand,s.model,s.display_name,s.displayName,s.product_title,s.productTitle,s.title,s.name,s.material,s.texture,s.weather,s.alignment,s.tack];
  if(isPutter)profileTextParts.push(s.putter_shape,s.putter_size);
  var text=profileTextParts.filter(Boolean).join(' ').toLowerCase();
  var brand=normBrandName(s.brand);
  /* 2026-07-09: shopify_description is real per-model Shopify product copy —
     NOT a shared merchandising/collection tag like source_tags, so it does not
     carry the same false-positive risk. Still kept as its own variable and
     matched only on explicit, low-ambiguity phrases (never a bare word like
     "soft" that appears in nearly every description) so it stays additive
     rather than re-deriving what the curated fields above already give us. */
  var descText=(s.shopify_description||'').toLowerCase();

  if(isPutter){
    if(/flatso|flat|pistol|pro\s*only|reverse\s*taper|gravity|solution|wristlock|armlock|claw|lock|tour|1\.0pt/.test(text))addProductProfile(scores,'Control / Shotmaker Player',5);
    if(/oversize|jumbo|3\.0|4\.0|5\.0|fatso|big\s*boy|xl|long|17\s*(?:"|”|in\b)|21\s*(?:"|”|in\b)|counter\s*balance|counterbalance|wristlock|armlock|tank|snug|2thumb|palmbird/.test(text))addProductProfile(scores,'Oversize / Reduced Grip Pressure Player',6);
    if(/soft|snsr|winn|excel|polymer|polyurethane|tacky|sticky|medallist|ntp/.test(text))addProductProfile(scores,'Maximum Comfort Player',4);
    if(/arthritis|arthritic|pain|soft|winn|excel|oversize|jumbo/.test(text))addProductProfile(scores,'Arthritis / Joint Pain Player',2);
    if(/traxion|zenergy|tacky|sticky|tak/.test(text))addProductProfile(scores,'High-Traction Player',3);
    if(/special|limited|camo|flag|usa|mexico|good\s*good|darth|vader|star\s*wars|marvel|army|color|pink|red|blue|green|white|black/.test(text)||brand==='Iomic')addProductProfile(scores,'Style / Color-Matching Player',5);
    if(/tour\s*classic|velvet|medallist|rd2|rd3|rd5/.test(text))addProductProfile(scores,'Value / Regrip Set Player',2);
    if(/standard|slim|tour\s*classic|medallist/.test(text))addProductProfile(scores,'Beginner / Casual Player',2);
  }else{
    if(/cord|corded|full\s*cord|z[-\s]*grip|dtx|sidewinder|stx|aggressive|grid|s-tech\s*cord|revl\s*player\s*cord/.test(text)){
      addProductProfile(scores,'High-Traction Player',6);
      addProductProfile(scores,'Humid / Sweaty Hands Player',4);
      addProductProfile(scores,'All-Weather Player',2);
    }
    if(/all[-\s]*weather|wet|rain|weather|element|revl\s*element|vdr/.test(text)){
      addProductProfile(scores,'All-Weather Player',5);
      addProductProfile(scores,'High-Traction Player',3);
    }
    if(/sticky|tacky|iomic|pure|lizard|winndry|dri[-\s]*tac|d2r|high\s*tack|traxion/.test(text)){
      addProductProfile(scores,'High-Traction Player',3);
      addProductProfile(scores,'Humid / Sweaty Hands Player',2);
    }
    if(/soft|comfort|cpx|cp2|dri[-\s]*tac|excel|chamois|arthritic|serrated|wrap|polymer|elastomer|polyurethane|shock|dampening|soft\s*wrap/.test(text)){
      addProductProfile(scores,'Maximum Comfort Player',5);
    }
    if(/arthritic|arthritis|serrated|chamois|dri[-\s]*tac|excel|cpx|cp2|winn|jumbo|oversize/.test(text)){
      addProductProfile(scores,'Arthritis / Joint Pain Player',3);
    }
    /* Explicit description phrase match. Catches unmapped models whose brand/
       model text alone gives no signal (e.g. "Tacki-Mac Itomic Wrap Black
       Jumbo" — model field truncated to "Tacki" in this export, but its
       description literally says "Soft arthritic-relieving") — these products
       are Arthritis/Joint Pain-relevant but were invisible to the checks
       above. Weighted higher than the generic word list since it is a much
       more specific claim than "soft" or "jumbo" alone. */
    if(/arthrit/i.test(descText)){
      addProductProfile(scores,'Arthritis / Joint Pain Player',6);
    }
    /* All-Weather Player was previously unreachable as a primary profile on
       the club track (0% of answer combos, per 2026-07-08 diagnosis) partly
       because no catalog text besides "all-weather"/"wet"/"rain" fed it.
       Descriptions add a second, independent phrase for the same claim. */
    if(/water[-\s]*resist/i.test(descText)){
      addProductProfile(scores,'All-Weather Player',5);
      addProductProfile(scores,'High-Traction Player',2);
    }
    if(/non-?slip|high\s*traction/i.test(descText)){
      addProductProfile(scores,'High-Traction Player',3);
    }
    if(/jumbo|max|jumbomax|oversize|midsize|plus4|plus\s*4|reduced\s*taper|less\s*taper|lt\b|no[-\s]*taper|str8|zenlite|ultralite|wrap\s*series/.test(text)){
      addProductProfile(scores,'Oversize / Reduced Grip Pressure Player',6);
    }
    if(/align|max\s*z|calibrate|reminder|ribbed|firm|tour\s*velvet|z[-\s]*grip|s-tech|revl\s*player|x-grip|ixx|tour\s*25|pro\b/.test(text)){
      addProductProfile(scores,'Control / Shotmaker Player',5);
    }
    if(/special|limited|team|teams|camo|opus|patriot|patriotic|honorary|starter|good\s*good|liberty|loudmouth|shagadelic|argyle|thunderbolt|flag|shamrock|marvel|star\s*wars|disney|color|pink|red|blue|green|white|black/.test(text)||brand==='Iomic'){
      addProductProfile(scores,'Style / Color-Matching Player',5);
    }
    if(/karma|velour|tacki|tacki-mac|star\s*grip|classic\s*wrap|tour\s*velvet|crossline|bubble|pro\s*lite|value|kit|bundle/.test(text)){
      addProductProfile(scores,'Value / Regrip Set Player',4);
      addProductProfile(scores,'Beginner / Casual Player',2);
    }
    if(/tour\s*velvet|velour|cross\s*comfort|s-tech|revl\b|standard|smooth|rubber|beginner|training/.test(text)){
      addProductProfile(scores,'Beginner / Casual Player',3);
    }
  }

  var summary=profileSummary(scores);
  return {primaryProfile:summary.primaryProfile,secondaryProfiles:[summary.secondaryProfile],allProfileScores:scores};
}
function profileMatchBoost(s,customerProfiles,why){
  customerProfiles=customerProfiles||getCustomerProfiles(ans);
  var product=inferGripProfiles(s);
  var boost=0,matched=[];
  var secs=product.secondaryProfiles||[];
  if(product.primaryProfile===customerProfiles.primaryProfile){boost+=28;matched.push(customerProfiles.primaryProfile);}
  if(secs.indexOf(customerProfiles.primaryProfile)>=0){boost+=18;matched.push(customerProfiles.primaryProfile);}
  if(product.primaryProfile===customerProfiles.secondaryProfile){boost+=16;matched.push(customerProfiles.secondaryProfile);}
  if(secs.indexOf(customerProfiles.secondaryProfile)>=0){boost+=10;matched.push(customerProfiles.secondaryProfile);}
  if(boost>0&&why&&matched.length){
    var m=matched[0].replace(/ Player$/,'').toLowerCase();
    if(why.indexOf('This model also matches your '+m+' profile from the quiz')===-1)why.push('This model also matches your '+m+' profile from the quiz');
  }
  return boost;
}
function preferredBrandBoost(s,customerProfiles,baseScore){
  customerProfiles=customerProfiles||getCustomerProfiles(ans);
  if(baseScore<45)return 0;
  var brand=normBrandName(s&&s.brand);
  var primary=customerProfiles.primaryProfile, secondary=customerProfiles.secondaryProfile;
  var boost=0;

  if(brand==='Golf Pride'||brand==='Iomic'||brand==='JumboMax'||brand==='SuperStroke')boost+=5;

  if(brand==='Golf Pride'&&(
    primary==='Control / Shotmaker Player'||primary==='High-Traction Player'||primary==='Humid / Sweaty Hands Player'||
    secondary==='Control / Shotmaker Player'||secondary==='High-Traction Player'||secondary==='Humid / Sweaty Hands Player'))boost+=4;
  if(brand==='Iomic'&&(
    primary==='Style / Color-Matching Player'||primary==='Humid / Sweaty Hands Player'||primary==='High-Traction Player'||
    secondary==='Style / Color-Matching Player'))boost+=4;
  if(brand==='JumboMax'&&(
    primary==='Oversize / Reduced Grip Pressure Player'||primary==='Arthritis / Joint Pain Player'||
    secondary==='Oversize / Reduced Grip Pressure Player'))boost+=6;
  if(brand==='SuperStroke'){
    if(s&&s.type==='putter')boost+=8;
    if(primary==='Maximum Comfort Player'||primary==='Control / Shotmaker Player'||primary==='High-Traction Player'||primary==='All-Weather Player'||secondary==='Control / Shotmaker Player')boost+=4;
  }

  return Math.min(boost,14);
}

/* ================================================================== *
 *  DESCRIPTION-TEXT SIGNALS  (added 2026-07-09)
 *  Mines s.shopify_description (real, per-model Shopify product copy, NOT a
 *  shared merchandising tag) for a short whitelist of high-confidence phrases
 *  that the curated spec fields (feel/texture/material/weather/tack) do not
 *  already capture. Verified against the full 649-model catalog before
 *  picking these five phrases specifically because each one is common enough
 *  to matter and, in most cases, NOT already implied by an existing curated
 *  field:
 *    - "water resistan(t/ce)"      15 models mention it, 7 not already
 *                                  tagged weather=all-weather
 *    - "reduced torque"/"low torque"  4 models, 0 overlap with any curated field
 *    - "reduced taper"/"less taper"/"no taper"  29 models — a tighter phrase
 *                                  match than the existing bare "reduced"
 *                                  check against model+material text
 *    - "non-slip"/"high traction"  24 models, all NOT already texture=corded
 *    - "shock absorb(ing/tion)"/"air-cushion(ed)"  9 models (mostly already
 *                                  feel=soft — kept as a minor confirmatory
 *                                  bonus, not a primary signal)
 *  Deliberately excludes generic single words ("soft", "comfort", "firm")
 *  that appear in most descriptions regardless of the product — those would
 *  just re-derive signal the curated fields already provide and dilute this
 *  into noise, the same failure mode that caused the 2026-07-08 "ribbed"
 *  false-positive bug. Kept as its own function, called once per product,
 *  bounded to a small total so it can only act as a tie-breaker within the
 *  existing spec-fit layer — never large enough to override a real curated-
 *  field mismatch (compare to the 55-pt size match or 55-pt alignment bonus
 *  in scoreClub, an order of magnitude larger). */
function descriptionSignals(s){
  var d=(s&&s.shopify_description)||'';
  return {
    waterResistant:/water[-\s]*resist/i.test(d),
    reducedTorque:/reduced[-\s]*torque|low[-\s]*torque/i.test(d),
    reducedTaper:/reduced[-\s]*taper|less[-\s]*taper|no[-\s]*taper/i.test(d),
    highTraction:/non-?slip|high\s*traction/i.test(d),
    shockAbsorbing:/shock.?absorb|air.?cushion/i.test(d)
  };
}
function descriptionBoost(s,a,why){
  if(!s||!s.shopify_description)return 0;
  var sig=descriptionSignals(s);
  var pts=0;
  function addWhy(msg){ if(why&&msg&&why.indexOf(msg)===-1)why.push(msg); }

  if(s.type==='putter'){
    /* Putter descriptions almost never carry these phrases (verified: 0/222
       for torque/shock-absorb/arthritis, only a handful for water-resist/
       traction) — no dedicated putter answer maps to them today either.
       Left as a no-op scaffold rather than removed, so a future wet-weather
       or comfort putter question can wire in without re-deriving this. */
    return 0;
  }

  if(a.sweat==='wet'&&sig.waterResistant){
    pts+=10;
    addWhy('The product description specifically calls out water resistance, which matters for the wet conditions you mentioned');
  }
  if((a.pressure==='tight'||a.priority==='control')&&sig.reducedTorque){
    pts+=8;
    addWhy('This grip is described as reduced/low torque, which helps with control and consistency under grip pressure');
  }
  if((a.pressure==='tight'||a.priority==='size')&&sig.reducedTaper){
    pts+=8;
    addWhy('The reduced-taper construction described for this grip can ease pressure in your lower hand');
  }
  if((a.priority==='traction'||a.sweat==='sweaty')&&sig.highTraction){
    pts+=6;
    addWhy('The description highlights a non-slip, high-traction surface that matches your traction priority');
  }
  if(a.comfort==='yes'&&sig.shockAbsorbing){
    pts+=6;
    addWhy('The description calls out shock-absorbing construction, which can help with hand or wrist strain');
  }

  return Math.min(pts,24);
}

/* Style / color merchandising layer.
   The profile map can correctly mark a grip family as style-friendly, but the
   old formatter still picked the cheapest/live variant inside that family —
   often a plain black grip. When the golfer says color/style is the priority,
   these helpers do two things:
   1) rank style/color-forward grip families higher, and
   2) pick the most color/style-forward live variant within the chosen family. */
var GQ_COLOR_WORDS=['red','blue','green','orange','yellow','gold','silver','pink','purple','violet','navy','teal','aqua','lime','copper','brown','tan','ivory','white','grey','gray','black'];
var GQ_NON_BLACK_COLORS=['red','blue','green','orange','yellow','gold','silver','pink','purple','violet','navy','teal','aqua','lime','copper','brown','tan','ivory','white','grey','gray'];
var GQ_STYLE_KEYWORD_RE=/special|limited|team|teams|camo|opus|patriot|patriotic|honorary|starter|good\s*good|liberty|loudmouth|shagadelic|argyle|thunderbolt|flag|shamrock|marvel|star\s*wars|disney|darth|vader|hulk|iron[\s-]?man|spider[\s-]?man|captain\s*america|black\s*panther|army|mexico|usa|colorway|multi[-\s]?color|two[-\s]?tone/i;
function stylePriorityActive(a,customerProfiles){
  customerProfiles=customerProfiles||getCustomerProfiles(a||ans);
  return !!(
    (a&&a.priority==='style')||(a&&a.musthave==='style')||(a&&a.ppriority==='style')||
    customerProfiles.primaryProfile==='Style / Color-Matching Player'||
    customerProfiles.secondaryProfile==='Style / Color-Matching Player'
  );
}
function textForStyleScan(s,v){
  var parts=[];
  if(s)parts.push(gripSearchText(s));
  if(v)parts.push(v.title,v.name,v.option1,v.option2,v.option3,v.color,v.colour,v.variant_title,v.variantTitle,v.sku,v.url);
  return parts.filter(Boolean).join(' ').toLowerCase();
}
function colorWordsInText(text){
  var found={};
  GQ_COLOR_WORDS.forEach(function(c){
    var re=new RegExp('(?:^|[^a-z])'+c+'(?:[^a-z]|$)','i');
    if(re.test(text))found[c]=1;
  });
  return Object.keys(found);
}

/* Exact Shopify variant mappings are embedded in grip-specs.js by handle.
   Unlike the legacy colors[] summary, each item below identifies one real
   Shopify variant ID, its selected options, availability, price, color, and
   canonical size. Color buttons must be built from these mappings whenever
   they exist so two labels can never point to the same guessed variant. */
function embeddedShopifyVariants(v){
  v=v||{};
  var raw=Array.isArray(v.shopify_variants)?v.shopify_variants:[];
  var allowed=Array.isArray(v.size)?v.size.filter(function(x){return x&&x!=='Unspecified';}):[];
  var list=raw.map(function(x){
    x=x||{};
    var id=String(x.id||variantIdFromGid(x.gid)||'');
    var selected=x.selected_options||x.selectedOptions||{};
    var color=String(x.color||selected.Color||selected.Colour||'').trim();
    var size=String(x.size||'').trim();
    var price=x.price==null?null:Number(x.price);
    return {
      id:id,
      gid:String(x.gid||''),
      sku:String(x.sku||''),
      color:color,
      size:size,
      selected_options:selected,
      available:x.available!==false,
      price:isNaN(price)?null:price,
      compareAt:x.compareAt==null?null:Number(x.compareAt),
      url:x.url||''
    };
  }).filter(function(x){return !!x.id;});
  if(allowed.length){
    var sized=list.filter(function(x){return !x.size||allowed.indexOf(x.size)>=0;});
    if(sized.length)list=sized;
  }
  return list;
}
function exactShopifyVariantsForEntry(v){
  var live=(v&&v._gqExactShopifyVariants)||embeddedShopifyVariants(v);
  return (live||[]).filter(function(x){return x&&x.id&&x.available!==false;});
}
/* 2026-07-22 fix: colors used to come ONLY from grip-specs.js shopify_variants.
   Live variants were fetched, used to validate the cached list, and then thrown
   away — so a product whose cached entry had 1 (or 0) embedded variants showed
   1 (or 0) colors no matter how many colors the live Shopify product actually
   had. That is the "product page has 8 colors, recommendation card shows none"
   bug. The live store now contributes colors directly.

   Reads a color label straight off a live variant descriptor. Storefront
   descriptors carry selectedOptions (Color/Colour); the /products/{handle}.js
   descriptors only carry a flat options array + title, so fall back to the
   option value / title that actually reads like a color or a design name. */
function liveDescriptorSizeValue(d){
  var sel=(d&&d.selectedOptions)||{};
  return String(sel.Size||sel.size||'').trim();
}
function liveDescriptorColorLabel(d){
  if(!d)return '';
  var sel=d.selectedOptions||{};
  var direct=String(sel.Color||sel.Colour||sel.color||sel.colour||'').trim();
  if(direct)return direct;
  /* No named Color option: pick the first option value that looks like a color
     or a design name and is not a size. Then fall back to the variant title. */
  var opts=(d.options||[]).map(function(x){return String(x||'').trim();}).filter(Boolean);
  var sizeVal=liveDescriptorSizeValue(d).toLowerCase();
  for(var i=0;i<opts.length;i++){
    var o=opts[i],lo=o.toLowerCase();
    if(lo===sizeVal)continue;
    if(/^(standard|undersize|midsize|jumbo|oversize|ladies|junior|large|small|medium|xl|x-?large)$/i.test(o))continue;
    if(colorWordsInText(lo).length||GQ_STYLE_KEYWORD_RE.test(lo))return o;
  }
  var title=String(d.title||'').trim();
  if(title&&!/^default title$/i.test(title)){
    if(colorWordsInText(title.toLowerCase()).length||GQ_STYLE_KEYWORD_RE.test(title))return title;
  }
  return '';
}
/* Live variants on this entry's handle that are in stock, match the entry's
   size, and carry a usable color label. */
function liveColorVariantsForEntry(v){
  var descriptors=((v&&v._gqLiveVariants)||[]).filter(function(d){return d&&d.id&&d.available!==false;});
  if(!descriptors.length)return [];
  var allowed=Array.isArray(v&&v.size)?v.size.filter(function(x){return x&&x!=='Unspecified';}):[];
  var out=[];
  descriptors.forEach(function(d){
    var label=liveDescriptorColorLabel(d);
    if(!label)return;
    /* Never surface a color that only exists in a size the golfer was not
       recommended. When the live variant has no size option at all, the whole
       product page is that size, so it is safe to keep. */
    var size=liveDescriptorSizeValue(d);
    if(allowed.length&&size&&allowed.indexOf(size)<0)return;
    out.push({
      id:String(d.id),
      color:label,
      size:size,
      selected_options:d.selectedOptions||{},
      available:true,
      price:d.price!=null?d.price:null,
      compareAt:d.compareAt!=null?d.compareAt:null
    });
  });
  return out;
}
/* Union of cached-and-still-available colors with live colors, deduped by
   canonical color key and by variant id. Cached entries still have to survive
   the live availability reconcile, so a sold-out cached color cannot sneak back
   in through this union. Cached labels win on ties because they are the curated,
   human-readable names ("Black / White Cap" rather than "BLK-WHT"). */
function exactColorVariantsForEntry(v){
  var cached=exactShopifyVariantsForEntry(v).filter(function(x){return !!String(x.color||'').trim();});
  var live=liveColorVariantsForEntry(v);
  var out=[],seenId={},seenKey={};
  function push(x){
    var id=String(x&&x.id||'');
    if(!id||seenId[id])return;
    var key=canonicalColorKey(x.color)||String(x.color||'').toLowerCase();
    if(!key||seenKey[key])return;
    seenId[id]=1;seenKey[key]=1;
    out.push(x);
  }
  cached.forEach(push);
  live.forEach(push);
  if(out.length)return out;
  return liveInferredColorVariantsForEntry(v);
}


function legacyVariantColorLabels(v){
  v=v||{};
  var raw=[];
  if(Array.isArray(v.colors))raw=raw.concat(v.colors);
  else if(v.colors)raw.push(v.colors);
  [v.color,v.colour,v.option1,v.option2,v.option3,v.title,v.variant_title,v.variantTitle].forEach(function(x){if(x)raw.push(x);});
  var labels=[];
  raw.forEach(function(x){
    var label=String(x||'').replace(/[_]+/g,' ').replace(/\s+/g,' ').trim();
    if(!label)return;
    label=label.replace(/\b(?:grip|single|bundle|kit|junior|ladies|undersize|standard|midsize|oversize|jumbo|small|medium|large|x-?large|xl|size)\b/ig,' ')
      .replace(/^\s*[\/-]+|[\/-]+\s*$/g,'').replace(/\s+/g,' ').trim();
    if(!label)return;
    var lower=label.toLowerCase();
    var hasColor=colorWordsInText(lower).length>0;
    var hasDesign=GQ_STYLE_KEYWORD_RE.test(lower)||/camo|army|topograph|gaucho|guacho|shamrock|team|usa|marvel|star wars|darth|hulk|spider|iron man|flag|pattern|print/i.test(lower);
    if(!hasColor&&!hasDesign)return;
    if(labels.map(function(z){return z.toLowerCase();}).indexOf(lower)<0)labels.push(label);
  });
  if(!labels.length){
    var url=String(v.url||'').replace(/[-_]+/g,' ');
    var colors=colorWordsInText(url);
    if(colors.length)labels.push(colors.map(function(c){return c.charAt(0).toUpperCase()+c.slice(1);}).join(' / '));
    else if(GQ_STYLE_KEYWORD_RE.test(url))labels.push('Special design');
  }
  return labels;
}
function liveInferredColorVariantsForEntry(v){
  var descriptors=((v&&v._gqLiveVariants)||[]).filter(function(d){return d&&d.id&&d.available!==false;});
  var labels=legacyVariantColorLabels(v);
  if(!descriptors.length||!labels.length)return [];
  var pairs=[];
  labels.forEach(function(label){
    descriptors.forEach(function(d){
      var score=liveVariantMatchScore(d,v,label);
      if(score>=40)pairs.push({label:label,d:d,score:score});
    });
  });
  pairs.sort(function(a,b){return b.score-a.score;});
  var usedLabels={},usedIds={},out=[];
  pairs.forEach(function(p){
    var lk=canonicalColorKey(p.label)||String(p.label).toLowerCase(),id=String(p.d.id);
    if(usedLabels[lk]||usedIds[id])return;
    usedLabels[lk]=1;usedIds[id]=1;
    out.push({id:id,color:p.label,size:'',available:true,price:p.d.price,compareAt:p.d.compareAt,selected_options:p.d.selectedOptions||{}});
  });
  /* A single-color page with one live variant is safe even when the title does
     not repeat the color. Never apply this shortcut when several color labels
     compete for the same destination. */
  if(!out.length&&labels.length===1&&descriptors.length===1){
    var d=descriptors[0];out.push({id:String(d.id),color:labels[0],size:'',available:true,price:d.price,compareAt:d.compareAt,selected_options:d.selectedOptions||{}});
  }
  return out;
}

function meaningfulVariantColorLabels(v){
  v=v||{};
  var embedded=exactShopifyVariantsForEntry(v).filter(function(x){return !!String(x.color||'').trim();});
  var exactLabels=[],seen={};
  embedded.forEach(function(x){var label=String(x.color||'').replace(/\s+/g,' ').trim(),key=label.toLowerCase();if(label&&!seen[key]){seen[key]=1;exactLabels.push(label);}});
  if(exactLabels.length)return exactLabels;
  return legacyVariantColorLabels(v);
}
function meaningfulColorLabelsForSpec(s,target){
  var out={},variants=(s&&s.variants)||[];
  variants.forEach(function(v){
    var sizes=Array.isArray(v.size)?v.size:[];
    if(target&&sizes.length&&sizes.indexOf(target)<0&&sizes.indexOf('Unspecified')<0)return;
    meaningfulVariantColorLabels(v).forEach(function(label){out[label.toLowerCase()]=label;});
  });
  return Object.keys(out).map(function(k){return out[k];});
}
function gripStyleInfo(s,target){
  var text=textForStyleScan(s,null);
  var colors=colorWordsInText(text),set={};
  colors.forEach(function(c){set[c]=1;});
  meaningfulColorLabelsForSpec(s,target).forEach(function(label){
    colorWordsInText(label.toLowerCase()).forEach(function(c){set[c]=1;});
  });
  colors=Object.keys(set);
  var nonBlack=colors.filter(function(c){return c!=='black';});
  var level=String((s&&s.style_level)||(s&&s.styleLevel)||'').toLowerCase();
  var curatedCount=Number(s&&s.non_black_color_count!=null?s.non_black_color_count:(s&&s.nonBlackColorCount))||0;
  var optionLabels=meaningfulColorLabelsForSpec(s,target);
  return {
    colors:colors,
    nonBlackColors:nonBlack,
    optionLabels:optionLabels,
    liveLikeColorCount:optionLabels.length,
    curatedNonBlackCount:curatedCount,
    styleLevel:level,
    styleKeyword:GQ_STYLE_KEYWORD_RE.test(text),
    blackOnly:(colors.length===1&&colors[0]==='black'),
    noColorInfo:(colors.length===0&&optionLabels.length===0)
  };
}
function mappedStyleProfileMatch(s){
  var p=inferGripProfiles(s)||{},secs=p.secondaryProfiles||[];
  return p.primaryProfile==='Style / Color-Matching Player'||secs.indexOf('Style / Color-Matching Player')>=0;
}
function styleMerchandisingScore(s,target){
  if(!s)return 0;
  var info=gripStyleInfo(s,target),pts=0;
  var targetOptionCount=info.optionLabels.length;
  if(info.styleLevel==='special_edition')pts+=72;
  else if(info.styleLevel==='style_forward')pts+=target&&targetOptionCount===0?14:58;
  else if(info.styleLevel==='multiple_colors')pts+=target&&targetOptionCount===0?0:24;
  else if(info.styleLevel==='basic')pts+=0;

  /* When scoring a specific recommended size, count only colors/designs that
     actually exist in that size. Family-wide color counts can otherwise make
     a pink Undersize page qualify a Midsize recommendation as style-forward. */
  var count=target?Math.max(info.nonBlackColors.length,targetOptionCount):Math.max(info.curatedNonBlackCount,info.nonBlackColors.length,targetOptionCount);
  pts+=Math.min(count,8)*5;
  if(info.styleKeyword)pts+=24;
  if(mappedStyleProfileMatch(s))pts+=8;
  if(info.blackOnly&&!info.styleKeyword&&info.styleLevel!=='special_edition')pts-=28;
  if(info.noColorInfo&&info.styleLevel!=='special_edition'&&(!target||targetOptionCount===0))pts-=20;
  return Math.max(-40,Math.min(130,pts));
}
/* Putter style priority uses the verified colors available in the golfer's
   selected size, rather than the family-wide color rollup. This is deliberately
   putter-only so club-style rankings remain unchanged. A distinctive one-color
   special edition can still score strongly; an ordinary one-color style-forward
   family no longer receives the same merchandising credit as three or more real
   choices in that size. */
function putterStyleTargetForSpec(s,a){
  if(!s||s.type!=='putter')return null;
  var explicit=putterTargetSize(a||{});
  if(explicit)return explicit;
  var cls=putterSizeClass(s.putter_size);
  return {standard:'Standard',midsize:'Midsize',oversize:'Jumbo/Oversize'}[cls]||null;
}
function putterSizeAwareStyleScore(s,a){
  if(!s||s.type!=='putter')return styleMerchandisingScore(s,null);
  var target=putterStyleTargetForSpec(s,a);
  if(!target)return styleMerchandisingScore(s,null);
  var labels=meaningfulColorLabelsForSpec(s,target);
  var optionCount=labels.length;
  var text=textForStyleScan(s,null);
  var level=String((s&&s.style_level)||(s&&s.styleLevel)||'').toLowerCase();
  var design=GQ_STYLE_KEYWORD_RE.test(text);
  var mapped=mappedStyleProfileMatch(s);
  var pts=0;

  if(level==='special_edition')pts+=72;
  else if(level==='style_forward'){
    if(optionCount===0)pts+=8;
    else if(optionCount===1)pts+=26;
    else if(optionCount===2)pts+=44;
    else pts+=60;
  }else if(level==='multiple_colors'){
    if(optionCount===1)pts+=10;
    else if(optionCount===2)pts+=24;
    else if(optionCount>=3)pts+=36;
  }

  /* The first color proves the item is available in the size. Additional
     verified choices are what create extra value for a style-first shopper. */
  if(optionCount>=2)pts+=Math.min(optionCount,8)*5;
  if(optionCount===2)pts+=8;
  else if(optionCount>=3)pts+=18;
  if(optionCount===1&&level==='style_forward'&&!design)pts-=8;
  if(design)pts+=24;
  if(mapped)pts+=8;
  if(optionCount===0&&level!=='special_edition'&&!design)pts-=20;
  return Math.max(-40,Math.min(130,pts));
}
function styleColorBoost(s,a,customerProfiles,why,target){
  if(!stylePriorityActive(a,customerProfiles))return 0;
  var explicitPutterStyle=!!(s&&s.type==='putter'&&a&&a.ppriority==='style');
  var quality=explicitPutterStyle?putterSizeAwareStyleScore(s,a):styleMerchandisingScore(s,target);
  var boost=Math.round(quality*0.55);
  if(a&&a.priority==='style')boost+=Math.round(quality*0.20);
  if(a&&a.musthave==='style')boost+=Math.round(quality*0.25);
  if(boost>0&&why){
    var msg='This model better fits your color and style priority';
    if(why.indexOf(msg)===-1)why.push(msg);
  }
  return Math.max(-60,Math.min(120,boost));
}

function isPutterStyleColorCandidate(s,a,customerProfiles){
  if(!stylePriorityActive(a,customerProfiles))return true;
  if(!s||s.type!=='putter')return true;
  var pts=(a&&a.ppriority==='style')?putterSizeAwareStyleScore(s,a):styleMerchandisingScore(s);
  return pts>20;
}

function putterStyleColorPreferenceScore(s,a,customerProfiles,why){
  if(!stylePriorityActive(a,customerProfiles)||!s||s.type!=='putter')return 0;
  var pts=(a&&a.ppriority==='style')?putterSizeAwareStyleScore(s,a):styleMerchandisingScore(s);
  if(a&&a.ppriority==='style')pts+=Math.round(pts*0.40);
  if(!isPutterStyleColorCandidate(s,a,customerProfiles))pts-=95;
  if(pts>0&&why){
    var msg='This model better fits your color and style priority';
    if(why.indexOf(msg)===-1)why.push(msg);
  }
  return Math.max(-95,Math.min(150,pts));
}

function variantStyleScore(v,s){
  var labels=meaningfulVariantColorLabels(v);
  var text=textForStyleScan(s,v);
  var score=0;
  if(GQ_STYLE_KEYWORD_RE.test(text))score+=35;
  if(labels.length>=3)score+=34;
  else if(labels.length===2)score+=26;
  else if(labels.length===1)score+=18;
  var colors=colorWordsInText(labels.join(' ').toLowerCase());
  if(colors.length===1&&colors[0]==='black'&&!GQ_STYLE_KEYWORD_RE.test(text))score-=22;
  return score;
}
function preferVariantCandidate(candidate,current,spec,preferStyle){
  if(!current)return true;
  if(preferStyle){
    var cs=variantStyleScore(candidate,spec),os=variantStyleScore(current,spec);
    if(cs!==os)return cs>os;
  }
  var cp=(candidate&&candidate.price!=null)?Number(candidate.price):1e9;
  var op=(current&&current.price!=null)?Number(current.price):1e9;
  return cp<op;
}


/* Putter specialty guard.
   The current quiz never asks whether the golfer uses an arm-lock, wrist-lock,
   long, or counterbalanced putter. Those products are therefore not safe
   substitutes for an ordinary putter grip, even when the customer asks for
   stability, oversize, or heavy weight. Future versions can expose a dedicated
   pbuild answer and the allow-list below will support it without another
   scoring rewrite. */
function putterSpecialtyType(s){
  if(!s||s.type!=='putter')return '';
  var text=gripSearchText(s).toLowerCase();
  var sizeClass=String(s.putter_size_class||s.putterSizeClass||'').toLowerCase();
  var sizes=(s.sizes_available||[]).map(function(x){return String(x).toLowerCase();});
  if(/arm\s*lock|armlock/.test(text))return 'armlock';
  if(/wrist\s*lock|wristlock/.test(text))return 'wristlock';
  if(/counter\s*balance|counterbalance/.test(text))return 'counterbalance';
  if(/2thumb|two\s*thumb/.test(text))return 'twothumb';
  if(/\bclaw\b/.test(text))return 'claw';
  if(sizeClass==='long'||sizes.indexOf('long')>=0||/\bxl\+|\b(?:1[3-9](?:\.\d+)?|2\d(?:\.\d+)?|3\d(?:\.\d+)?)\s*(?:\"|”|in\b|inch)|\blong\s+putter\b/.test(text))return 'long';
  return '';
}
function putterSpecialtyRequested(a,kind){
  a=a||{};
  var build=String(a.pbuild||a.putter_build||a.putterBuild||'').toLowerCase();
  if(!build)return false;
  if(kind==='armlock')return /arm/.test(build);
  if(kind==='wristlock')return /wrist/.test(build);
  if(kind==='counterbalance')return /counter/.test(build);
  if(kind==='twothumb')return /two|thumb/.test(build);
  if(kind==='claw')return /claw/.test(build);
  if(kind==='long')return /long/.test(build);
  return false;
}
function isUnsupportedSpecialtyPutter(s,a){
  var kind=putterSpecialtyType(s);
  return !!kind&&!putterSpecialtyRequested(a,kind);
}

function specListedUnitPrice(s){
  if(!s)return null;
  var vals=[s.normalized_price_per_grip,s.normalizedPricePerGrip,s.single_price_min,s.singlePriceMin,s.price_min,s.priceMin]
    .map(Number).filter(function(v){return isFinite(v)&&v>0;});
  return vals.length?Math.min.apply(Math,vals):null;
}

/* Value is now price-led rather than brand/model-name-led. This pre-live
   score is intentionally modest; the stronger pool-relative live-price
   adjustment is applied after Shopify availability and current prices are
   confirmed. Familiarity only breaks close ties. */
function putterDefaultValuePreferenceScore(s,a,customerProfiles,why){
  if(!s||s.type!=='putter'||!a)return 0;
  if(stylePriorityActive(a,customerProfiles))return 0;

  var explicitValue=a.ppriority==='value';
  var neutralDefault=!explicitValue&&customerHasProfile(customerProfiles,'Beginner / Casual Player');
  if(!explicitValue&&!neutralDefault)return 0;

  var text=gripSearchText(s).toLowerCase();
  var brand=normBrandName(s&&s.brand);
  var pts=0;

  /* Explicit Best Value is reranked after live prices are confirmed. At this
     pre-live stage, price only helps inexpensive products enter the candidate
     pool; brand familiarity and premium-model recognition are intentionally
     disabled so they cannot fight the later price-led value ranking. */
  if(explicitValue){
    var price=specListedUnitPrice(s);
    if(price!=null){
      if(price<=10)pts+=14;
      else if(price<=15)pts+=11;
      else if(price<=20)pts+=8;
      else if(price<=28)pts+=4;
      else if(price>=45)pts-=6;
      else if(price>=36)pts-=3;
    }
    if(isUnsupportedSpecialtyPutter(s,a))pts-=60;
    if(pts>0&&why){
      var valueMsg='Its lower listed price keeps it in the live Best Value comparison';
      if(why.indexOf(valueMsg)===-1)why.push(valueMsg);
    }
    return Math.max(-60,Math.min(14,pts));
  }

  /* For neutral/default putter paths, a small familiarity preference remains
     useful because the customer did not explicitly ask for price-led ranking. */
  var mainstream=/zenergy\s*(?:tour|pistol)\s*(?:1\.0|2\.0)|traxion\s*(?:flatso|pistol|tour)\s*(?:1\.0|2\.0)|tlt\s*pistol\s*1\.0|golf\s*pride\s*pro\s*only|karma.*velvet|black\s*velvet\s*paddle|winn.*medallist|tour\s*classic|rd[235]\b|pistol\s*1\.0/.test(text);
  if(mainstream)pts+=10;
  if(brand==='Golf Pride'||brand==='Karma'||brand==='Winn'||brand==='SuperStroke')pts+=3;
  if(/pistol|tour\s*2\.0|flatso\s*2\.0|black\s*velvet\s*paddle|medallist/.test(text))pts+=3;
  if(isUnsupportedSpecialtyPutter(s,a))pts-=60;
  if(pts>0&&why){
    var msg='Ranked higher as a familiar, conventional putter-grip option';
    if(why.indexOf(msg)===-1)why.push(msg);
  }
  return Math.max(-60,Math.min(16,pts));
}

/* When a golfer requires a wrap and prioritizes traction, rank wrap grips by
   their actual moisture performance instead of letting a soft, dry-biased
   comfort wrap win on broad profile overlap alone. */
function wrapTractionPreferenceScore(s,a,why){
  if(!s||s.type==='putter'||!a||a.musthave!=='wrap')return 0;
  var active=a.priority==='traction'||a.sweat==='sweaty'||a.sweat==='wet';
  if(!active||!productIsWrap(s))return 0;

  var weather=String(s.weather_performance||s.weatherPerformance||s.weather||'').toLowerCase();
  var tack=String(s.tack_level||s.tackLevel||s.tack||'').toLowerCase();
  var feel=String(s.feel_profile||s.feelProfile||s.feel||'').toLowerCase();
  var text=gripSearchText(s).toLowerCase();
  var pts=0;

  if(/maximum[_\s-]*wet/.test(weather))pts+=36;
  else if(/all[_\s-]*weather/.test(weather))pts+=30;
  else if(/humid|sweat/.test(weather))pts+=24;
  else if(/dry[_\s-]*(?:biased|preferred|only)/.test(weather))pts-=28;

  if(tack==='very_high'||tack==='very high')pts+=12;
  else if(tack==='high')pts+=9;
  else if(tack==='low')pts-=8;

  if(/perforated|serrated|traxion|micro[-\s]*texture|high[-\s]*traction|non[-\s]*slip/.test(text))pts+=10;
  if(a.feel==='firm'){
    if(feel==='firm'||feel==='very_firm'||feel==='very firm')pts+=7;
    else if(feel==='soft'||feel==='very_soft'||feel==='very soft')pts-=7;
  }

  if(pts>0&&why){
    var msg='Ranked higher among wrap grips because its texture and moisture performance better match your traction goal';
    if(why.indexOf(msg)===-1)why.push(msg);
  }
  return Math.max(-35,Math.min(48,pts));
}


/* Novelty / special-edition / licensed grips (Marvel, Star Wars, team-logo, etc.).
   These carry the same specs as their standard twin, so without a penalty they tie
   and can surface at the top. Down-rank them so the plain grip leads; they can still
   appear as alternates. Keyword list is intentionally conservative — review before publish. */
var NOVELTY_RE=/special edition|limited edition|collector|camo|pink\s*\/\s*white|red\s*\/\s*white\s*\/\s*blue|off\s*the\s*truck|patriotic|stars?\s*and\s*stripes|marvel|star\s*wars|disney|hulk|iron[\s-]?man|spider[\s-]?man|captain america|black panther|darth|vader|batman|superman|\bnfl\b|\bnba\b|\bmlb\b|\bnhl\b|\bflag\b/i;
function gripSearchText(s){
  if(!s)return '';
  /* 2026-07-09: s.source_tags removed from this blob (see note in inferGripProfiles).
     This text feeds novelty detection, style/color color-word scanning, and the
     mainstream/niche default nudge, so the same source_tags noise (merchandising
     tags reused for size/collection purposes, not real product attributes) was
     leaking into all of them. */
  var parts=[
    s.brand,s.model,s.display_name,s.displayName,s.product_title,s.productTitle,
    s.title,s.name,s.full_title,s.fullTitle
  ];
  (s.variants||[]).forEach(function(v){
    if(!v)return;
    parts.push(v.product_title,v.productTitle,v.title,v.name,v.full_title,v.fullTitle,v.url);
  });
  return parts.filter(Boolean).join(' ');
}
function isNovelty(s){
  var text=gripSearchText(s);
  if(NOVELTY_RE.test(text))return true;
  if(/\bteams?\b/i.test(text))return true; /* team-logo editions */
  return false;
}
function noveltyPenalty(s){ return isNovelty(s) ? -45 : 0; }

/* Training / teaching / practice / junior / demo grips are not normal retail
   recommendations — heavily demote so they never headline or show as alternates. */
var ODDBALL_RE=/\btraining\b|\btrainer\b|\bteaching\b|\bpractice\b|\bjunior\b|\bjr\.?\b|\bdemo\b/i;
function oddballPenalty(s){ return ODDBALL_RE.test(s.model||'') ? -60 : 0; }

/* Mainstream/default merchandising: when a golfer gives neutral or unsure answers,
   keep the first recommendations familiar and broadly trusted instead of letting
   niche or novelty-ish grips drift into the top 5 on scoring ties. */
var MAINSTREAM_DEFAULT_RE=/tour\s*velvet|velour|cross\s*comfort|cp2|cpx|dri[-\s]*tac|mcc|new\s*decade|zenergy|traxion|pistol|flatso|pro\s*only/i;
var NICHE_DEFAULT_RE=/gaucho|stick\s*grip|shamrock|loudmouth|captain\s*thunderbolt|shagadelic|argyle|icon|special|limited|patriotic|flag|team/i;
var SAFE_PUTTER_DEFAULT_RE=/super\s*stroke.*(?:pistol|tour)\s*(?:1\.0|2\.0)|zenergy.*(?:pistol|tour)\s*(?:1\.0|2\.0)|golf\s*pride\s*pro\s*only/i;
function confidenceLabel(pct){
  pct=Number(pct)||0;
  if(pct>=92)return 'Excellent match';
  if(pct>=82)return 'Strong match';
  if(pct>=72)return 'Good match';
  return 'Potential match';
}

/* Spec-confidence bonus, tiered. Supports the current spec-sheet vocabulary
   while remaining backward compatible with older exports. */
function confidenceBonus(s){
  var c=String((s&&s.spec_confidence)||'').toLowerCase();
  if(c==='verified_model'||c==='verified')return 4;
  if(c==='verified_family'||c==='verified_brand_default'||c==='verified-brand')return 3;
  if(c==='verified_brand')return 2;
  return 0;
}
function isRecommendationEligible(s){
  if(!s)return false;
  var v=String(s.recommendation_eligible==null?'yes':s.recommendation_eligible).toLowerCase();
  return v!=='no'&&v!=='false'&&v!=='0';
}

/* Normalize the messy putter_shape vocabulary into a face-shape class.
   Bare "no-taper"/"unconfirmed" carry no face shape -> neutral (''). */
function putterShapeClass(raw){
  var t=(raw||'').toLowerCase();
  if(!t||t==='unconfirmed'||t==='no-taper')return '';
  /* 2026-07-09 fix: "claw"-style putter grips (Super Stroke The Claw, Traxion
     CLAW, Zenergy CLAW, etc.) are wide, non-traditional grips built for the
     claw putting technique — not a traditional flat-front/pistol/round shape,
     and the quiz never asks whether a golfer uses a claw grip. Their curated
     putter_shape text is literally "flat claw", which matched /flat/ BELOW
     and got misclassified as FLAT — winning the full straight-stroke
     flat-front bonus and beating (or nearly tying) genuinely flat-front
     grips like Flatso for a plain standard/slim/firm request (Case 13).
     Check for "claw" FIRST and return its own class so it gets none of the
     FLAT/PISTOL/ROUND shape bonuses for any stroke answer. */
  if(/claw/.test(t))return 'CLAW';
  if(/round/.test(t))return 'ROUND';
  if(/pistol|contour/.test(t))return 'PISTOL';
  if(/flat|straight|paddle/.test(t))return 'FLAT';
  return '';
}

function scoreClub(s,a,target,customerProfiles){
  a=normalizeQuizAnswers(a);
  var sc=0, why=[], sizes=s.sizes_available||[];
  var feelValue=String(s.feel_profile||s.feelProfile||s.feel||'').toLowerCase();
  if(feelValue==='balanced')feelValue='medium';
  var tackValue=String(s.tack_level||s.tackLevel||s.tack||'').toLowerCase();
  var weatherValue=String(s.weather_performance||s.weatherPerformance||s.weather||'').toLowerCase();
  customerProfiles=customerProfiles||getCustomerProfiles(a);
  function addWhy(msg){ if(msg && why.indexOf(msg)===-1) why.push(msg); }

  if(sizes.indexOf(target)>=0) {
    sc+=55;
    addWhy('This grip is available in your recommended '+target+' size, so it matches the hand-size result from the quiz');
  }
  else if(sizes.some(function(x){return adjacent(x,target);})) {
    sc+=20;
    addWhy('This model is close to your recommended size range and still fits the profile you selected');
  }
  else sc+=2;

  if(a.sweat==='wet'){
    /* 2026-07-09: dropped the s.source_tags fallback here. Audited all 649 catalog
       specs — 22 products (Golf Pride Tour Velvet ALIGN, Tour Wrap 2G, Lamkin
       Crossline/ST+2 Hybrid, Super Stroke S-Tech, etc.) matched /cord/i only because
       their Shopify source_tags contain the word "cord" as a merchandising/collection
       tag, even though none of them are actually corded (texture is textured/wrap
       rubber). That was a false +40 wet-weather boost. s.texture and s.model are
       curated/real signals; source_tags is not. */
    if(productHasCord(s)){
      sc+=40;
      addWhy('The corded texture gives you stronger traction when the grip gets wet');
    }
    else if(weatherValue==='maximum_wet'||weatherValue==='all_weather'||weatherValue==='all-weather'){
      sc+=22;
      addWhy('The all-weather design helps maintain traction in rain and damp conditions');
    }
    else sc-=12;
  }
  else if(a.sweat==='sweaty'){
    if(productHasCord(s)||weatherValue==='humid_sweat'||weatherValue==='all_weather'||weatherValue==='maximum_wet'||weatherValue==='all-weather'){sc+=22;addWhy('The added traction helps keep the club from slipping when your hands get sweaty or humid');}
    else sc+=3;
  }
  else { if((tackValue==='high'||tackValue==='very_high') && (a.feel==='soft' || a.comfort==='yes'))sc+=8; }

  if(a.feel==='soft'&&(feelValue==='soft'||feelValue==='very_soft')){
    sc+=20;addWhy('The softer feel gives you more cushioning and reduces harsh feedback through your hands');
  }
  else if(a.feel==='firm'&&(feelValue==='firm'||feelValue==='very_firm')){
    sc+=20;addWhy('The firmer feel gives clearer feedback and a more connected feel during the swing');
  }
  else if(a.feel==='balanced'&&(feelValue==='medium'||feelValue==='balanced')){
    sc+=14;addWhy('The medium feel gives you a balanced mix of comfort, control, and feedback');
  }
  else if(a.feel!=='balanced'&&feelValue!==a.feel){sc-=4;}

  /* Neutral, all-purpose request (balanced feel, comfort not flagged): favor classic
     medium-feel moderate-tack rubber grips (e.g. Tour Velvet) over comfort/tacky-biased
     grips (e.g. high-tack polymers). Keeps the quiz from defaulting to soft/tacky picks
     when the golfer didn't ask for them. */
  if(a.feel==='balanced' && a.comfort!=='yes' && (a.texture==='smooth' || a.texture==='nopref')){
    if((feelValue==='medium'||feelValue==='balanced') && tackValue!=='high' && tackValue!=='very_high' && has(/rubber/i,s.material)){
      sc+=10; addWhy('A classic medium-feel rubber grip suits the neutral, all-purpose feel you selected');
    } else if(tackValue==='high' || tackValue==='very_high' || feelValue==='soft' || feelValue==='very_soft'){
      sc-=4;
    }
  }

  var neutralDefaultProfile=!clubMustHaveActive(a)&&((a.hand==='unsure')||(
    a.feel==='balanced' && a.comfort!=='yes' && a.sweat==='dry' &&
    (a.texture==='smooth'||a.texture==='nopref') &&
    (a.alignment==='round'||a.alignment==='nopref')
  ));
  if(neutralDefaultProfile){
    var defaultName=gripSearchText(s);
    if(MAINSTREAM_DEFAULT_RE.test(defaultName))sc+=8;
    if(NICHE_DEFAULT_RE.test(defaultName))sc-=26;
  }

  if(a.comfort==='yes'){
    var soft=(feelValue==='soft'||feelValue==='very_soft'), damp=has(/dampening|polymer|elastomer|winndry/i,s.material), big=(target==='Jumbo/Oversize'||target==='Midsize');
    if(soft||damp){sc+=22;addWhy('The shock-absorbing construction helps reduce hand and wrist strain during the round');}
    if(big&&sizes.indexOf(target)>=0)sc+=6;
    /* Comfort golfers should land on a softer grip — steer away from firm feel,
       except in wet conditions where a cord (often firmer) grip is needed for traction. */
    if((feelValue==='firm'||feelValue==='very_firm')&&a.sweat!=='wet')sc-=20;
  }

  /* 2026-07-09: texture is a hard preference when the golfer explicitly picks
     corded or wrap (not smooth/nopref, which stay soft preferences). Bumped
     from a +16/-4 soft nudge to a weight comparable to the other hard
     preferences (alignment, size) so an explicit "I want corded" or "I want
     wrap" answer reliably outranks generic profile-matching bonuses instead
     of being swamped by them. See maxScoreClub — keep the ceiling in sync. */
  if(a.texture==='corded'){
    if(productHasCord(s)){sc+=45;addWhy('The corded texture is a strong match for the extra-traction feel you specifically asked for');}
    else sc-=30;
  }
  else if(a.texture==='wrap'){
    if(productIsWrap(s)){sc+=45;addWhy('The wrap-style texture is a strong match for the classic wrapped feel you specifically asked for');}
    else sc-=24;
  }
  else if(a.texture==='smooth'){
    if(!productHasCord(s)&&!productIsWrap(s)){sc+=10;addWhy('The smoother rubber surface matches your preference for a clean, traditional grip feel');}
  }

  /* Alignment is a hard preference. When the golfer explicitly asks for an
     alignment ridge, prioritize clearly branded alignment models (ALIGN,
     Calibrate, Reminder) above generic round versions of the same grip, and
     give partial credit to "varies" listings that may include a ridge variant.
     This keeps products like Tour Velvet ALIGN ahead of regular Tour Velvet.
     IMPORTANT (fixed 2026-07-08, revised after a deeper follow-up fix same day):
     only trust the curated s.alignment field and the actual product model
     name for this — never s.brand or s.source_tags. Two false positives were
     found and closed:
       1. Free-text matching 'ribbed' against the model name credited Iomic's
          "Sticky 1.8 Ribbed" (a ribbed TRACTION texture, curated alignment
          field = "round", no ridge) as an alignment-reminder grip.
       2. Even after restricting 'ribbed' to the curated field, the broader
          align/calibrate/reminder check still scanned s.source_tags, and
          Iomic's Shopify merchandising tag "ribbed-reminder-golf-grips"
          contains the word "reminder" as a collection/SEO tag, unrelated to
          any real alignment-ridge feature, and slipped through the same way.
     Both false positives caused the same case: a customer asking for firm
     feel + smooth texture + alignment=yes (Nate's case 2) got recommended a
     soft, non-aligned grip over genuinely firmer, better-fitting alternatives.
     The curated s.alignment field values in the catalog are a closed, known
     set (round / round (unconfirmed) / round/ribbed (varies) / ALIGN ridge
     (reminder) / alignment (ALIGN) / blank) — safe to match directly instead
     of scanning free text. */
  var alignmentField=(s.alignment||'');
  var alignmentType=alignmentAidType(s);
  if(a.alignment==='yes'){
    if(alignmentType==='ridge'){
      sc+=55;
      addWhy('The built-in alignment ridge helps you place your hands the same way every time');
    }else if(alignmentType==='varies'){
      sc+=20;
      addWhy('Some versions of this grip include an alignment aid — check the product page for the exact option');
    }else sc-=35;
  }
  else if(a.alignment==='round'){
    /* 2026-07-09 fix: previously there was no penalty at all here, so an
       ALIGN/ribbed/reminder-branded grip could still win on size/feel/profile
       alone even though the golfer explicitly said they did NOT want an
       alignment ridge. Penalize clearly-branded alignment models the same way
       the a.alignment==='yes' branch above penalizes non-aligned models for a
       ridge request — this keeps them from outranking genuine round-profile
       grips, and the addWhy() call means that if one still surfaces (e.g. it's
       the only option in the recommended size), the mismatch is disclosed in
       the visible "why" reasons rather than shown silently. */
    if(productHasAlignmentRidge(s)){
      sc-=40;
      addWhy('This model includes a raised alignment ridge, which is the opposite of the standard round profile you asked for');
    }
    else if(alignmentType==='round'){
      sc+=6;
      addWhy('The round profile gives you a clean setup without a raised alignment ridge');
    }
  }

  if(a.pressure==='tight'&&isReducedTaperGrip(s)){
    sc+=14;addWhy('The reduced-taper lower hand can ease grip pressure and help your hands stay more relaxed');
  }

  /* Small tie-breaker: sweaty hands prefer the higher-tack option when specs
     otherwise match. Not applied to 'wet' — cord traction should lead in rain
     even though cord grips are often rated low-tack. */
  if(a.sweat==='sweaty'&&s.tack==='high')sc+=4;

  sc+=styleColorBoost(s,a,customerProfiles,why,target);
  sc+=profileMatchBoost(s,customerProfiles,why);
  sc+=descriptionBoost(s,a,why);
  sc+=preferredBrandBoost(s,customerProfiles,sc);
  sc+=confidenceBonus(s);
  sc+=noveltyPenalty(s);
  sc+=oddballPenalty(s);
  return {score:sc,why:why};
}

/* Maximum achievable scoreClub for a given answer set — used to normalize
   scores into a match %. KEEP IN SYNC with scoreClub when weights change. */
/* Max achievable descriptionBoost() for a given answer set — mirrors its
   conditions with each bonus's ceiling. KEEP IN SYNC with descriptionBoost. */
function maxDescriptionBoost(a){
  var m=0;
  if(a.sweat==='wet')m+=10;
  if(a.pressure==='tight'||a.priority==='control')m+=8;
  if(a.pressure==='tight'||a.priority==='size')m+=8;
  if(a.priority==='traction'||a.sweat==='sweaty')m+=6;
  if(a.comfort==='yes')m+=6;
  return Math.min(m,24);
}
function maxScoreClub(a,target){
  a=normalizeQuizAnswers(a);
  var m=55; /* exact size match */
  if(a.sweat==='wet')m+=40; else if(a.sweat==='sweaty')m+=22;
  else if(a.feel==='soft'||a.comfort==='yes')m+=8; /* dry high-tack bonus */
  if(a.feel==='soft'||a.feel==='firm')m+=20; else if(a.feel==='balanced')m+=14;
  if(a.feel==='balanced'&&a.comfort!=='yes'&&(a.texture==='smooth'||a.texture==='nopref'))m+=10;
  if((a.hand==='unsure')||(a.feel==='balanced'&&a.comfort!=='yes'&&a.sweat==='dry'&&(a.texture==='smooth'||a.texture==='nopref')&&(a.alignment==='round'||a.alignment==='nopref')))m+=8;
  if(a.comfort==='yes')m+=22+((target==='Jumbo/Oversize'||target==='Midsize')?6:0);
  if(a.texture==='corded'||a.texture==='wrap')m+=45; else if(a.texture==='smooth')m+=10;
  if(a.alignment==='yes')m+=55; else if(a.alignment==='round')m+=6;
  if(a.pressure==='tight')m+=14;
  if(a.sweat==='sweaty')m+=4;
  m+=maxDescriptionBoost(a);
  m+=4; /* confidence */
  return m;
}
function scorePutter(s,a,customerProfiles){
  var sc=0,why=[];
  customerProfiles=customerProfiles||getCustomerProfiles(a);
  /* Face shape is the most important putter-fit factor, so it leads the score.
     straight -> flat-front, slight arc -> pistol, strong arc -> round (with pistol
     as a strong fallback because round-tagged grips are scarce in the catalog). */
  var shapeClass=putterShapeClass(s.putter_shape);
  if(a.stroke==='straight'){
    if(shapeClass==='FLAT'){sc+=48;why.push('A flat-front shape helps keep the face square for a straight-back, straight-through stroke');}
    else if(shapeClass==='PISTOL'){sc+=16;}
    else if(shapeClass==='ROUND'){sc-=18;}
  }else if(a.stroke==='arc'){
    if(shapeClass==='ROUND'){sc+=48;why.push('A rounder grip shape lets the putter face rotate naturally through a stronger arc stroke');}
    else if(shapeClass==='PISTOL'){sc+=30;why.push('A pistol shape suits a stronger arc and still lets the face release through the stroke');}
    else if(shapeClass==='FLAT'){sc-=18;}
  }else{ /* slight arc */
    if(shapeClass==='PISTOL'){sc+=48;why.push('A pistol-style shape works well for a slight-arc stroke and gives you a balanced blend of feel and face control');}
    else if(shapeClass==='FLAT'){sc+=16;}
    else if(shapeClass==='ROUND'){sc+=16;}
  }
  if(!shapeClass)sc+=4;

  var ps=(s.putter_size||'').toLowerCase();
  var isBig=/3\.0|4\.0|5\.0|oversize|jumbo|fatso/.test(ps),isMid=/2\.0|midsize/.test(ps),isStd=/1\.0|slim|standard/.test(ps);
  var wantBig=a.psize==='oversize'||a.wristaction==='wristy', wantMid=a.psize==='midsize';
  var putterText=gripSearchText(s).toLowerCase();
  var isLongPutter=/counter\s*balance|counterbalance|\blong\b|17\s*(?:\"|”|in\b)|21\s*(?:\"|”|in\b)|\bxl\+|\bxl\b/.test(putterText);

  if(a.psize==='standard'&&isStd){
    sc+=24;
    why.push('The standard thickness keeps more feel in your hands and gives you a traditional putting grip profile');
  }
  else if(wantMid&&isMid){
    sc+=24;
    why.push('The midsize thickness adds stability without making the grip feel overly bulky');
  }
  else if(wantBig&&isBig){
    sc+=26;
    why.push(a.wristaction==='wristy'
      ? 'The larger grip helps quiet wrist action and keep the stroke more stable'
      : 'The oversize profile gives you maximum hand comfort and stroke stability');
  }
  else if(a.psize==='nopref')sc+=8;

  /* Respect the golfer's stated thickness: a slim/standard request should not be
     pushed onto a bigger grip on shape alone (e.g. strong arc -> a midsize/oversize
     round). Slim-pistol is the correct fallback when no slim round grip is in stock. */
  if(a.psize==='standard'&&isBig)sc-=22; else if(a.psize==='standard'&&isMid)sc-=12; else if(a.psize==='oversize'&&isStd)sc-=16; else if(a.psize==='midsize'&&(isBig||isStd))sc-=6;

  /* No-preference putter golfers should get a safe, mainstream size first.
     Oversize still wins when the golfer says they get wristy, but neutral
     no-preference profiles should not default into jumbo, long, or counterbalance grips. */
  if(a.psize==='nopref'){
    if(isMid||isStd)sc+=10;
    if(isBig&&a.wristaction!=='wristy')sc-=12;
  }

  if(isLongPutter && a.pweight!=='heavy' && a.wristaction!=='wristy' && a.psize!=='oversize'){
    sc-=35;
  }

  var safePutterDefaultProfile=(
    a.stroke==='slight' && a.wristaction==='neutral' &&
    a.psize==='nopref' && a.pweight==='nopref' && a.pfeel==='nopref'
  );
  if(safePutterDefaultProfile){
    if(SAFE_PUTTER_DEFAULT_RE.test(putterText))sc+=12;
    if(/jumbo|max|counter\s*balance|counterbalance|\blong\b|\bxl\+|\bxl\b|17\s*(?:"|”|in\b)|21\s*(?:"|”|in\b)/i.test(putterText))sc-=32;
  }

  var w=avgWeight(s);
  if(w!=null&&a.pweight!=='nopref'){
    if(a.pweight==='light'&&w<=60){sc+=18;why.push('The lighter weight keeps the putter head feeling responsive and easier to control');}
    else if(a.pweight==='heavy'&&w>=85){sc+=18;why.push('The heavier weight adds stability and can help smooth out the stroke');}
    else if(a.pweight==='medium'&&w>60&&w<85){sc+=14;why.push('The mid-range weight keeps a balanced feel between head stability and touch');}
  }
  if(a.pfeel==='soft'&&s.feel==='soft'){sc+=12;why.push('The softer feel adds tack and comfort without losing control');}
  else if(a.pfeel==='firm'&&s.feel==='firm'){sc+=12;why.push('The firmer feel gives you cleaner feedback at impact');}
  sc+=styleColorBoost(s,a,customerProfiles,why);
  sc+=profileMatchBoost(s,customerProfiles,why);
  sc+=descriptionBoost(s,a,why);
  sc+=preferredBrandBoost(s,customerProfiles,sc);
  sc+=confidenceBonus(s);
  sc+=noveltyPenalty(s);
  sc+=oddballPenalty(s);
  return {score:sc,why:why};
}

/* Maximum achievable scorePutter for a given answer set — used to normalize
   scores into a match %. KEEP IN SYNC with scorePutter when weights change. */
function maxScorePutter(a){
  var m=48; /* best shape match for any stroke answer */
  if(a.psize==='oversize')m+=26;
  else if(a.psize==='standard'||a.psize==='midsize')m+=24;
  else m+=(a.wristaction==='wristy'?26:18); /* nopref */
  if(a.pweight==='light'||a.pweight==='heavy')m+=18;
  else if(a.pweight==='medium')m+=14;
  if(a.pfeel==='soft'||a.pfeel==='firm')m+=12;
  if(a.stroke==='slight'&&a.wristaction==='neutral'&&a.psize==='nopref'&&a.pweight==='nopref'&&a.pfeel==='nopref')m+=12;
  m+=4; /* confidence */
  return m;
}

/* ================================================================== *  FORMAT / BUNDLE-KIT  */
function packCount(f){var m=/(\d+)\s*pc/.exec(f);return m?+m[1]:1;}
function fmtMeta(f){var n=packCount(f),kit=/kit/i.test(f),bun=/bundle/i.test(f);
  if(n<=1)return {key:f,label:'Single',n:1,rank:1};
  if(kit)return {key:f,label:n+' pc + Kit',n:n,rank:4};
  if(bun)return {key:f,label:n+' pc',n:n,rank:3};
  return {key:f,label:n+'pc',n:n,rank:2};}
function getProductHandleFromSpec(spec){
  if(!spec)return '';
  if(spec.handle)return String(spec.handle).replace(/^\/products\//,'').replace(/^products\//,'').split('?')[0].replace(/^\//,'');
  if(spec.product_handle)return String(spec.product_handle).replace(/^\/products\//,'').replace(/^products\//,'').split('?')[0].replace(/^\//,'');
  if(spec.productHandle)return String(spec.productHandle).replace(/^\/products\//,'').replace(/^products\//,'').split('?')[0].replace(/^\//,'');

  var urls=[];
  ['url','product_url','productUrl','handle_url'].forEach(function(k){ if(spec[k])urls.push(spec[k]); });
  (spec.variants||[]).forEach(function(v){ if(v&&v.url)urls.push(v.url); });

  for(var i=0;i<urls.length;i++){
    var h=getProductHandleFromUrl(urls[i]);
    if(h)return h;
  }
  return '';
}
function normalizeProductUrl(url,spec,variant){
  var handle=getProductHandleFromSpec(spec);
  var raw=(url==null?'':String(url)).trim();

  if(!raw && variant && variant.url)raw=String(variant.url).trim();
  if(!raw && spec){
    raw=String(spec.url||spec.product_url||spec.productUrl||'').trim();
  }

  if(!raw && handle)return '/products/'+encodeURIComponent(handle);
  if(!raw)return '#';
  if(raw.charAt(0)==='#')return raw;

  /* Some generated data may store only a query string or only a variant ID.
     Add the product handle back so the link does not become the current quiz page. */
  if(raw.charAt(0)==='?' && handle)return '/products/'+encodeURIComponent(handle)+raw;
  if(/^\d{8,}$/.test(raw) && handle)return '/products/'+encodeURIComponent(handle)+'?variant='+encodeURIComponent(raw);

  if(/^https?:\/\//i.test(raw))return raw;
  if(/^\/\//.test(raw))return window.location.protocol+raw;
  if(raw.charAt(0)==='/')return raw;

  /* Root-relative Shopify routes. */
  if(/^products\//i.test(raw))return '/'+raw;
  if(/^collections\//i.test(raw))return '/'+raw;
  if(/^cart\//i.test(raw))return '/'+raw;

  /* URLs without a scheme, like www.grips4less.com/products/handle. */
  var m=raw.match(/(?:^|\/)products\/([^\/?#]+)/i);
  if(m){
    var query=raw.indexOf('?')>=0?raw.slice(raw.indexOf('?')):'';
    return '/products/'+m[1]+query;
  }

  /* Bare handle fallback. */
  if(/^[a-z0-9][a-z0-9-]*$/i.test(raw))return '/products/'+raw;

  return raw;
}
function absoluteProductUrl(url,spec,variant){
  var href=normalizeProductUrl(url,spec,variant);
  if(!href || href==='#')return '#';
  try{return new URL(href,window.location.origin).href;}catch(e){return href;}
}
/* 2026-07-09 product-link integrity fix:
   Some spec rows can contain variants from more than one Shopify product when
   the upstream export collapses similar/truncated model names (example:
   brand="Tacki-Mac", model="Tacki"). That can make the card display one
   product name while the format/button URL points to a totally different
   product handle. Keep the visible name and every buy link inside the same
   Shopify product handle by filtering variants to the product handle that
   produced the displayed name. */
function variantHandle(v){return getProductHandleFromUrl(v&&v.url);}
function validDisplayCandidateName(v){
  v=stripFormatFromName(v);
  return !!(v && v.length>3 && !/^(unconfirmed|unspecified)$/i.test(v));
}
function findVariantHandleByDisplayName(spec,name){
  name=stripFormatFromName(name).toLowerCase();
  if(!name||!spec||!spec.variants)return '';
  for(var i=0;i<spec.variants.length;i++){
    var v=spec.variants[i]||{};
    var h=variantHandle(v);
    if(!h)continue;
    var fields=[v.product_title,v.productTitle,v.title,v.name,v.full_title,v.fullTitle];
    for(var j=0;j<fields.length;j++){
      var c=stripFormatFromName(fields[j]).toLowerCase();
      if(c&&c===name)return h;
    }
  }
  return '';
}
function displayProductHandleForSpec(spec){
  spec=spec||{};
  var direct=getProductHandleFromSpec(spec);

  /* Known handle-based display override. If this returned a name from the
     direct handle, the links should use that same handle. */
  if(displayNameFromHandleForGenericSpec(spec)&&direct)return direct;

  var specFields=[
    spec.display_name,spec.displayName,spec.product_title,spec.productTitle,
    spec.title,spec.name,spec.full_title,spec.fullTitle
  ];
  for(var i=0;i<specFields.length;i++){
    var c=stripFormatFromName(specFields[i]);
    if(validDisplayCandidateName(c))return findVariantHandleByDisplayName(spec,c)||direct;
  }

  if(spec.variants&&spec.variants.length){
    for(var j=0;j<spec.variants.length;j++){
      var v=spec.variants[j]||{};
      var fields=[v.product_title,v.productTitle,v.title,v.name,v.full_title,v.fullTitle];
      for(var k=0;k<fields.length;k++){
        var vc=stripFormatFromName(fields[k]);
        if(validDisplayCandidateName(vc))return variantHandle(v)||direct;
      }
    }
  }

  return direct;
}
function variantsForDisplayedProduct(spec,variants){
  variants=variants||[];
  var handle=displayProductHandleForSpec(spec);
  if(!handle)return variants;
  var filtered=variants.filter(function(v){
    var h=variantHandle(v);
    return !h || h===handle;
  });
  return filtered.length?filtered:variants;
}
function variantsForSize(spec,t){
  /* Size must be resolved across the entire model family before any default
     product URL is considered. A family-level spec URL may point at one color
     or size (CP2 Wrap pointed at the pink Undersize page), while the correct
     Midsize/Standard product lives on another Shopify product page. */
  var raw=(spec&&spec.variants)||[];
  var exact=raw.filter(function(v){
    var sizes=Array.isArray(v&&v.size)?v.size:[];
    return !t||sizes.indexOf(t)>=0;
  });
  if(exact.length)return exact;
  var unspecified=raw.filter(function(v){
    var sizes=Array.isArray(v&&v.size)?v.size:[];
    return sizes.indexOf('Unspecified')>=0||sizes.length===0;
  });
  if(unspecified.length)return unspecified;
  /* Last-resort fallback only when the export has no variant tagged to the
     requested size. This is disclosed elsewhere as a size compromise. */
  return raw;
}
function buildFormats(spec,t,wantSet){
  var vs=variantsForSize(spec,t),by={},preferStyle=stylePriorityActive(ans);
  vs.forEach(function(v){var k=v.format||'single';if(preferVariantCandidate(v,by[k],spec,preferStyle))by[k]=v;});
  var list=Object.keys(by).map(function(k){var m=fmtMeta(k);m.url=normalizeProductUrl(by[k].url,spec,by[k]);m.price=by[k].price;m.styleScore=variantStyleScore(by[k],spec);return m;});
  list.sort(function(a,b){
    if(preferStyle){
      var ds=(b.styleScore||0)-(a.styleScore||0);
      if(ds)return ds;
    }
    if(wantSet)return (b.rank-a.rank)||(b.n-a.n)||((a.price||0)-(b.price||0));
    return (a.rank-b.rank)||(a.n-b.n)||((a.price||0)-(b.price||0));
  });
  if(list.length){var p=list[0];
    if(wantSet)p=list.filter(function(x){return /kit/i.test(x.key);})[0]||list.filter(function(x){return x.rank===3;})[0]||list[0];
    list.forEach(function(x){x.primary=(x===p);});
    list.sort(function(a,b){return (b.primary?1:0)-(a.primary?1:0);});}
  return list;
}

function getProductHandleFromUrl(url){
  if(!url)return '';
  try{var u=new URL(url,window.location.origin);var m=u.pathname.match(/\/products\/([^\/?#]+)/);return m?decodeURIComponent(m[1]):'';}catch(e){var m2=String(url).match(/\/products\/([^\/?#]+)/);return m2?decodeURIComponent(m2[1]):'';}
}
function getVariantIdFromUrl(url){
  if(!url)return '';
  try{var u=new URL(url,window.location.origin);return u.searchParams.get('variant')||'';}catch(e){var m=String(url).match(/[?&]variant=([^&#]+)/);return m?m[1]:'';}
}
function variantIdFromGid(gid){var s=String(gid||'');var parts=s.split('/');return parts[parts.length-1]||s;}
function withSelectedVariant(url,variantId){
  var href=normalizeProductUrl(url);
  if(!href||href==='#'||!variantId)return href;
  try{
    var u=new URL(href,window.location.origin);
    u.searchParams.set('variant',String(variantId));
    return /^https?:\/\//i.test(href)?u.href:(u.pathname+u.search+u.hash);
  }catch(e){
    var base=String(href).replace(/([?&])variant=[^&#]*&?/i,function(m,p){return p==='?'?'?':'';}).replace(/[?&]$/,'');
    return base+(base.indexOf('?')>=0?'&':'?')+'variant='+encodeURIComponent(String(variantId));
  }
}
function liveVariantDescriptorFromStorefrontNode(n){
  if(!n)return null;
  var selected={},opts=[];
  (n.selectedOptions||[]).forEach(function(o){if(o&&o.name){selected[o.name]=o.value;opts.push(o.value);}});
  var p=n.price&&n.price.amount!=null?Number(n.price.amount):null;
  var c=n.compareAtPrice&&n.compareAtPrice.amount!=null?Number(n.compareAtPrice.amount):null;
  return {id:variantIdFromGid(n.id),available:n.availableForSale!==false,title:n.title||'',sku:n.sku||'',options:opts,selectedOptions:selected,price:isNaN(p)?null:p,compareAt:isNaN(c)?null:c};
}
function liveVariantDescriptorsFromStorefront(product){
  return (((product||{}).variants||{}).edges||[]).map(function(e){return liveVariantDescriptorFromStorefrontNode(e&&e.node);}).filter(Boolean);
}
function liveVariantDescriptorsFromJson(product){
  return ((product&&product.variants)||[]).map(function(v){
    var p=v&&v.price!=null?Number(v.price)/100:null;
    var c=v&&v.compare_at_price!=null?Number(v.compare_at_price)/100:null;
    return {
      id:String(v&&v.id||''),available:!!v&&v.available!==false,title:String(v&&v.title||''),sku:String(v&&v.sku||''),
      options:[v&&v.option1,v&&v.option2,v&&v.option3].filter(Boolean).map(String),
      price:isNaN(p)?null:p,compareAt:isNaN(c)?null:c
    };
  }).filter(function(v){return !!v.id;});
}
function normalizeVariantMatchText(v){
  return String(v||'').toLowerCase().replace(/\bgray\b/g,'grey').replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();
}
function desiredVariantLabels(specVariant,forcedColorLabel){
  var labels=[];
  if(forcedColorLabel)labels.push(forcedColorLabel);
  else meaningfulVariantColorLabels(specVariant||{}).forEach(function(x){labels.push(x);});
  var out=[],seen={};
  labels.forEach(function(x){var n=normalizeVariantMatchText(x);if(n&&!seen[n]){seen[n]=1;out.push(n);}});
  return out;
}
function liveVariantMatchScore(desc,specVariant,forcedColorLabel){
  if(!desc||desc.available===false)return -1e9;
  var text=normalizeVariantMatchText([desc.title,desc.sku].concat(desc.options||[]).join(' '));
  var score=0,labels=desiredVariantLabels(specVariant,forcedColorLabel);
  labels.forEach(function(label){
    if(text===label)score+=120;
    else if(text.indexOf(label)>=0)score+=80;
    var colors=colorWordsInText(label);
    if(colors.length&&colors.every(function(c){return text.indexOf(c==='gray'?'grey':c)>=0;}))score+=45+colors.length*4;
  });
  var sizes=(specVariant&&Array.isArray(specVariant.size))?specVariant.size:[];
  sizes.forEach(function(size){
    var n=normalizeVariantMatchText(size);
    if(n&&text.indexOf(n)>=0)score+=18;
  });
  if(labels.length===0)score+=1;
  return score;
}

function reconcileEmbeddedShopifyVariants(specVariant,descriptors){
  var embedded=embeddedShopifyVariants(specVariant);
  if(!embedded.length)return [];
  descriptors=descriptors||[];
  if(!descriptors.length)return embedded.filter(function(x){return x.available!==false;});
  var byId={};descriptors.forEach(function(d){if(d&&d.id)byId[String(d.id)]=d;});
  return embedded.map(function(x){
    var d=byId[String(x.id)];
    if(!d||d.available===false||x.available===false)return null;
    var out={};for(var k in x){if(Object.prototype.hasOwnProperty.call(x,k))out[k]=x[k];}
    out.available=true;
    if(d.price!=null)out.price=d.price;
    if(d.compareAt!=null)out.compareAt=d.compareAt;
    return out;
  }).filter(Boolean);
}

function resolveLiveVariantId(descriptors,specVariant,forcedColorLabel){
  descriptors=(descriptors||[]).filter(function(v){return v&&v.available!==false&&v.id;});
  if(!descriptors.length)return '';
  var existing=getVariantIdFromUrl(specVariant&&specVariant.url);
  if(existing&&!forcedColorLabel&&descriptors.some(function(v){return String(v.id)===String(existing);}))return String(existing);
  if(existing&&forcedColorLabel){
    var existingDesc=descriptors.filter(function(v){return String(v.id)===String(existing);})[0];
    if(existingDesc&&liveVariantMatchScore(existingDesc,specVariant,forcedColorLabel)>=40)return String(existing);
  }
  if(descriptors.length===1)return String(descriptors[0].id);
  var best=null,bestScore=-1e9;
  descriptors.forEach(function(v){var sc=liveVariantMatchScore(v,specVariant,forcedColorLabel);if(sc>bestScore){best=v;bestScore=sc;}});
  /* Require a real label/size match when several live variants exist. This is
     safer than silently selecting Shopify's first variant for an ambiguous
     color page. */
  return best&&bestScore>=40?String(best.id):'';
}
function variantUrlForColor(v,label){
  if(!v)return '#';
  var key=canonicalColorKey(label),exact=exactColorVariantsForEntry(v),match=null;
  for(var i=0;i<exact.length;i++){
    if(canonicalColorKey(exact[i].color)===key){match=exact[i];break;}
  }
  if(match&&match.id)return withSelectedVariant(v.url,match.id);
  var id=resolveLiveVariantId(v._gqLiveVariants||[],v,label);
  return id?withSelectedVariant(v.url,id):normalizeProductUrl(v.url,null,v);
}

var GQ_STOCK_CACHE={};
var GQ_INFLIGHT_CACHE={};
function gqShareInflight(key,factory){
  if(Object.prototype.hasOwnProperty.call(GQ_INFLIGHT_CACHE,key))return GQ_INFLIGHT_CACHE[key];
  var promise;
  try{promise=Promise.resolve(factory());}catch(e){return Promise.reject(e);}
  GQ_INFLIGHT_CACHE[key]=promise;
  return promise.then(function(value){delete GQ_INFLIGHT_CACHE[key];return value;},function(err){delete GQ_INFLIGHT_CACHE[key];throw err;});
}
function fetchWithTimeout(url,options,ms){
  ms=ms||3500;
  options=options||{};

  if(window.AbortController){
    var controller=new AbortController();
    var timer=setTimeout(function(){try{controller.abort();}catch(e){}},ms);
    var opts={};
    for(var k in options){if(Object.prototype.hasOwnProperty.call(options,k))opts[k]=options[k];}
    opts.signal=controller.signal;
    return fetch(url,opts).finally(function(){clearTimeout(timer);});
  }

  return Promise.race([
    fetch(url,options),
    new Promise(function(_,reject){setTimeout(function(){reject(new Error('fetch timeout'));},ms);})
  ]);
}
function storefrontConfig(){
  var cfg=window.GRIP_QUIZ_STOREFRONT||{};
  return {
    token:cfg.token||'',
    apiVersion:cfg.apiVersion||'2025-01',
    endpoint:cfg.endpoint||('/api/'+(cfg.apiVersion||'2025-01')+'/graphql.json')
  };
}
function hasUsableStorefrontToken(token){return !!token && token.indexOf('REPLACE_WITH')===-1 && token.indexOf('YOUR_')===-1;}
function fetchStorefrontProduct(handle){
  var cfg=storefrontConfig();
  var cacheKey='sf:'+handle;
  if(Object.prototype.hasOwnProperty.call(GQ_STOCK_CACHE,cacheKey))return Promise.resolve(GQ_STOCK_CACHE[cacheKey]);
  if(!hasUsableStorefrontToken(cfg.token)){
    GQ_STOCK_CACHE[cacheKey]=null;
    return Promise.resolve(null);
  }

  return gqShareInflight('sf:'+handle,function(){
    var query='query GripQuizProduct($handle:String!){product(handle:$handle){handle availableForSale variants(first:250){edges{node{id title sku availableForSale selectedOptions{name value} price{amount currencyCode} compareAtPrice{amount currencyCode}}}}}}';
    var headers={'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':cfg.token};
    return fetchWithTimeout(cfg.endpoint,{method:'POST',credentials:'same-origin',headers:headers,body:JSON.stringify({query:query,variables:{handle:handle}})},3500)
      .then(function(r){if(!r.ok)throw new Error('Storefront stock fetch failed');return r.json();})
      .then(function(data){
        if(data&&data.errors&&data.errors.length)throw new Error('Storefront GraphQL returned errors');
        var product=data&&data.data&&data.data.product?data.data.product:null;
        GQ_STOCK_CACHE[cacheKey]=product;
        return product;
      })
      .catch(function(){GQ_STOCK_CACHE[cacheKey]=null;return null;});
  });
}

/* ------------------------------------------------------------------
   BATCHED STOREFRONT VARIANT AVAILABILITY  (v33 speed pass)

   The recommendation "load" cost is the per-handle stock waterfall, not the
   scoring. Every embedded shopify_variant in grip-specs.js carries an exact
   ProductVariant GID, so we can resolve availability + live price for the whole
   preselected finalist pool with one or two Storefront `nodes(ids: [...])`
   requests instead of one single-product query per handle.

   IMPORTANT — this does NOT change either safety guarantee:
     * 404 protection still comes solely from verifyPublicProductPage()
       (sitemap / live HTML). Storefront `availableForSale` is never allowed to
       prove publication on its own — a batched node for an unpublished product
       is still rejected by the publication gate upstream.
     * Out-of-stock protection still requires availableForSale === true, read
       from the exact same field the single-product query returns.
   The batch only changes HOW availability is read (in bulk), not WHETHER a
   product is trusted. Any GID the batch does not cover falls back to the
   existing per-handle fetchStorefrontProduct / product.js pipeline unchanged.
   ------------------------------------------------------------------ */
var GQ_VARIANT_AVAIL={};              /* variantId -> {available,price,compareAt,handle} */
var GQ_VARIANT_AVAIL_TTL_MS=5*60*1000;
var GQ_VARIANT_AVAIL_CACHE_KEY='gq_variant_avail_v1';
var GQ_VARIANT_BATCH_MAX=40;          /* GIDs per Storefront request */
var GQ_VARIANT_BATCH_CONCURRENCY=2;   /* simultaneous in-flight batch requests */
var GQ_VARIANT_AVAIL_SEEDED=false;

function gqReadVariantAvailSessionCache(){
  if(GQ_VARIANT_AVAIL_SEEDED)return;
  GQ_VARIANT_AVAIL_SEEDED=true;
  try{
    var raw=sessionStorage.getItem(GQ_VARIANT_AVAIL_CACHE_KEY);
    if(!raw)return;
    var payload=JSON.parse(raw);
    if(!payload||typeof payload.ts!=='number'||(Date.now()-payload.ts)>GQ_VARIANT_AVAIL_TTL_MS)return;
    var map=payload.map||{};
    for(var k in map){if(Object.prototype.hasOwnProperty.call(map,k))GQ_VARIANT_AVAIL[k]=map[k];}
  }catch(e){}
}
function gqWriteVariantAvailSessionCache(){
  try{sessionStorage.setItem(GQ_VARIANT_AVAIL_CACHE_KEY,JSON.stringify({ts:Date.now(),map:GQ_VARIANT_AVAIL}));}catch(e){}
}
/* Collect the exact ProductVariant GIDs embedded on a spec entry. */
function gqEmbeddedGidsForEntry(v){
  return embeddedShopifyVariants(v).map(function(x){return x.gid||('gid://shopify/ProductVariant/'+x.id);}).filter(function(g){return /ProductVariant\/\d+$/.test(g);});
}
/* True only when every embedded GID this spec entry needs is already resolved
   in the batched availability map (fresh). Otherwise we must not shortcut. */
function gqEntryFullyBatched(v){
  var ids=embeddedShopifyVariants(v).map(function(x){return String(x.id);}).filter(Boolean);
  if(!ids.length)return false;
  for(var i=0;i<ids.length;i++){if(!Object.prototype.hasOwnProperty.call(GQ_VARIANT_AVAIL,ids[i]))return false;}
  return true;
}
/* Build Storefront-shaped variant descriptors for a spec entry straight from
   the batched map, so downstream code (reconcileEmbeddedShopifyVariants,
   extractStorefrontPrice, color routing) behaves exactly as with a live fetch. */
function gqBatchedDescriptorsForEntry(v){
  return embeddedShopifyVariants(v).map(function(x){
    var rec=GQ_VARIANT_AVAIL[String(x.id)]||{};
    return {
      id:String(x.id),
      available:rec.available!==false,
      title:'',
      sku:x.sku||'',
      options:[],
      selectedOptions:x.selected_options||{},
      price:(rec.price!=null?rec.price:x.price),
      compareAt:(rec.compareAt!=null?rec.compareAt:(x.compareAt!=null?x.compareAt:null))
    };
  });
}
function gqParseVariantNode(node){
  if(!node||!node.id)return null;
  var vid=variantIdFromGid(node.id);
  var handle=node.product&&node.product.handle?String(node.product.handle):'';
  var p=node.price&&node.price.amount!=null?Number(node.price.amount):null;
  var c=node.compareAtPrice&&node.compareAtPrice.amount!=null?Number(node.compareAtPrice.amount):null;
  /* A variant only counts as available when BOTH the variant and its parent
     product report availableForSale. Publication is still checked separately. */
  var available=(node.availableForSale!==false)&&(!node.product||node.product.availableForSale!==false);
  return {id:String(vid),record:{available:available,price:isNaN(p)?null:p,compareAt:isNaN(c)?null:c,handle:handle}};
}
function gqFetchVariantBatch(gids){
  var cfg=storefrontConfig();
  if(!hasUsableStorefrontToken(cfg.token)||!gids.length)return Promise.resolve(false);
  var query='query GripQuizVariants($ids:[ID!]!){nodes(ids:$ids){__typename ... on ProductVariant{id availableForSale price{amount currencyCode} compareAtPrice{amount currencyCode} product{handle availableForSale}}}}';
  var headers={'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':cfg.token};
  return fetchWithTimeout(cfg.endpoint,{method:'POST',credentials:'same-origin',headers:headers,body:JSON.stringify({query:query,variables:{ids:gids}})},3500)
    .then(function(r){if(!r.ok)throw new Error('variant batch failed');return r.json();})
    .then(function(data){
      if(data&&data.errors&&data.errors.length)throw new Error('variant batch graphql errors');
      var nodes=(data&&data.data&&data.data.nodes)||[];
      nodes.forEach(function(n){var parsed=gqParseVariantNode(n);if(parsed)GQ_VARIANT_AVAIL[parsed.id]=parsed.record;});
      return true;
    })
    .catch(function(){return false;});
}
/* Resolve a list of GIDs, skipping any already fresh in the map, in bounded
   concurrent batches. Never rejects — a failed batch simply leaves those GIDs
   unresolved so the per-handle fallback handles them. */
var GQ_VARIANT_INFLIGHT={};   /* variantId -> true while a batch covering it is in flight */
function gqPrimeVariantAvailability(gids){
  gqReadVariantAvailSessionCache();
  var need=[],seen={};
  (gids||[]).forEach(function(g){
    var id=String(variantIdFromGid(g));
    if(!id||seen[id])return;seen[id]=1;
    /* Skip variants already resolved or already being fetched by a concurrent
       prime (e.g. prefetch during the quiz + the results-time call). */
    if(Object.prototype.hasOwnProperty.call(GQ_VARIANT_AVAIL,id))return;
    if(GQ_VARIANT_INFLIGHT[id])return;
    need.push('gid://shopify/ProductVariant/'+id);
  });
  if(!need.length)return Promise.resolve(false);
  need.forEach(function(gid){GQ_VARIANT_INFLIGHT[variantIdFromGid(gid)]=true;});
  var batches=[];
  for(var i=0;i<need.length;i+=GQ_VARIANT_BATCH_MAX)batches.push(need.slice(i,i+GQ_VARIANT_BATCH_MAX));
  var next=0,any=false;
  function worker(){
    if(next>=batches.length)return Promise.resolve();
    var b=batches[next++];
    return gqFetchVariantBatch(b).then(function(ok){if(ok)any=true;b.forEach(function(gid){delete GQ_VARIANT_INFLIGHT[variantIdFromGid(gid)];});return worker();});
  }
  var lanes=[];
  for(var w=0;w<Math.min(GQ_VARIANT_BATCH_CONCURRENCY,batches.length);w++)lanes.push(worker());
  return Promise.all(lanes).then(function(){need.forEach(function(gid){delete GQ_VARIANT_INFLIGHT[variantIdFromGid(gid)];});if(any)gqWriteVariantAvailSessionCache();return any;});
}

/* ------------------------------------------------------------------
   TOKENLESS BULK CATALOG WARM-UP  (v34 speed pass)

   The store has no Storefront API token configured, so the batched
   nodes(ids:) fast path above can never fire — every candidate would fall to
   a per-handle /products/{handle}.js waterfall on the results screen.

   Shopify also exposes a token-free, same-origin bulk endpoint:
     /collections/{handle}/products.json?limit=250&page=N
   It lists ONLY published Online-Store products and carries per-variant
   `available` + price + compare_at_price. That is functionally the same data
   (and the same Shopify CDN freshness) as the per-handle .js endpoint the
   token-less path already trusted — but for the whole grip catalog in ~2-4
   requests instead of one request per recommended product.

   This module fetches those grip collections once (at quiz mount, in the
   background) and fills the SAME structures the Storefront batch would have:
     - GQ_VARIANT_AVAIL[variantId] = {available,price,compareAt,handle}
       so gqEntryFullyBatched()/gqBatchedDescriptorsForEntry() shortcut exactly
       as they do with a real token — no scoring, ranking, color, size, price,
       or format code changes.
     - GQ_BULK_PUBLISHED[handle] = true, consulted by the publication gate as an
       additional authoritative "published" source alongside the sitemap index.

   Availability is written through the SAME 5-minute sessionStorage cache as the
   Storefront batch, so the worst-case staleness window is unchanged. Every
   404 / sold-out / not-live gate downstream is untouched and still fails closed:
   a handle the bulk feed does not cover simply takes the existing per-handle
   .js + public-page path.
   ------------------------------------------------------------------ */
var GQ_BULK_PUBLISHED={};              /* handle -> true (published in a grip collection) */
var GQ_BULK_STATE={promise:null,done:false,loadedAt:0};
var GQ_BULK_PAGE_LIMIT=250;            /* products per page (Shopify max) */
var GQ_BULK_MAX_PAGES=8;               /* safety ceiling per collection (2000 products) */
function gqBulkDisabled(){try{return window.GRIP_QUIZ_BULK_DISABLE===true;}catch(e){return false;}}
function gqBulkCollectionHandles(){
  try{
    var c=window.GRIP_QUIZ_BULK_COLLECTIONS;
    if(Array.isArray(c)&&c.length)return c.slice();
  }catch(e){}
  return ['golf-grips','putter-grips'];
}
/* Ingest one collection products.json product array into the shared
   availability + publication maps. Returns the number of products ingested. */
function gqIngestBulkProducts(products){
  var n=0;
  (products||[]).forEach(function(p){
    if(!p||!p.handle)return;
    var handle=String(p.handle);
    /* Presence in a published Online-Store collection feed IS publication.
       published_at is additionally required so a scheduled/hidden product that
       still appears in a preview feed is never treated as live. */
    if(p.published_at&&!GQ_KNOWN_PUBLIC_404_HANDLES[handle])GQ_BULK_PUBLISHED[handle]=true;
    (p.variants||[]).forEach(function(v){
      if(!v||v.id==null)return;
      var id=String(v.id);
      var price=(v.price!=null&&v.price!=='')?Number(v.price):null;
      var comp=(v.compare_at_price!=null&&v.compare_at_price!=='')?Number(v.compare_at_price):null;
      GQ_VARIANT_AVAIL[id]={
        available:(v.available!==false)&&(p.published_at?true:false)&&!GQ_KNOWN_PUBLIC_404_HANDLES[handle],
        price:(price!=null&&!isNaN(price))?price:null,
        compareAt:(comp!=null&&!isNaN(comp)&&comp>(price||0))?comp:null,
        handle:handle
      };
    });
    n++;
  });
  return n;
}
function gqBulkFetchCollectionPage(handle,page){
  var url='/collections/'+encodeURIComponent(handle)+'/products.json?limit='+GQ_BULK_PAGE_LIMIT+'&page='+page;
  return fetchWithTimeout(url,{method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}},6000)
    .then(function(r){if(!r.ok)throw new Error('bulk products.json '+r.status);return r.json();})
    .then(function(data){return (data&&data.products)||[];});
}
function gqBulkFetchCollection(handle){
  function page(n){
    return gqBulkFetchCollectionPage(handle,n).then(function(products){
      var got=gqIngestBulkProducts(products);
      if(products.length>=GQ_BULK_PAGE_LIMIT&&n<GQ_BULK_MAX_PAGES)return page(n+1);
      return got;
    }).catch(function(){return 0;});
  }
  return page(1);
}
/* Fire-and-forget bulk warm-up. Never rejects. Cached for the life of the page;
   the availability values it writes still respect the 5-minute session cache. */
function gqBulkPrime(){
  if(gqBulkDisabled())return Promise.resolve(false);
  if(GQ_BULK_STATE.done)return Promise.resolve(true);
  if(GQ_BULK_STATE.promise)return GQ_BULK_STATE.promise;
  gqReadVariantAvailSessionCache();
  var handles=gqBulkCollectionHandles();
  GQ_BULK_STATE.promise=Promise.all(handles.map(function(h){return gqBulkFetchCollection(h);}))
    .then(function(){
      GQ_BULK_STATE.done=true;GQ_BULK_STATE.loadedAt=Date.now();
      try{gqWriteVariantAvailSessionCache();}catch(e){}
      /* Seed the publication index too, so a cold results screen can gate 404s
         locally even before the sitemap loader finishes. Merges, never shrinks. */
      try{
        var seed={};for(var h in GQ_BULK_PUBLISHED){if(GQ_BULK_PUBLISHED[h])seed[h]=true;}
        if(gqPublicationMapSize(seed)){
          if(GQ_PUBLICATION_INDEX.loaded&&GQ_PUBLICATION_INDEX.handles){
            for(var k in seed)GQ_PUBLICATION_INDEX.handles[k]=true;
          }else{
            gqFinishPublicationIndex(seed,'products-json');
            GQ_PUBLICATION_INDEX.promise=Promise.resolve(GQ_PUBLICATION_INDEX.handles);
          }
        }
      }catch(e){}
      return true;
    })
    .catch(function(){GQ_BULK_STATE.done=true;return false;});
  return GQ_BULK_STATE.promise;
}

var GQ_PUBLIC_STOREFRONT_ORIGIN=(window.GRIP_QUIZ_PUBLIC_STOREFRONT_ORIGIN||'https://www.grips4less.com').replace(/\/$/,'');
var GQ_KNOWN_PUBLIC_404_HANDLES={
  'iomic-sticky-mid-grip-grip-bundle-set':true,
  'super-stroke-usa-commemorative-legacy-3-0-putter-grip-with-counter-core-50g-weight':true
};

/* ------------------------------------------------------------------
   PUBLICATION INDEX

   A Shopify theme preview can expose old product JSON even after the public
   product page has been unpublished and now returns 404. Checking only
   /products/{handle}.js on the preview origin therefore is not enough.

   Shopify's generated product sitemap represents the public Online Store
   catalog. Load it once, cache the published handles for a few minutes, and
   require a handle to exist there before trusting preview-origin product JSON.
   On the real storefront this also gives us a cheap publication check before
   requesting every product's full JSON.
   ------------------------------------------------------------------ */
var GQ_PUBLICATION_INDEX={promise:null,loaded:false,failed:false,handles:null,source:'',loadedAt:0};
var GQ_PUBLICATION_CACHE_KEY='gq_published_product_handles_v22';
var GQ_PUBLICATION_CACHE_MS=60*60*1000;
function gqIsThemePreview(){
  try{
    return !!(window.Shopify&&window.Shopify.designMode)||/\.myshopify\.com$/i.test((window.location&&window.location.hostname)||'')||/[?&](?:preview_theme_id|oseid)=/i.test((window.location&&window.location.search)||'');
  }catch(e){return false;}
}
function gqProductHandleFromLoc(loc){
  var m=String(loc||'').match(/\/products\/([^/?#]+)/i);
  if(!m)return '';
  try{return decodeURIComponent(m[1]);}catch(e){return m[1];}
}
function gqParseSitemapLocs(text){
  try{
    var doc=(new DOMParser()).parseFromString(String(text||''),'application/xml');
    if(doc.getElementsByTagName('parsererror').length)return [];
    return Array.prototype.slice.call(doc.getElementsByTagName('loc')).map(function(n){return String(n.textContent||'').trim();}).filter(Boolean);
  }catch(e){return [];}
}
function gqSameOriginPath(url){
  try{var u=new URL(url,window.location.href);return u.pathname+(u.search||'');}catch(e){return String(url||'');}
}
function gqFetchText(url,ms){
  return fetchWithTimeout(url,{method:'GET',credentials:'same-origin',headers:{Accept:'application/xml,text/xml,text/plain,*/*'}},ms||5000)
    .then(function(r){if(!r.ok)throw new Error('sitemap fetch failed: '+r.status);return r.text();});
}
function gqPublicationMapFromLocs(locs){
  var map={};
  (locs||[]).forEach(function(loc){var h=gqProductHandleFromLoc(loc);if(h&&!GQ_KNOWN_PUBLIC_404_HANDLES[h])map[h]=true;});
  return map;
}
function gqPublicationMapSize(map){var n=0;for(var k in (map||{}))if(Object.prototype.hasOwnProperty.call(map,k)&&map[k])n++;return n;}
function gqReadPublicationCache(){
  try{
    var raw=localStorage.getItem(GQ_PUBLICATION_CACHE_KEY)||sessionStorage.getItem(GQ_PUBLICATION_CACHE_KEY);if(!raw)return null;
    var parsed=JSON.parse(raw);
    if(!parsed||!parsed.ts||Date.now()-parsed.ts>GQ_PUBLICATION_CACHE_MS||!Array.isArray(parsed.handles)||!parsed.handles.length)return null;
    var map={};parsed.handles.forEach(function(h){if(h&&!GQ_KNOWN_PUBLIC_404_HANDLES[h])map[h]=true;});
    return map;
  }catch(e){return null;}
}
function gqStorePublicationCache(map){
  try{var payload=JSON.stringify({ts:Date.now(),handles:Object.keys(map||{})});localStorage.setItem(GQ_PUBLICATION_CACHE_KEY,payload);sessionStorage.setItem(GQ_PUBLICATION_CACHE_KEY,payload);}catch(e){}
}
function gqFinishPublicationIndex(map,source){
  if(!map||!gqPublicationMapSize(map))throw new Error('empty publication index');
  Object.keys(GQ_KNOWN_PUBLIC_404_HANDLES).forEach(function(h){delete map[h];});
  GQ_PUBLICATION_INDEX.loaded=true;GQ_PUBLICATION_INDEX.failed=false;GQ_PUBLICATION_INDEX.handles=map;GQ_PUBLICATION_INDEX.source=source||'sitemap';GQ_PUBLICATION_INDEX.loadedAt=Date.now();
  gqStorePublicationCache(map);
  return map;
}
function loadPublishedHandleIndex(){
  if(GQ_PUBLICATION_INDEX.loaded&&GQ_PUBLICATION_INDEX.handles)return Promise.resolve(GQ_PUBLICATION_INDEX.handles);
  if(GQ_PUBLICATION_INDEX.promise)return GQ_PUBLICATION_INDEX.promise;
  var cached=gqReadPublicationCache();
  if(cached){GQ_PUBLICATION_INDEX.promise=Promise.resolve(gqFinishPublicationIndex(cached,'session-cache'));return GQ_PUBLICATION_INDEX.promise;}

  function fromRootSitemap(){
    return gqFetchText('/sitemap.xml',5000).then(function(rootText){
      var rootLocs=gqParseSitemapLocs(rootText);
      var direct=gqPublicationMapFromLocs(rootLocs);
      var productMaps=rootLocs.filter(function(loc){return /sitemap_products_/i.test(loc);});
      if(!productMaps.length&&gqPublicationMapSize(direct))return gqFinishPublicationIndex(direct,'sitemap-root');
      if(!productMaps.length)throw new Error('no product sitemap links');
      return Promise.all(productMaps.slice(0,50).map(function(loc){return gqFetchText(gqSameOriginPath(loc),5000).then(gqParseSitemapLocs);})).then(function(groups){
        var all=[];groups.forEach(function(g){all=all.concat(g||[]);});
        return gqFinishPublicationIndex(gqPublicationMapFromLocs(all),'sitemap-products');
      });
    });
  }
  function fromDirectProductSitemap(){
    return gqFetchText('/sitemap_products_1.xml',5000).then(function(text){
      return gqFinishPublicationIndex(gqPublicationMapFromLocs(gqParseSitemapLocs(text)),'sitemap-products-direct');
    });
  }

  GQ_PUBLICATION_INDEX.promise=fromRootSitemap().catch(fromDirectProductSitemap).catch(function(){
    GQ_PUBLICATION_INDEX.loaded=false;GQ_PUBLICATION_INDEX.failed=true;GQ_PUBLICATION_INDEX.handles=null;GQ_PUBLICATION_INDEX.source='unavailable';
    return null;
  });
  return GQ_PUBLICATION_INDEX.promise;
}
function publishedHandleStatusSync(handle){
  if(!handle||GQ_KNOWN_PUBLIC_404_HANDLES[handle])return false;
  if(GQ_BULK_PUBLISHED[handle])return true;
  if(GQ_PUBLICATION_INDEX.loaded&&GQ_PUBLICATION_INDEX.handles)return !!GQ_PUBLICATION_INDEX.handles[handle];
  return null;
}
function getPublishedHandleStatus(handle){
  if(!handle||GQ_KNOWN_PUBLIC_404_HANDLES[handle])return Promise.resolve(false);
  if(GQ_BULK_PUBLISHED[handle])return Promise.resolve(true);
  return loadPublishedHandleIndex().then(function(map){
    if(map&&map[handle])return true;
    /* The sitemap index may have resolved before the bulk grip feed finished.
       Re-check the bulk set so a grip published only in the collection feed is
       not wrongly failed to the slow public-HTML path. */
    if(GQ_BULK_PUBLISHED[handle])return true;
    return map?!!map[handle]:null;
  });
}

/* ------------------------------------------------------------------
   PUBLIC PRODUCT PAGE VERIFICATION (v21)

   Important: Shopify can still expose a stale product through Storefront
   GraphQL or /products/{handle}.js even when the normal customer-facing HTML
   product page is a 404. Therefore API availability is never allowed to prove
   publication by itself.

   Fast path: a handle present in Shopify's generated public product sitemap is
   considered published. Slow path: when a handle is absent from the sitemap,
   verify the actual public HTML page. On the real www.grips4less.com storefront
   this request is same-origin and its HTTP status is authoritative. In theme
   preview, cross-origin HTML checks may be blocked by CORS; those unverified
   handles fail closed instead of being recommended.
   ------------------------------------------------------------------ */
function gqPublicPageCacheKey(handle){return 'page:'+GQ_PUBLIC_STOREFRONT_ORIGIN+':'+handle;}
function gqCurrentOriginIsPublicStore(){
  try{return String((window.location&&window.location.origin)||'').replace(/\/$/,'')===GQ_PUBLIC_STOREFRONT_ORIGIN;}catch(e){return false;}
}
function gqProductPageHandleFromUrl(url){
  try{return gqProductHandleFromLoc(new URL(url,window.location.href).href);}catch(e){return gqProductHandleFromLoc(url);}
}
function gqHtmlLooksLike404(html){
  var text=String(html||'');
  var title=(text.match(/<title[^>]*>([\s\S]*?)<\/title>/i)||[])[1]||'';
  var bodyClass=(text.match(/<body[^>]*class=["']([^"']*)["']/i)||[])[1]||'';
  return /(?:^|\b)(?:404|page\s+not\s+found|not\s+found)(?:\b|$)/i.test(title.replace(/<[^>]+>/g,' '))||
    /(?:template|page|type)[-_ ]?404|\b404\b/i.test(bodyClass)||
    /id=["']shopify-section-template--[^"']*__main["'][^>]*>[\s\S]{0,5000}\b404\b/i.test(text);
}
function gqStorePublicPageStatus(handle,status){
  GQ_STOCK_CACHE[gqPublicPageCacheKey(handle)]=status;
  return status;
}
function publicProductPageStatusSync(handle){
  if(!handle||GQ_KNOWN_PUBLIC_404_HANDLES[handle])return false;
  var cached=GQ_STOCK_CACHE[gqPublicPageCacheKey(handle)];
  if(cached&&typeof cached.ok==='boolean')return cached.ok;
  var sitemap=publishedHandleStatusSync(handle);
  return sitemap===true?true:null;
}
function fetchPublicProductPageAt(handle,url,credentials){
  return fetchWithTimeout(url,{
    method:'GET',credentials:credentials||'omit',redirect:'follow',cache:'no-store',
    headers:{Accept:'text/html,application/xhtml+xml'}
  },4500).then(function(r){
    if(r.status===404||r.status===410)return {ok:false,status:r.status,source:'public-html'};
    if(!r.ok)return {ok:null,status:r.status,source:'public-html-error'};
    var finalHandle=gqProductPageHandleFromUrl(r.url||url);
    return r.text().then(function(html){
      if(!finalHandle||gqHtmlLooksLike404(html))return {ok:false,status:r.status,source:'public-html-soft-404'};
      /* A redirect to a different product can select the wrong grip/variant.
         Treat it as stale rather than silently sending the shopper elsewhere. */
      if(finalHandle!==handle)return {ok:false,status:r.status,source:'public-html-redirect',redirectHandle:finalHandle};
      return {ok:true,status:r.status,source:'public-html',handle:finalHandle};
    });
  });
}
function verifyPublicProductPage(handle){
  if(!handle||GQ_KNOWN_PUBLIC_404_HANDLES[handle])return Promise.resolve(gqStorePublicPageStatus(handle,{ok:false,status:404,source:'known-blocklist'}));
  var key=gqPublicPageCacheKey(handle);
  if(Object.prototype.hasOwnProperty.call(GQ_STOCK_CACHE,key))return Promise.resolve(GQ_STOCK_CACHE[key]);

  return gqShareInflight('verify:'+key,function(){
    return getPublishedHandleStatus(handle).then(function(inSitemap){
      if(inSitemap===true)return gqStorePublicPageStatus(handle,{ok:true,status:200,source:GQ_PUBLICATION_INDEX.source||'sitemap'});

      /* v35 speed fix: Shopify's product sitemap is the authoritative list of
         products published to the Online Store. When it has loaded successfully
         and a handle is DEFINITIVELY absent (inSitemap===false, not merely
         unknown/null), the product is not live — so we fail it closed WITHOUT a
         per-handle HTML 404 fetch. Those fetches (4.5s timeout each) were the
         dominant results-screen cost. This never shows a 404/unpublished
         product; the only trade-off is that a product published so recently it
         is not yet in the regenerated sitemap is treated as not-live until the
         sitemap catches up. Set window.GRIP_QUIZ_TRUST_SITEMAP=false to restore
         the per-handle HTML confirmation for sitemap-absent handles. */
      var trustSitemap=(function(){try{return window.GRIP_QUIZ_TRUST_SITEMAP!==false;}catch(e){return true;}})();
      if(inSitemap===false&&trustSitemap&&GQ_PUBLICATION_INDEX.loaded&&!GQ_PUBLICATION_INDEX.failed&&GQ_PUBLICATION_INDEX.handles){
        return gqStorePublicPageStatus(handle,{ok:false,status:404,source:'sitemap-absent'});
      }

      var publicUrl=GQ_PUBLIC_STOREFRONT_ORIGIN+'/products/'+encodeURIComponent(handle);
      var samePublicOrigin=gqCurrentOriginIsPublicStore();
      return fetchPublicProductPageAt(handle,publicUrl,samePublicOrigin?'same-origin':'omit')
        .then(function(status){
          if(status&&status.ok===true)return gqStorePublicPageStatus(handle,status);
          if(status&&status.ok===false)return gqStorePublicPageStatus(handle,status);
          return gqStorePublicPageStatus(handle,{ok:false,status:status&&status.status||0,source:'public-html-unverified'});
        })
        .catch(function(){
          return gqStorePublicPageStatus(handle,{ok:false,status:0,source:samePublicOrigin?'public-html-fetch-failed':'preview-unverified'});
        });
    });
  });
}
function gqProductJsonCacheKey(handle){return 'json:'+GQ_PUBLIC_STOREFRONT_ORIGIN+':'+handle;}
function fetchProductJsonAt(url,credentials){
  return fetchWithTimeout(url,{method:'GET',credentials:credentials||'omit',cache:'no-store'},3500).then(function(r){
    if(r.status===404||r.status===410)return {__missing:true,__verifiedPublic404:true};
    if(!r.ok)throw new Error('product json failed');
    return r.json();
  });
}
function fetchProductJson(handle){
  var cacheKey=gqProductJsonCacheKey(handle);
  if(Object.prototype.hasOwnProperty.call(GQ_STOCK_CACHE,cacheKey))return Promise.resolve(GQ_STOCK_CACHE[cacheKey]);
  function store(product){GQ_STOCK_CACHE[cacheKey]=product;return product;}
  function missing(extra){var out={__missing:true};if(extra)for(var k in extra)out[k]=extra[k];return store(out);}
  if(GQ_KNOWN_PUBLIC_404_HANDLES[handle])return Promise.resolve(missing({__verifiedPublic404:true,__publicationSource:'known-blocklist'}));

  return gqShareInflight('json:'+cacheKey,function(){
    return verifyPublicProductPage(handle).then(function(pageStatus){
      if(!pageStatus||pageStatus.ok!==true)return missing({__verifiedPublic404:true,__publicationSource:(pageStatus&&pageStatus.source)||'public-page'});

      var publicUrl=GQ_PUBLIC_STOREFRONT_ORIGIN+'/products/'+encodeURIComponent(handle)+'.js';
      var sameOriginUrl='/products/'+encodeURIComponent(handle)+'.js';
      var publicIsCurrent=gqCurrentOriginIsPublicStore();

      return fetchProductJsonAt(publicUrl,publicIsCurrent?'same-origin':'omit')
        .then(function(product){return store(product);})
        .catch(function(){
          if(publicIsCurrent)return missing({__publicFetchFailed:true});
          return fetchProductJsonAt(sameOriginUrl,'same-origin').then(store).catch(function(){return missing({__sameOriginFetchFailed:true});});
        });
    });
  });
}
function storefrontProductAvailable(product,variantId){
  if(!product)return null;
  var edges=(product.variants&&product.variants.edges)||[];
  if(variantId&&edges.length){
    for(var i=0;i<edges.length;i++){var n=edges[i].node;if(String(variantIdFromGid(n.id))===String(variantId))return n.availableForSale!==false;}
  }
  if(product.availableForSale===false)return false;
  if(edges.length)return edges.some(function(e){return e.node&&e.node.availableForSale!==false;});
  return true;
}
function productJsonAvailable(product,variantId){
  if(!product)return null;
  if(product.__missing===true)return false;

  var variants=product.variants||[];
  if(variantId&&variants.length){
    for(var i=0;i<variants.length;i++){
      if(String(variants[i].id)===String(variantId))return variants[i].available!==false;
    }

    /* If the exact variant from grip-specs.js is no longer on the live product,
       do not show that format/link. It would lead to a bad variant or wrong purchase path. */
    return false;
  }

  if(product.available===false)return false;
  if(variants.length)return variants.some(function(v){return v.available!==false;});
  return true;
}
/* ------------------------------------------------------------------
   LIVE PRICE EXTRACTION
   Pull the current selling price (and any sale/compare-at price) straight
   from the live store response, so the quiz never relies on the cached
   grip-specs.js price. Prices can change and products can be on sale.
   - Storefront GraphQL: price.amount is a decimal string (e.g. "12.99").
   - /products/{handle}.js: price + compare_at_price are integer CENTS.
   Returns {price:Number, compareAt:Number|null} or null when unavailable.
   ------------------------------------------------------------------ */
function moneyNum(x){if(x==null)return null;var n=Number(x);return isNaN(n)?null:n;}
function priceObj(price,compareAt){
  if(price==null)return null;
  return {price:price,compareAt:(compareAt!=null&&compareAt>price)?compareAt:null};
}
function extractStorefrontPrice(product,variantId){
  if(!product)return null;
  var edges=(product.variants&&product.variants.edges)||[];
  function fromNode(n){
    if(!n)return null;
    var p=moneyNum(n.price&&n.price.amount);
    var c=moneyNum(n.compareAtPrice&&n.compareAtPrice.amount);
    return priceObj(p,c);
  }
  if(variantId&&edges.length){
    for(var i=0;i<edges.length;i++){var n=edges[i].node;if(String(variantIdFromGid(n.id))===String(variantId))return fromNode(n);}
    return null; /* the exact variant is no longer live — don't show a stale price */
  }
  /* No specific variant id: use the lowest live, available variant price. */
  var best=null;
  for(var j=0;j<edges.length;j++){var nn=edges[j].node;if(nn&&nn.availableForSale!==false){var pr=fromNode(nn);if(pr&&(best==null||pr.price<best.price))best=pr;}}
  return best;
}
function extractJsonPrice(product,variantId){
  if(!product||product.__missing===true)return null;
  var variants=product.variants||[];
  function fromV(v){
    if(!v)return null;
    var p=v.price!=null?moneyNum(v.price)/100:null;            /* .js prices are in cents */
    var c=v.compare_at_price!=null?moneyNum(v.compare_at_price)/100:null;
    return priceObj(p,c);
  }
  if(variantId&&variants.length){
    for(var i=0;i<variants.length;i++){if(String(variants[i].id)===String(variantId))return fromV(variants[i]);}
    return null;
  }
  var best=null;
  for(var j=0;j<variants.length;j++){var v=variants[j];if(v&&v.available!==false){var pr=fromV(v);if(pr&&(best==null||pr.price<best.price))best=pr;}}
  return best;
}
function isSpecVariantLiveAvailable(v){
  var handle=getProductHandleFromUrl(v&&v.url);
  var requestedVariantId=getVariantIdFromUrl(v&&v.url);
  var embedded=embeddedShopifyVariants(v);

  if(!handle)return Promise.resolve({ok:false,live:null,variantId:'',variantOptions:[],exactVariants:[]});

  /* v21: publication must be proven before either Storefront GraphQL or the
     Ajax product endpoint is allowed to qualify a variant. This closes the
     exact loophole that let 404 products appear in style recommendations. */
  return verifyPublicProductPage(handle).then(function(pageStatus){
    if(!pageStatus||pageStatus.ok!==true)return {ok:false,live:null,variantId:'',variantOptions:[],exactVariants:[],publicPageStatus:pageStatus||null};

    /* v33 fast read: when every embedded variant this entry needs is already
       resolved in the batched availability map, answer from it instead of
       issuing a per-handle Storefront query. Publication has already passed
       above, so this only substitutes the in-stock/price read — identical
       result shape and identical availableForSale semantics. */
    if(embedded.length&&gqEntryFullyBatched(v)){
      var bDescriptors=gqBatchedDescriptorsForEntry(v);
      var bExact=reconcileEmbeddedShopifyVariants(v,bDescriptors);
      if(!bExact.length)return {ok:false,live:null,variantId:'',variantOptions:bDescriptors,exactVariants:[],publicPageStatus:pageStatus};
      var bChosen=(requestedVariantId&&bExact.filter(function(x){return String(x.id)===String(requestedVariantId);})[0])||bExact[0];
      return {ok:true,live:{price:bChosen.price,compareAt:bChosen.compareAt},variantId:bChosen.id,variantOptions:bDescriptors,exactVariants:bExact,publicPageStatus:pageStatus};
    }

    return fetchStorefrontProduct(handle).then(function(sfProduct){
      var sfDescriptors=liveVariantDescriptorsFromStorefront(sfProduct);
      var sfExact=reconcileEmbeddedShopifyVariants(v,sfDescriptors);
      if(sfProduct){
        if(embedded.length){
          if(!sfExact.length)return {ok:false,live:null,variantId:'',variantOptions:sfDescriptors,exactVariants:[]};
          var sfChosen=(requestedVariantId&&sfExact.filter(function(x){return String(x.id)===String(requestedVariantId);})[0])||sfExact[0];
          return {ok:true,live:{price:sfChosen.price,compareAt:sfChosen.compareAt},variantId:sfChosen.id,variantOptions:sfDescriptors,exactVariants:sfExact,publicPageStatus:pageStatus};
        }
        var sfVariantId=requestedVariantId||resolveLiveVariantId(sfDescriptors,v,'');
        var sfOk=storefrontProductAvailable(sfProduct,sfVariantId);
        if(sfOk!==null)return {ok:sfOk,live:extractStorefrontPrice(sfProduct,sfVariantId),variantId:sfVariantId,variantOptions:sfDescriptors,exactVariants:[],publicPageStatus:pageStatus};
      }

      return fetchProductJson(handle).then(function(jsonProduct){
        var jsonDescriptors=liveVariantDescriptorsFromJson(jsonProduct);
        var jsonExact=reconcileEmbeddedShopifyVariants(v,jsonDescriptors);
        if(embedded.length){
          if(!jsonExact.length)return {ok:false,live:null,variantId:'',variantOptions:jsonDescriptors,exactVariants:[]};
          var jsonChosen=(requestedVariantId&&jsonExact.filter(function(x){return String(x.id)===String(requestedVariantId);})[0])||jsonExact[0];
          return {ok:true,live:{price:jsonChosen.price,compareAt:jsonChosen.compareAt},variantId:jsonChosen.id,variantOptions:jsonDescriptors,exactVariants:jsonExact,publicPageStatus:pageStatus};
        }
        var jsonVariantId=requestedVariantId||resolveLiveVariantId(jsonDescriptors,v,'');
        var jsonOk=productJsonAvailable(jsonProduct,jsonVariantId);
        return {ok:(jsonOk===null?false:jsonOk),live:extractJsonPrice(jsonProduct,jsonVariantId),variantId:jsonVariantId,variantOptions:jsonDescriptors,exactVariants:[],publicPageStatus:pageStatus};
      });
    });
  });
}
function gqMaterializeLiveSpecVariant(v,res){
  if(!v||!res||!res.ok)return null;
  var out={};for(var k in v){if(Object.prototype.hasOwnProperty.call(v,k))out[k]=v[k];}
  out._gqLiveVariants=res.variantOptions||[];
  out._gqExactShopifyVariants=res.exactVariants&&res.exactVariants.length?res.exactVariants:embeddedShopifyVariants(v).filter(function(x){return x.available!==false;});
  if(res.variantId)out.url=withSelectedVariant(out.url,res.variantId);
  if(res.live&&res.live.price!=null){
    out.price=res.live.price;
    out.compareAt=res.live.compareAt!=null?res.live.compareAt:null;
    out.livePrice=true;
  }
  return out;
}
function liveVariantsForSize(spec,t){
  var raw=variantsForSize(spec,t);
  if(!raw.length&&spec&&spec.variants)raw=spec.variants;
  return Promise.all(raw.map(function(v){return isSpecVariantLiveAvailable(v).then(function(res){return gqMaterializeLiveSpecVariant(v,res);});}))
    .then(function(list){return list.filter(Boolean);});
}

/* v22 fast-first-result path.
   The full purchase-option builder validates every single/bundle/kit handle
   before rendering. That is ideal for final controls but unnecessarily slows
   the first recommendation. This path follows the already-ranked product list,
   verifies one strong primary purchasing destination per model, and renders as
   soon as enough legitimate products are found. All remaining colors and pack
   formats are hydrated in the background with buildResultLive(). */
function gqPrimaryVariantCandidates(spec,t,wantSet){
  var raw=variantsForSize(spec,t);
  if(!raw.length&&spec&&spec.variants)raw=spec.variants.slice();
  raw=(raw||[]).filter(Boolean);
  var formats=buildFormats(spec,t,wantSet);
  var ordered=[],seen=[];
  function add(v){if(!v||seen.indexOf(v)>=0)return;seen.push(v);ordered.push(v);}
  (formats||[]).forEach(function(f){
    var fh=getProductHandleFromUrl(f.url),fid=getVariantIdFromUrl(f.url);
    var matches=raw.filter(function(v){
      if(fh&&getProductHandleFromUrl(v.url)!==fh)return false;
      var vid=getVariantIdFromUrl(v.url);
      return !fid||!vid||String(fid)===String(vid);
    });
    matches.sort(function(a,b){
      if(preferVariantCandidate(a,b,spec,stylePriorityActive(ans)))return -1;
      if(preferVariantCandidate(b,a,spec,stylePriorityActive(ans)))return 1;
      return 0;
    });
    matches.forEach(add);
  });
  raw.forEach(add);
  return ordered.slice(0,12);
}
function buildPrimaryProductOptionLive(spec,t,wantSet){
  var preferStyle=stylePriorityActive(ans),candidates=gqPrimaryVariantCandidates(spec,t,wantSet),BATCH=2;
  function tryBatch(start){
    if(start>=candidates.length)return Promise.resolve({formats:[],colors:[],pending:false});
    var slice=candidates.slice(start,start+BATCH);
    return Promise.all(slice.map(function(v){return isSpecVariantLiveAvailable(v).then(function(res){return gqMaterializeLiveSpecVariant(v,res);});})).then(function(list){
      var live=list.filter(Boolean)[0];
      if(!live)return tryBatch(start+BATCH);
      var formats=buildFormatsFromVariants([live],wantSet,spec,preferStyle);
      if(!formats.length)return tryBatch(start+BATCH);
      var colors=buildColorOptionsFromVariants([live],wantSet,spec,preferStyle,formats);
      return {formats:formats,colors:colors,pending:true};
    });
  }
  return tryBatch(0);
}
function buildFormatsFromVariants(vs,wantSet,spec,preferStyle){
  var by={};
  preferStyle=!!preferStyle;
  vs.forEach(function(v){var k=v.format||'single';if(preferVariantCandidate(v,by[k],spec,preferStyle))by[k]=v;});
  var list=Object.keys(by).map(function(k){var m=fmtMeta(k);m.url=normalizeProductUrl(by[k].url,spec,by[k]);m.price=by[k].price;m.compareAt=by[k].compareAt!=null?by[k].compareAt:null;m.livePrice=!!by[k].livePrice;m.styleScore=variantStyleScore(by[k],spec);return m;});
  list.sort(function(a,b){
    if(preferStyle){
      var ds=(b.styleScore||0)-(a.styleScore||0);
      if(ds)return ds;
    }
    if(wantSet)return (b.rank-a.rank)||(b.n-a.n)||((a.price||0)-(b.price||0));
    return (a.rank-b.rank)||(a.n-b.n)||((a.price||0)-(b.price||0));
  });
  if(list.length){var p=list[0];if(wantSet)p=list.filter(function(x){return /kit/i.test(x.key);})[0]||list.filter(function(x){return x.rank===3;})[0]||list[0];list.forEach(function(x){x.primary=(x===p);});list.sort(function(a,b){return (b.primary?1:0)-(a.primary?1:0);});}
  return list;
}
function canonicalColorKey(label){
  var text=String(label||'').toLowerCase().replace(/\bgray\b/g,'grey').replace(/\bcolour\b/g,'color').replace(/[^a-z0-9]+/g,' ').trim();
  if(!text)return '';
  /* Treat equivalent plain color combinations as the same option regardless of
     spelling or order: Gray = Grey, and White / Black = Black / White. Keep
     descriptive design names intact so special editions are not collapsed. */
  var design=GQ_STYLE_KEYWORD_RE.test(text)||/camo|army|topograph|gaucho|guacho|shamrock|marvel|star wars|darth|hulk|spider|iron man|flag|pattern|print/i.test(text);
  var colors=colorWordsInText(text).map(function(c){return c==='gray'?'grey':c;});
  var residue=text.replace(/\b(?:red|blue|green|orange|yellow|gold|silver|pink|purple|violet|navy|teal|aqua|lime|copper|brown|tan|white|grey|gray|black|dark|light|and|or|color)\b/g,' ').replace(/\s+/g,' ').trim();
  if(!design&&!residue&&colors.length){
    var seen={};colors=colors.filter(function(c){if(seen[c])return false;seen[c]=1;return true;}).sort();
    return ((/\bdark\b/.test(text)?'dark-':'')+(/\blight\b/.test(text)?'light-':'')+colors.join('|'));
  }
  return text;
}
function inferredUnlabeledColorLabel(vs,spec){
  var found={},ordered=[];
  function add(label){var key=canonicalColorKey(label);if(!key||key==='standard color'||found[key])return;found[key]=label;ordered.push(key);}
  (vs||[]).forEach(function(v){meaningfulVariantColorLabels(v).forEach(add);});
  if(ordered.length===1)return found[ordered[0]];

  /* Family-level colors can belong to only one size (CP2 Wrap Pink was sold in
     Standard/Undersize while the unlabeled Midsize page was Blue). Prefer a
     curated size-specific default and never copy a global family color into an
     unlabeled size. If no size-specific color is known, "Standard color" is
     safer than showing a confidently wrong color. */
  if(!ordered.length&&spec&&spec.default_color_by_size){
    var size='';
    (vs||[]).some(function(v){
      var sizes=Array.isArray(v&&v.size)?v.size:[];
      if(sizes.length===1){size=sizes[0];return true;}
      return false;
    });
    if(size&&spec.default_color_by_size[size])return spec.default_color_by_size[size];
  }
  return '';
}
function colorOptionStyleScore(label){
  var text=String(label||'').toLowerCase(),pts=0;
  if(GQ_STYLE_KEYWORD_RE.test(text)||/camo|army|topograph|gaucho|guacho|shamrock|marvel|star wars|darth|hulk|spider|iron man|usa|team|flag|pattern|print/i.test(text))pts+=45;
  var colors=colorWordsInText(text),nonBlack=colors.filter(function(c){return c!=='black';});
  pts+=Math.min(nonBlack.length,3)*12;
  if(colors.length===1&&colors[0]==='black')pts-=10;
  return pts;
}
function swatchCssForColorLabel(label){
  var map={red:'#d83a3a',blue:'#2f6edb',green:'#2e9b57',orange:'#ef8b2c',yellow:'#e6c52f',gold:'#c79a2b',silver:'#b9bdc3',pink:'#eb78a8',purple:'#8156c9',violet:'#7751bd',navy:'#223b67',teal:'#2f9999',aqua:'#55bfc7',lime:'#84bd36',copper:'#b96f45',brown:'#79513d',tan:'#c7a97d',white:'#f7f7f7',grey:'#888',gray:'#888',black:'#171717'};
  var colors=colorWordsInText(String(label||'').toLowerCase()).map(function(c){return map[c];}).filter(Boolean);
  if(!colors.length)return 'background:linear-gradient(135deg,#f2f2f2 0%,#d8d8d8 100%)';
  if(colors.length===1)return 'background:'+colors[0];
  var stops=[];colors.slice(0,4).forEach(function(c,i,arr){var a=Math.round(i*100/arr.length),b=Math.round((i+1)*100/arr.length);stops.push(c+' '+a+'%',c+' '+b+'%');});
  return 'background:linear-gradient(135deg,'+stops.join(',')+')';
}
function buildColorOptionsFromVariants(vs,wantSet,spec,preferStyle,allFormats){
  var groups={},order=[],hasExact=false;
  function addVariant(label,v,exact){
    label=String(label||'').replace(/\s+/g,' ').trim();
    if(!label)return;
    var key=canonicalColorKey(label)||'standard-color';
    if(!groups[key]){groups[key]={key:key,label:label,variants:[],destinations:{}};order.push(key);}
    var colorVariant={};for(var vk in v){if(Object.prototype.hasOwnProperty.call(v,vk))colorVariant[vk]=v[vk];}
    if(exact){
      colorVariant.url=withSelectedVariant(v.url,exact.id);
      if(exact.price!=null)colorVariant.price=exact.price;
      if(exact.compareAt!=null)colorVariant.compareAt=exact.compareAt;
      colorVariant.livePrice=exact.price!=null;
      colorVariant._gqExactVariantId=String(exact.id);
    }else colorVariant.url=variantUrlForColor(v,label);
    colorVariant._gqColorLabel=label;
    var dest=getProductHandleFromUrl(colorVariant.url)+'::'+(getVariantIdFromUrl(colorVariant.url)||'page')+'::'+String(colorVariant.format||'single');
    if(groups[key].destinations[dest])return;
    groups[key].destinations[dest]=1;
    groups[key].variants.push(colorVariant);
  }

  /* Strict mode: every displayed color is tied to a distinct embedded Shopify
     variant ID. Pack formats are attached only when that exact color exists for
     that handle, so selecting Blue can never open a Black kit. */
  (vs||[]).forEach(function(v){
    var exact=exactColorVariantsForEntry(v);
    if(exact.length){
      hasExact=true;
      exact.forEach(function(x){addVariant(x.color,v,x);});
    }
  });

  if(!hasExact){
    var inferredDefault=inferredUnlabeledColorLabel(vs,spec);
    (vs||[]).forEach(function(v){
      var labels=meaningfulVariantColorLabels(v);
      /* Without exact IDs, only expose a label when the destination is
         unambiguous. Multiple labels on one page are hidden rather than guessed. */
      if(labels.length>1)labels=[];
      if(!labels.length)labels=[inferredDefault||'Standard color'];
      labels.forEach(function(label){addVariant(label,v,null);});
    });
  }

  var primaryUrl=((allFormats||[]).filter(function(f){return f.primary;})[0]||(allFormats||[])[0]||{}).url||'';
  var colors=order.map(function(key){
    var g=groups[key];
    var formats=buildFormatsFromVariants(g.variants,wantSet,spec,preferStyle);
    var primaryHandle=getProductHandleFromUrl(primaryUrl),primaryVariant=getVariantIdFromUrl(primaryUrl);
    var matchesPrimary=formats.some(function(f){
      if(f.url===primaryUrl)return true;
      return primaryHandle&&getProductHandleFromUrl(f.url)===primaryHandle&&primaryVariant&&getVariantIdFromUrl(f.url)===primaryVariant;
    });
    return {key:g.key,label:g.label,formats:formats,primary:matchesPrimary,styleScore:colorOptionStyleScore(g.label),swatch:swatchCssForColorLabel(g.label)};
  }).filter(function(c){return c.formats.length;});

  /* Final safety net: one concrete destination may belong to only one visible
     color. This catches incomplete legacy pages that expose several color
     labels but no distinct variant IDs. Prefer a named color over the generic
     "Standard color" label, then keep the stronger style label. */
  var destinationClaims={};
  colors.forEach(function(c){
    (c.formats||[]).forEach(function(f){
      var dest=getProductHandleFromUrl(f.url)+'::'+(getVariantIdFromUrl(f.url)||'page')+'::'+String(f.key||f.label||'');
      if(!destinationClaims[dest])destinationClaims[dest]=[];
      destinationClaims[dest].push({color:c,format:f});
    });
  });
  Object.keys(destinationClaims).forEach(function(dest){
    var claims=destinationClaims[dest];
    var unique={};claims.forEach(function(x){unique[x.color.key]=x.color;});
    var owners=Object.keys(unique).map(function(k){return unique[k];});
    if(owners.length<2)return;
    owners.sort(function(a,b){
      var as=a.label==='Standard color'?0:1,bs=b.label==='Standard color'?0:1;
      if(as!==bs)return bs-as;
      return (b.styleScore||0)-(a.styleScore||0);
    });
    var winner=owners[0];
    claims.forEach(function(x){if(x.color!==winner)x.color.formats=x.color.formats.filter(function(f){return f!==x.format;});});
  });
  colors=colors.filter(function(c){return c.formats.length;});
  if(colors.length&&!colors.some(function(c){return c.primary;}))colors[0].primary=true;
  colors.sort(function(a,b){
    if(a.primary!==b.primary)return a.primary?-1:1;
    if(preferStyle&&a.styleScore!==b.styleScore)return b.styleScore-a.styleScore;
    if(a.label==='Standard color'&&b.label!=='Standard color')return -1;
    if(b.label==='Standard color'&&a.label!=='Standard color')return 1;
    return a.label.localeCompare(b.label);
  });
  if(colors.length){var chosen=colors.filter(function(c){return c.primary;})[0]||colors[0];colors.forEach(function(c){c.primary=(c===chosen);});}
  return colors;
}
function buildProductOptionsLive(spec,t,wantSet){
  var preferStyle=stylePriorityActive(ans);
  return liveVariantsForSize(spec,t).then(function(vs){
    if(!vs.length)return {formats:[],colors:[]};
    var formats=buildFormatsFromVariants(vs,wantSet,spec,preferStyle);
    var colors=buildColorOptionsFromVariants(vs,wantSet,spec,preferStyle,formats);
    return {formats:formats,colors:colors};
  });
}
function buildFormatsLive(spec,t,wantSet){return buildProductOptionsLive(spec,t,wantSet).then(function(x){return x.formats;});}
/* 2026-07-09 fix: the comment below already claimed this prevented "3+
   products from the same brand," but it did not — it just stopped once
   `desired` (count+8) raw live-confirmed items were collected, with no check
   on whether those items were actually brand-diverse. Confirmed via a real
   live test (Case 3: large/tight/sweaty/corded/alignment=yes) that this let
   THREE Golf Pride ALIGN products (MCC CLASSIC ALIGN, MCC PLUS4 ALIGN, ALIGN
   Max Z) all land in one 5-item visible list — brand cap says max 2, but
   finalRecommendationList's cap-with-overflow-topup only has as many
   candidates to choose from as this function bothered to collect, and in a
   profile bucket where one brand has deep bench strength, the first ~13
   live-confirmed items can genuinely be 8+ of that one brand before a third
   distinct brand shows up. Now keeps walking (still bounded by the existing
   max=60 catalog-depth ceiling, so worst-case cost is unchanged) until the
   collected pool actually contains enough brand-diverse candidates to fill
   `count` visible slots at the real max-2-per-brand cap, not just enough raw
   count. */
function enoughBrandDiversity(items,count,maxPerBrand){
  var counts={},total=0;
  for(var i=0;i<items.length&&total<count;i++){
    var b=brandCapName(items[i]);
    if((counts[b]||0)<maxPerBrand){counts[b]=(counts[b]||0)+1;total++;}
  }
  return total>=count;
}
function getLiveRankedItems(ranked,target,wantSet,count){
  var firstSpec=ranked&&ranked[0]&&ranked[0].s;
  var valueMode=firstSpec&&firstSpec.type==='putter'
    ? ((putterScoringAnswers(ans)||{}).ppriority==='value')
    : ((clubScoringAnswers(ans)||{}).priority==='value');
  /* Value ranking needs a deeper pool than ordinary ranking because an
     inexpensive good-fit model may start below premium profile favorites.
     Thirty-six live candidates is a practical balance between accuracy and
     request time; normal paths retain the smaller count+8 pool. */
  var out=[],max=Math.min(ranked.length,valueMode?72:60),BATCH=6;
  var desired=valueMode?Math.min(max,36):Math.min(max,Math.max(count+8,count));
  function runBatch(start){
    if(start>=max)return Promise.resolve(out);
    if(out.length>=desired&&enoughBrandDiversity(out,count,2))return Promise.resolve(out);
    var slice=ranked.slice(start,Math.min(start+BATCH,max));
    return Promise.all(slice.map(function(item){
      return buildProductOptionsLive(item.s,target,wantSet).then(function(options){return {item:item,formats:options.formats,colors:options.colors};});
    })).then(function(res){
      res.forEach(function(r){
        if(r.formats.length)out.push({s:r.item.s,score:r.item.score,pct:r.item.pct,why:r.item.why,formats:r.formats,color_options:r.colors||[],must_have_match:r.item.must_have_match,exact_size_match:r.item.exact_size_match,must_have_complete_match:r.item.must_have_complete_match});
      });
      return runBatch(start+BATCH);
    });
  }
  return runBatch(0).then(function(items){return finalRecommendationList(items,count);});
}
function getFastLiveRankedItems(ranked,target,wantSet,count){
  var firstSpec=ranked&&ranked[0]&&ranked[0].s;
  var valueMode=firstSpec&&firstSpec.type==='putter'
    ? ((putterScoringAnswers(ans)||{}).ppriority==='value')
    : ((clubScoringAnswers(ans)||{}).priority==='value');
  var out=[],max=Math.min(ranked.length,valueMode?48:28),BATCH=4;
  var desired=valueMode?Math.min(max,24):Math.min(max,Math.max(count+3,count));
  function runBatch(start){
    if(start>=max)return Promise.resolve(out);
    if(out.length>=desired&&enoughBrandDiversity(out,count,2))return Promise.resolve(out);
    var slice=ranked.slice(start,Math.min(start+BATCH,max));
    return Promise.all(slice.map(function(item){
      return buildPrimaryProductOptionLive(item.s,target,wantSet).then(function(options){return {item:item,formats:options.formats,colors:options.colors,pending:options.pending};});
    })).then(function(res){
      res.forEach(function(r){
        if(r.formats.length)out.push({s:r.item.s,score:r.item.score,pct:r.item.pct,why:r.item.why,formats:r.formats,color_options:r.colors||[],must_have_match:r.item.must_have_match,exact_size_match:r.item.exact_size_match,must_have_complete_match:r.item.must_have_complete_match,_gqOptionsPending:!!r.pending});
      });
      return runBatch(start+BATCH);
    });
  }
  return runBatch(0).then(function(items){return finalRecommendationList(items,count);});
}
/* v33: gather the exact variant GIDs the fast finalist pool will need, so a
   single batched availability request can warm the whole pool before the
   per-candidate verification loop runs. Mirrors the pool sizes used by
   getFastLiveRankedItems (28 normal / 48 Best Value). */
function gqFastValueMode(a,putter){
  return putter?(((putterScoringAnswers(a)||{}).ppriority==='value')):(((clubScoringAnswers(a)||{}).priority==='value'));
}
function gqCollectFastPoolGids(a){
  a=normalizeQuizAnswers(a||ans||{});
  var gids=[],trk=a.regrip;
  function addSpec(spec){(spec&&spec.variants||[]).forEach(function(v){gqEmbeddedGidsForEntry(v).forEach(function(g){gids.push(g);});});}
  if(trk==='set'||trk==='both'){
    var sz=recommendSize(a),cap=gqFastValueMode(a,false)?48:28;
    rankClub(a,sz.size).slice(0,cap).forEach(function(it){addSpec(it.s);});
  }
  if(trk==='putter'||trk==='both'){
    var pcap=gqFastValueMode(a,true)?48:28;
    rankPutter(a).slice(0,pcap).forEach(function(it){addSpec(it.s);});
  }
  return gids;
}
function gqPromiseWithCap(p,ms){
  return Promise.race([Promise.resolve(p).catch(function(){return null;}),new Promise(function(res){setTimeout(function(){res('cap');},ms);})]);
}
/* Preload the publication sitemap index (makes the 404 gate a local lookup)
   and batch-resolve the finalist pool's stock. Never rejects. */
function gqEnsureFastBatchPrimed(a){
  var jobs=[];
  /* Load the sitemap publication index so result-time 404/live verification is
     a local lookup (no per-handle HTML fetch). This is the primary accelerator
     for the tokenless store. */
  try{jobs.push(loadPublishedHandleIndex().catch(function(){return null;}));}catch(e){}
  /* Storefront exact-variant batch (only fires when a valid token exists;
     otherwise a no-op). */
  try{jobs.push(gqPrimeVariantAvailability(gqCollectFastPoolGids(a)).catch(function(){return false;}));}catch(e){}
  return Promise.all(jobs);
}
function buildResultLiveFast(){
  ans=normalizeQuizAnswers(ans);
  /* Ensure the sitemap publication index is loaded before the verification
     loop so publication is a local lookup (no per-handle HTML 404 fetch). The
     index is normally already loaded from mount; when still cold we block
     briefly on it. The Storefront batch is a no-op without a token. */
  if(GQ_PUBLICATION_INDEX.loaded||gqFastPoolWarm(ans)){
    try{gqEnsureFastBatchPrimed(ans);}catch(e){}   /* fire-and-forget: warms Storefront batch + retries, never blocks */
    return buildResultLiveFastInner();
  }
  return gqPromiseWithCap(gqEnsureFastBatchPrimed(ans),2500).then(function(){return buildResultLiveFastInner();});
}
/* True when a majority of the fast pool's embedded variants are already
   resolved in the batched availability map (i.e. prefetch has warmed it). */
function gqFastPoolWarm(a){
  var ids=[],seen={};
  gqCollectFastPoolGids(a).forEach(function(g){var id=String(variantIdFromGid(g));if(id&&!seen[id]){seen[id]=1;ids.push(id);}});
  if(!ids.length)return true;
  var have=0;ids.forEach(function(id){if(Object.prototype.hasOwnProperty.call(GQ_VARIANT_AVAIL,id))have++;});
  return have/ids.length>=0.6;
}
function buildResultLiveFastInner(){
  var trk=ans.regrip,out={track:trk,customerProfiles:getCustomerProfiles(ans),_gqFastResult:true},jobs=[];
  if(trk==='set'||trk==='both'){
    var sz=recommendSize(ans),r=rankClub(ans,sz.size);
    jobs.push(getFastLiveRankedItems(r,sz.size,true,5).then(function(items){if(items.length)out.club=annotateClubMustHaveResult({size:sz,top:items[0],rest:items.slice(1,5),formats:items[0].formats},ans);}));
  }
  if(trk==='putter'||trk==='both'){
    var rp=rankPutter(ans),wantTgt=putterTargetSize(ans);
    jobs.push(getFastLiveRankedItems(rp,wantTgt,false,4).then(function(items){if(items.length){var tgt=wantTgt||(items[0].s.sizes_available||['Unspecified'])[0];out.putter={top:items[0],rest:items.slice(1,4),formats:items[0].formats,tgt:tgt};}}));
  }
  return Promise.all(jobs).then(function(){return out;});
}

function annotateClubMustHaveResult(c,a){
  if(!c)return c;
  var items=[c.top].concat(c.rest||[]).filter(Boolean);
  var active=clubMustHaveActive(a);
  c.must_have_active=active;
  c.exact_must_have_count=items.filter(function(item){return item.must_have_match===true||clubMustHaveMatch(item.s,a);}).length;
  c.exact_complete_count=items.filter(function(item){
    var feature=item.must_have_match===true||clubMustHaveMatch(item.s,a);
    var size=item.exact_size_match!==false&&sizeEligibleClub(item.s,c.size&&c.size.size);
    return feature&&size;
  }).length;
  c.must_have_fallback=active&&c.exact_complete_count<items.length;
  c.no_exact_must_have=active&&c.exact_complete_count===0;
  return c;
}
function buildResultLive(){
  ans=normalizeQuizAnswers(ans);
  var trk=ans.regrip,out={track:trk,customerProfiles:getCustomerProfiles(ans)},jobs=[];
  if(trk==='set'||trk==='both'){
    var sz=recommendSize(ans),r=rankClub(ans,sz.size);
    jobs.push(getLiveRankedItems(r,sz.size,true,5).then(function(items){if(items.length)out.club=annotateClubMustHaveResult({size:sz,top:items[0],rest:items.slice(1,5),formats:items[0].formats},ans);}));
  }
  if(trk==='putter'||trk==='both'){
    var rp=rankPutter(ans);
    var wantTgt=putterTargetSize(ans);
    jobs.push(getLiveRankedItems(rp,wantTgt,false,4).then(function(items){if(items.length){var tgt=wantTgt||(items[0].s.sizes_available||['Unspecified'])[0];out.putter={top:items[0],rest:items.slice(1,4),formats:items[0].formats,tgt:tgt};}}));
  }
  return Promise.all(jobs).then(function(){return out;});
}

/* ================================================================== *  RANK + DEDUP  */
/* 2026-07-08: also exclude brand:"Test" rows (not just model:"test") — found a spec with
   brand "Test" and a real-sounding model name slipping through during QA. Trim before the
   length check so whitespace-only values don't sneak past as length>=2. */
function isJunk(s){
  var model=(s.model||'').trim();
  var brand=(s.brand||'').trim();
  return !model||model.length<2||/^test$/i.test(model)||/^test$/i.test(brand);
}
/* Family-aware key: collapses listing variants of the same grip line
   ("Tour Velvet", "Tour Velvet Grip - 58 Core", "Honorary Starter Tour Velvet")
   so the alternates list shows real variety. Functionally different models
   (ALIGN, PLUS4, Cord, etc.) keep distinct keys on purpose.

   2026-07 profile-map-only size dedupe fix:
   The profile map can legitimately assign the same profile to size-only models
   such as JumboMax Comfort Wrap Small / Medium / Large. Those are not useful as
   three separate recommendation cards. For club grips, lineKey() now removes
   size-only wording and measurement suffixes so one family appears once. The
   family picker below then chooses the closest size/version for the quiz's
   recommended size.

   2026-07-09 REVISAL: putter model numbers like Flatso 1.0/2.0/3.0 were
   previously preserved on the theory that they're "different putter models."
   That was wrong for dedup purposes — 1.0/2.0/3.0/5.0 is Super Stroke's (and
   others') SIZE TIER convention (1.0=slim/standard, 2.0=midsize, 3.0=oversize,
   5.0=jumbo+counterweight — confirmed against this catalog's own putter_size
   field), functionally identical to how club grips use the words Standard/
   Midsize/Jumbo. Verified 15+ Super Stroke families (Flatso, Legacy, Zenergy
   Tour, TRAXION Tour, Pistol GT, TLT Pistol, etc.) were each showing 2-4 "size
   variants" as separate alternates instead of one family recommendation. Now
   folded the same way club sizes are, via a putter-only decimal strip in
   lineKey() below — scoped to putters only because on the club side "Dri-Tac"
   vs "Dri-Tac 2.0" (Winn) are genuinely two different real products, not a
   size tier, so stripping there would wrongly merge them. */
function clubFamilyNoiseClean(t){
  var raw=String(t||'');
  /* 2026-07-09: strip short all-caps parenthetical build/core codes, e.g.
     JumboMax "NEW JumboMax Tour Series (SJ) Grip +1/8"" vs "(SO) Grip +1/16"".
     Every spec field for these two (material/texture/feel/tack/weather/alignment/
     sizes_available/colors_available) is identical — they differ only in the
     build-up amount, which the size-fraction strip below already removes for
     every other model. Without this, "(SJ)"/"(SO)" survived into the dedup key
     and both cards showed up for the same Jumbo/Oversize recommendation.
     Verified against the full 649-model catalog: the only 2-letter all-caps
     parenthetical codes that occur are SJ and SO. If a future catalog import
     adds a genuinely distinct product using a 2-letter parenthetical code
     (e.g. a real color or size abbreviation), re-check this regex. */
  raw=raw.replace(/\(\s*[A-Z]{2}\s*\)/g,' ');
  var cleaned=raw.toLowerCase()
    .replace(/\balign\s+max\b/g,'align')
    .replace(/\bblackout\b/g,' ')
    .replace(/\b4x\b/g,' ')
    .replace(/\([^)]*\+?\d+\s*\/\s*\d+[^)]*\)/g,' ')
    .replace(/\+?\d+\s*\/\s*\d+\s*(?:\"|”|in\b)?/g,' ')
    /* Important: remove x-large / xlarge BEFORE removing "large" or a stray "x" is left behind,
       which made Large and X-Large versions of the same grip show as separate recommendations. */
    .replace(/\b(?:x\s*[- ]?\s*large|xlarge|extra\s*[- ]?\s*large|xxl|2xl|3xl)\b/g,' ')
    .replace(/\b(?:undersize|ladies|lady|women|womens|junior|jr|standard|std|midsize|mid\s*size|jumbo|oversize|small|medium|large|xl)\b/g,' ');
  /* 2026-07-09: dedupe more aggressively across pure color/model variants —
     e.g. "Golf Pride MCC Plus4" vs "MCC Plus4 Grey" vs "MCC Plus4 Blue" were
     showing up as 3 separate "alternates" for the same underlying grip.
     Strips the same color vocabulary already used by styleColorBoost/
     gripStyleInfo (GQ_COLOR_WORDS), so a Style/Color-Matching customer isn't
     affected in practice: styleColorBoost still scores the more-colorful/
     stylistic variant higher BEFORE dedup runs, and familyPickBetter's >12-
     point score-gap shortcut picks that higher-scoring variant as the family
     representative. Only when colors are otherwise a wash on score does the
     plain confidence/price/name tie-break decide, which is fine since there's
     no strong preference signal either way at that point. */
  var colorRe=new RegExp('\\b(?:'+GQ_COLOR_WORDS.join('|')+')\\b','g');
  return cleaned.replace(colorRe,' ');
}
function lineKey(s){
  /* 2026-07-09 fix: putter records used to skip clubFamilyNoiseClean entirely
     and dedup on a near-exact lowercased "brand + model" string. That let
     Standard/Midsize/Jumbo variants of the same putter line (e.g. "Super
     Stroke Zenergy Tour 1.0" vs "...2.0", or a Jumbo/Large-suffixed model)
     show up as separate "alternates" instead of collapsing into one
     recommendation per family, the same way club grips already do. The size/
     noise vocabulary in clubFamilyNoiseClean (standard/midsize/jumbo/oversize/
     large/small/ladies/junior/etc.) applies equally to putter model names, so
     now both types run through the same family-aware cleaner. */
  var raw=clubFamilyNoiseClean((s&&s.brand||'')+' '+(s&&s.model||''));
  if(s&&s.type==='putter'){
    /* Putter-only: fold the bare-decimal size tier (Super Stroke's 1.0/2.0/
       3.0/5.0 convention, and similar) into the family key. See the revised
       comment above clubFamilyNoiseClean for why this is scoped to putters
       only and not applied to clubs. */
    raw=raw.replace(/\b[1-5]\.0\b/g,' ')
           .replace(/\bpalmbird\b/g,' ')
           .replace(/\bsq\s*\d+\b/g,'sq');
  }
  return raw
    .replace(/\bhonorary starter\b/g,'')
    .replace(/\b\d{2}\s*core\b/g,'')
    .replace(/\b(grip|grips|golf)\b/g,'')
    .replace(/\bs\b/g,'') /* stray "s" from possessives ("Star Grip's") — only "s", so "Z"/"X" models stay distinct */
    .replace(/\s\+\s/g,' ') /* standalone " + " is listing noise */
    .replace(/\+/g,'plus') /* attached "+" is meaningful: Sonar+ ≠ Sonar */
    .replace(/[^a-z0-9]+/g,'');
}
function sizeIndex(size){
  var i=SIZE_ORDER.indexOf(size);
  return i>=0?i:null;
}
function modelSizeIntent(s){
  var m=String((s&&s.model)||'').toLowerCase();

  /* These size words are model-level variants in some carried lines.
     Use model text only here — not brand text — so "JumboMax" does not make
     every JumboMax model look like the Large/Jumbo version. */
  if(/\b(?:ladies|lady|women|womens|undersize|junior|jr)\b/.test(m))return 'Undersize';
  if(/\b(?:x\s*[- ]?\s*large|xlarge|extra\s*[- ]?\s*large|large|xl|xxl|2xl|3xl|jumbo|oversize)\b|\+?11\s*\/\s*32|\+?3\s*\/\s*8/.test(m))return 'Jumbo/Oversize';
  if(/\b(?:medium|midsize|mid\s*size)\b|\+?5\s*\/\s*16/.test(m))return 'Midsize';
  if(/\b(?:small|standard|std)\b|\+?1\s*\/\s*4/.test(m))return 'Standard';
  return '';
}
function sizeTieBreakScore(s,target){
  if(!target)return 0;
  var ti=sizeIndex(target);
  if(ti==null)return 0;

  var intent=modelSizeIntent(s);
  if(intent){
    var ii=sizeIndex(intent);
    if(ii==null)return 0;
    var d=Math.abs(ii-ti);
    return d===0?60:(d===1?28:(d===2?8:0));
  }

  var sizes=(s&&s.sizes_available)||[];
  if(sizes.indexOf(target)>=0)return 44;
  if(sizes.some(function(x){return adjacent(x,target);}))return 18;
  return 0;
}
function familyPickBetter(candidate,current,target){
  if(!current)return true;
  var diff=(Number(candidate.score)||0)-(Number(current.score)||0);

  /* Profile mapping remains the main score. But when two records are effectively
     the same family and close in profile score, prefer the one that best matches
     the recommended grip size. This prevents Small/Medium/Large versions from
     all showing, and it chooses the best one for the customer. */
  if(Math.abs(diff)>12)return diff>0;

  var cs=sizeTieBreakScore(candidate.s,target),os=sizeTieBreakScore(current.s,target);
  if(cs!==os)return cs>os;
  if(diff!==0)return diff>0;

  var cx=confidenceBonus(candidate.s),cy=confidenceBonus(current.s);
  if(cx!==cy)return cx>cy;
  var cp=(candidate.s&&candidate.s.price_min!=null?candidate.s.price_min:1e9),op=(current.s&&current.s.price_min!=null?current.s.price_min:1e9);
  if(cp!==op)return cp<op;
  var cn=((candidate.s&&candidate.s.brand)||'')+' '+((candidate.s&&candidate.s.model)||''),on=((current.s&&current.s.brand)||'')+' '+((current.s&&current.s.model)||'');
  return cn<on;
}
function dedup(r,target){
  var seen={},order=[],i,k;
  for(i=0;i<r.length;i++){
    k=lineKey(r[i].s);
    if(!seen[k]){seen[k]=r[i];order.push(k);continue;}
    if(familyPickBetter(r[i],seen[k],target))seen[k]=r[i];
  }
  return order.map(function(key){return seen[key];});
}
function cmpRankedWithSizeTarget(target){
  return function(x,y){
    if(y.score!==x.score)return y.score-x.score;
    var ds=sizeTieBreakScore(y.s,target)-sizeTieBreakScore(x.s,target);
    if(ds)return ds;
    return cmpRanked(x,y);
  };
}
/* Deterministic ordering: score, then spec confidence, then lower price,
   then name — so ties never fall back to data-file order. */
function cmpRanked(x,y){
  if(y.score!==x.score)return y.score-x.score;
  var cx=confidenceBonus(x.s),cy=confidenceBonus(y.s);
  if(cy!==cx)return cy-cx;
  var px=(x.s.price_min!=null?x.s.price_min:1e9),py=(y.s.price_min!=null?y.s.price_min:1e9);
  if(px!==py)return px-py;
  var nx=(x.s.brand+' '+x.s.model),ny=(y.s.brand+' '+y.s.model);
  return nx<ny?-1:(nx>ny?1:0);
}
/* Brand diversity: keep the first visible recommendations from being dominated
   by one brand. This is especially important after profile mapping because many
   grips can share the same primary/secondary profile. Default: max 2 grips from
   the same brand in the first 5 visible recommendations. Overflow items keep
   their relative order and slide down; nothing is dropped. */
function brandCapName(item){
  return normBrandName(item&&item.s&&item.s.brand)||'';
}
function enforceBrandCap(list,maxPerBrand,visibleSlots){
  if(!list||!list.length)return list;
  maxPerBrand=maxPerBrand||2;
  visibleSlots=visibleSlots||5;
  var selected=[],overflow=[],counts={},i,b;
  for(i=0;i<list.length;i++){
    b=brandCapName(list[i]);
    if(selected.length<visibleSlots&&(counts[b]||0)<maxPerBrand){
      counts[b]=(counts[b]||0)+1;
      selected.push(list[i]);
    }else{
      overflow.push(list[i]);
    }
  }
  return selected.concat(overflow);
}
function diversify(list){
  return enforceBrandCap(list,2,5);
}
function selectStrictBrandCap(list,maxPerBrand,visibleSlots){
  var selected=[],counts={};
  (list||[]).some(function(item){
    var b=brandCapName(item);
    if((counts[b]||0)>=maxPerBrand)return false;
    counts[b]=(counts[b]||0)+1;
    selected.push(item);
    return selected.length>=visibleSlots;
  });
  return selected;
}
function liveUnitPrice(item){
  var vals=[];
  (item&&item.formats||[]).forEach(function(f){
    var p=Number(f&&f.price);if(!isFinite(p)||p<=0)return;
    var n=Number(f&&f.n)||1;
    /* Club value compares grip-only economics whenever possible. A kit is
       still purchasable, but tape/solvent extras should not make the grip look
       expensive if a verified single or grip-only bundle exists. */
    var key=String(f&&f.key||f&&f.label||'').toLowerCase();
    var isKit=/kit/.test(key);
    if(item&&item.s&&item.s.type!=='putter'&&isKit)return;
    vals.push((item&&item.s&&item.s.type==='putter')?p:(p/Math.max(1,n)));
  });
  /* If only a kit exists, use it rather than leaving the item unpriced. */
  if(!vals.length){
    (item&&item.formats||[]).forEach(function(f){
      var p=Number(f&&f.price);if(!isFinite(p)||p<=0)return;
      var n=Number(f&&f.n)||1;
      vals.push((item&&item.s&&item.s.type==='putter')?p:(p/Math.max(1,n)));
    });
  }
  return vals.length?Math.min.apply(Math,vals):null;
}
function valueModeForList(list){
  if(!list||!list.length)return false;
  var isPutter=!!(list[0]&&list[0].s&&list[0].s.type==='putter');
  var qa=isPutter?putterScoringAnswers(ans):clubScoringAnswers(ans);
  return isPutter?(qa&&qa.ppriority==='value'):(qa&&qa.priority==='value');
}
function valueConfidenceScore(s){
  var c=String((s&&s.spec_confidence)||'').toLowerCase();
  if(c==='verified_model'||c==='verified')return 100;
  if(c==='verified_family'||c==='verified_brand_default'||c==='verified-brand')return 82;
  if(c==='verified_brand')return 68;
  return 50;
}
function valueEligibilityTier(item,isPutter,qa){
  if(!item||!item.s)return 0;
  if(isPutter){
    var pref=qa&&qa.psize;
    if(!pref||pref==='nopref')return 3;
    if(sizeEligiblePutter(item.s,pref))return 3;
    if(sizeEligiblePutterAdjacent(item.s,pref))return 2;
    return 0;
  }
  var target=recommendSize(qa).size;
  var exactSize=item.exact_size_match!==false&&sizeEligibleClub(item.s,target);
  if(clubMustHaveActive(qa)){
    var feature=item.must_have_match===true||clubMustHaveMatch(item.s,qa,target);
    if(feature&&exactSize)return 3;
    if(feature)return 2;
    return 0;
  }
  return exactSize?3:1;
}
function logPriceScore(price,lo,hi){
  price=Number(price);lo=Number(lo);
  if(!isFinite(price)||price<=0||!isFinite(lo)||lo<=0)return 0;
  /* Score price by its ratio to the cheapest qualified option. This avoids
     exaggerating tiny differences (for example $6.99 versus $7.50) while
     still strongly rewarding a product that costs half or one-third as much. */
  return Math.max(0,Math.min(100,100*(lo/price)));
}
function round1(n){return Math.round(Number(n)*10)/10;}
function prepareLiveValueRanking(list,count){
  if(!list||!list.length||!valueModeForList(list))return list;
  var isPutter=!!(list[0]&&list[0].s&&list[0].s.type==='putter');
  var qa=isPutter?putterScoringAnswers(ans):clubScoringAnswers(ans);
  var fitFloor=isPutter?12:10;

  list.forEach(function(item){
    item.live_value_price=liveUnitPrice(item);
    item.value_fit_score=customerFacingFitPct(item);
    item.value_eligibility_tier=valueEligibilityTier(item,isPutter,qa);
    item.value_confidence_score=valueConfidenceScore(item.s);
  });

  var maxTier=Math.max.apply(Math,list.map(function(x){return x.value_eligibility_tier||0;}));
  var tierItems=list.filter(function(x){return x.value_eligibility_tier===maxTier&&x.live_value_price!=null;});
  if(!tierItems.length)return list;
  var bestFit=Math.max.apply(Math,tierItems.map(function(x){return Number(x.value_fit_score)||0;}));

  /* The core value pool contains products in the best requirement/size tier
     and within a modest fit distance of the best pure-fit product. Products
     outside this pool remain available as fallbacks but cannot headline Best
     Value merely because they are cheap. */
  tierItems.forEach(function(x){x.value_qualified=(Number(x.value_fit_score)||0)>=bestFit-fitFloor;});
  var qualified=tierItems.filter(function(x){return x.value_qualified;});
  if(!qualified.length){qualified=tierItems;qualified.forEach(function(x){x.value_qualified=true;});}

  var prices=qualified.map(function(x){return x.live_value_price;});
  var lo=Math.min.apply(Math,prices),hi=Math.max.apply(Math,prices);
  var fitWeight=isPutter?.50:.55,priceWeight=isPutter?.45:.40,confWeight=.05;

  list.forEach(function(item){
    var priceScore=item.live_value_price!=null?logPriceScore(item.live_value_price,lo,hi):0;
    var dominance=0;
    if(item.value_qualified&&item.live_value_price!=null){
      qualified.forEach(function(other){
        if(other===item||other.live_value_price==null)return;
        var fit=Number(item.value_fit_score)||0,otherFit=Number(other.value_fit_score)||0;
        var price=Number(item.live_value_price),otherPrice=Number(other.live_value_price);
        if(fit>=otherFit-6&&price<=otherPrice*.75)dominance+=3;
        if(fit>=otherFit-10&&price<=otherPrice*.50)dominance+=4;
      });
    }
    dominance=Math.min(10,dominance);
    item.value_price_score=round1(priceScore);
    item.value_dominance_bonus=round1(dominance);
    item.value_score=round1(Math.min(100,(Number(item.value_fit_score)||0)*fitWeight+priceScore*priceWeight+(Number(item.value_confidence_score)||0)*confWeight+dominance));
    item.live_value_bonus=round1(priceScore*priceWeight+dominance);
    if(item.value_qualified&&priceScore>=70&&item.why){
      var msg=isPutter
        ? 'Its verified live price gives it one of the strongest price-to-fit ratios in your qualified putter options'
        : 'Its verified live per-grip price gives it one of the strongest price-to-fit ratios in your qualified options';
      if(item.why.indexOf(msg)===-1)item.why.push(msg);
    }
  });
  return list;
}
function cmpValueRanked(x,y){
  var xq=!!(x&&x.value_qualified),yq=!!(y&&y.value_qualified);
  if(xq!==yq)return yq-xq;
  var xt=Number(x&&x.value_eligibility_tier)||0,yt=Number(y&&y.value_eligibility_tier)||0;
  if(yt!==xt)return yt-xt;
  if(xq&&yq){
    var xv=Number(x.value_score)||0,yv=Number(y.value_score)||0;
    if(yv!==xv)return yv-xv;
  }
  return cmpVisibleRanked(x,y);
}
function finalRecommendationList(list,count){
  var valueMode=valueModeForList(list);
  if(valueMode)list=prepareLiveValueRanking(list,count);
  var comparator=valueMode?cmpValueRanked:cmpVisibleRanked;
  var visible=selectStrictBrandCap((list||[]).slice().sort(comparator),2,count).sort(comparator);
  return applyDisplayFitPct(visible,valueMode);
}

/* 2026-07-09 fix: fit % was being normalized against the TOP SCORE WITHIN
   THE SAME LIST — which is self-referential. Whoever wins #1 in any list, by
   definition, has a score/topScore ratio of exactly 1, so applyScoreBasedPct
   returned pct=100 and displayFitPct returned display_pct=98 for the #1 item
   EVERY SINGLE TIME, regardless of whether that top pick was a strong,
   specific match or just the least-bad option in a generic/no-preference
   bucket. Confirmed against real quiz output: all 20 test profiles' top
   picks showed exactly 98%. Fixed by normalizing against a real, answer-set-
   dependent ceiling instead — the actual maximum profileMapScoreProduct()
   score achievable for this answer set, computed analytically by summing
   each component's own documented cap (mirrors the existing maxScoreClub/
   maxScorePutter pattern used for the legacy scoreClub/scorePutter path).
   KEEP IN SYNC with profileMapScoreProduct()'s component caps when any of
   them change:
     100  - primary profile match (the largest of the 100/70/50/35 tiers)
      20  - mapConfidencePoints() cap (Math.min(10,n)*2)
      36  - profileBucketTieBreakBoost() cap
   50/70  - specAnswerFitTieBreakBoost() cap (club/putter)
   70+55  - clubHardPreferenceScore() cap (texture + alignment, club only,
            only counted when that answer was actually given)
      14  - preferredBrandBoost() cap
   A mediocre best-in-pool match (low score relative to this ceiling) will
   now correctly show a moderate/low %, and only a genuinely strong, specific
   match approaches the 98% display ceiling. */
function maxProfileMapScore(isPutter){
  var a=ans||{};
  var m=135+20+36;
  m+=isPutter?70:50;
  if(!isPutter){
    if(a.texture==='corded'||a.texture==='wrap')m+=82;
    if(a.alignment==='yes')m+=55;
  }else if(stylePriorityActive(putterScoringAnswers(a),getCustomerProfiles(putterScoringAnswers(a)))){
    m+=150; /* putterStyleColorPreferenceScore cap */
  }else if((putterScoringAnswers(a)||{}).ppriority==='value'){
    m+=14; /* modest pre-live value-pool inclusion cap; live value rerank is separate */
  }
  m+=14;
  return m;
}
/* 2026-07-10: floor changed from 5 to 0 to match the displayFitPct() rework
   below — this feeds item.pct, which fitPct() falls back to whenever
   display_pct hasn't been set, so it should be honest too, not padded. */
function pctOf(sc,max){if(!max)return null;return Math.max(0,Math.min(100,Math.round(sc/max*100)));}
/* Calculate fit % from the same actual score used for ranking, normalized
   against the analytical ceiling above (not the pool's own top score — see
   the 2026-07-09 comment on maxProfileMapScore). */
function applyScoreBasedPct(list,isPutter){
  if(!list||!list.length)return list;
  var ceiling=maxProfileMapScore(!!isPutter);
  list.forEach(function(item){
    item.pct=pctOf(Number(item.score)||0,ceiling);
  });
  return list;
}
/* Honest final ranking for customer-visible recommendations.
   This does not rewrite or fake match percentages. It simply uses the
   actual calculated % fit as the primary confidence signal, then raw score,
   confidence, price, and name as tie-breakers. That way the card labeled
   "Best match" is the real highest-confidence visible recommendation. */
function cmpVisibleRanked(x,y){
  var clubList=!!((x&&x.s&&x.s.type==='club')||(y&&y.s&&y.s.type==='club'));
  if(clubList&&clubMustHaveActive(clubScoringAnswers(ans))){
    var xc=x&&x.must_have_complete_match===true?2:(x&&x.must_have_match===true?1:0);
    var yc=y&&y.must_have_complete_match===true?2:(y&&y.must_have_match===true?1:0);
    if(yc!==xc)return yc-xc;
  }
  var px=(x&&x.pct!=null)?Number(x.pct):-1;
  var py=(y&&y.pct!=null)?Number(y.pct):-1;
  if(isNaN(px))px=-1;
  if(isNaN(py))py=-1;
  if(py!==px)return py-px;
  return cmpRanked(x,y);
}
function sortVisibleRanked(list){
  if(!list||!list.length)return list;
  return list.slice().sort(cmpVisibleRanked);
}
/* Customer-facing fit percentage.
   The raw profile-map score is excellent for ordering products, but it is not
   an intuitive percentage denominator: some caps are impossible for a given
   answer set, and a required feature is now handled as an eligibility tier
   instead of duplicate additive points. That is why valid exact matches could
   display 6% even when the recommendation itself was sensible.

   The customer-facing number now combines:
     1) direct spec fit to the golfer's answers (size, feel, moisture, putter
        shape/size/weight),
     2) mapped player-profile fit, and
     3) exact required-feature/size compliance for club grips.
   It remains bounded and monotonic down the visible list, but no longer treats
   an unreachable theoretical score ceiling as 100%. */
function displayProfileFitRatio(s,qa){
  var customer=getCustomerProfiles(qa||{});
  var product=getMappedGripProfiles(s)||inferGripProfiles(s);
  if(!product||!product.primaryProfile)return .30;
  var secs=product.secondaryProfiles||[];
  if(product.primaryProfile===customer.primaryProfile)return 1;
  if(secs.indexOf(customer.primaryProfile)>=0)return .88;
  if(product.primaryProfile===customer.secondaryProfile)return .76;
  if(secs.indexOf(customer.secondaryProfile)>=0)return .64;
  return .32;
}
function displayDirectFitRatio(item,isPutter){
  if(!item||!item.s)return 0;
  var qa=isPutter?putterScoringAnswers(ans):clubScoringAnswers(ans);
  var neutral=neutralProfileForSpecTieBreak();
  var raw,max;
  if(isPutter){
    raw=scorePutter(item.s,qa,neutral).score;
    max=maxScorePutter(qa);
  }else{
    var target=recommendSize(qa).size;
    raw=scoreClub(item.s,qa,target,neutral).score;
    max=maxScoreClub(qa,target);
  }
  if(!isFinite(raw)||!isFinite(max)||max<=0)return 0;
  return Math.max(0,Math.min(1,raw/max));
}
function customerFacingFitPct(item){
  if(!item||!item.s)return null;
  var isPutter=item.s.type==='putter';
  var qa=isPutter?putterScoringAnswers(ans):clubScoringAnswers(ans);
  var direct=displayDirectFitRatio(item,isPutter);
  var profile=displayProfileFitRatio(item.s,qa);
  var ratio=(direct*.78)+(profile*.22);

  if(!isPutter&&clubMustHaveActive(qa)){
    var target=recommendSize(qa).size;
    var feature=item.must_have_match===true||clubMustHaveMatch(item.s,qa,target);
    var exactSize=item.exact_size_match!==false&&sizeEligibleClub(item.s,target);
    var requirementFit=feature?(exactSize?1:.68):.08;
    ratio=(ratio*.72)+(requirementFit*.28);
  }

  var pct=Math.round((48+(50*Math.max(0,Math.min(1,ratio))))*10)/10;

  /* A fallback may be useful, but it should never visually claim to be as
     complete a fit as a product satisfying the customer's non-negotiable
     feature. Adjacent-size exact-feature fallbacks receive a higher cap than
     products missing the requested construction entirely. */
  if(!isPutter&&clubMustHaveActive(qa)){
    var target2=recommendSize(qa).size;
    var feature2=item.must_have_match===true||clubMustHaveMatch(item.s,qa,target2);
    var exactSize2=item.exact_size_match!==false&&sizeEligibleClub(item.s,target2);
    if(!feature2)pct=Math.min(pct,69);
    else if(!exactSize2)pct=Math.min(pct,78);
  }
  return Math.max(0,Math.min(98,pct));
}
function displayFitPct(item,ceiling){
  var pct=customerFacingFitPct(item);
  return pct==null?(item&&item.pct!=null?item.pct:null):pct;
}
function applyDisplayFitPct(list,valueOrdered){
  if(!list||!list.length)return list;
  var prevPct=null;
  list.forEach(function(item){
    var pct=displayFitPct(item);
    /* Best Value is intentionally ordered by price-to-fit ratio, so a later
       premium alternative may have a slightly higher pure Fit %. Keep each
       product's honest fit instead of forcing percentages to mirror value rank. */
    if(!valueOrdered&&prevPct!=null)pct=Math.min(pct,prevPct);
    item.display_pct=pct;
    prevPct=pct;
  });
  return list;
}
function fitPct(item){
  return item ? (item.display_pct!=null ? item.display_pct : item.pct) : null;
}
/* Profile-map-only recommendation ranking.
   The old size/feel/texture/stroke scoring functions remain in the file for reference
   and fallback testing, but rankClub()/rankPutter() now rank products from the exact
   grip-profile map first. That means the spreadsheet/export profile mapping is the
   source of truth for product fit. Size/type/live availability still control what can
   be shown and purchased, but they do not overpower mapped player-profile fit. */
function mapConfidencePoints(productProfiles){
  var n=Number(productProfiles&&productProfiles.confidenceScore);
  if(isNaN(n)||n<=0)return 0;
  return Math.max(0,Math.min(10,n))*2;
}
function productHasProfile(product,profile){
  if(!product||!profile)return false;
  if(product.primaryProfile===profile)return true;
  return (product.secondaryProfiles||[]).indexOf(profile)>=0;
}
function customerHasProfile(customerProfiles,profile){
  if(!customerProfiles||!profile)return false;
  return customerProfiles.primaryProfile===profile||customerProfiles.secondaryProfile===profile;
}
/* 2026-07-08: near-tie inclusion for the tie-break signal boosts below.
   profileSummary() must pick exactly one primary/secondary using
   PROFILE_TIE_PRIORITY, so a real, strongly-scored signal (e.g. Oversize/
   Reduced Grip Pressure at 13 points from "very large hands" + "tight
   pressure") can lose an arbitrary tie to a higher-priority bucket (Arthritis
   at the same 13 points) and then get ZERO credit here even though the raw
   answers clearly support it. Case 1 in the 2026-07-08 QA pass (very large
   hands, tight pressure, soft feel, comfort=yes) is the example: Maximum
   Comfort was primary (17, correctly), but Oversize (13) tied Arthritis (13)
   for secondary and lost the tie, so no oversize/JumboMax-signal credit was
   ever applied and true oversize products didn't surface. This helper lets a
   bucket that scored within `margin` points of the actual secondary score
   still count as "in play" for these secondary signal boosts, without
   changing which profile is displayed as primary/secondary to the customer. */
function customerNearProfile(customerProfiles,profile,margin){
  if(!customerProfiles||!profile)return false;
  if(customerHasProfile(customerProfiles,profile))return true;
  var scores=customerProfiles.allProfileScores||{};
  var v=Number(scores[profile])||0;
  if(v<=0)return false;
  var sec=Number(customerProfiles.secondaryScore)||0;
  return v>=(sec-(margin==null?0:margin));
}
function profileBucketTieBreakBoost(s,product,customerProfiles,quizAnswers,target,why){
  /* Profile mapping remains the source of truth. This layer only breaks ties inside
     a crowded profile bucket so the recommendations look more sensible. Example:
     for an Oversize / Reduced Grip Pressure customer, show actual jumbo/reduced-taper
     grips in the recommended size before generic grips that merely share a broad map. */
  var boost=0,text=gripSearchText(s).toLowerCase();
  var brand=normBrandName(s&&s.brand);
  var qa=quizAnswers||{};

  if(customerNearProfile(customerProfiles,'Oversize / Reduced Grip Pressure Player',3)){
    var sizeScore=sizeTieBreakScore(s,target);
    var hasOversizeSignal=/jumbomax|jumbo|max\b|oversize|x\s*[- ]?\s*large|xlarge|large|midsize|medium|plus4|plus\s*4|less\s*taper|reduced\s*taper|no[-\s]*taper|non[-\s]*taper|str8|zenlite|ultralite|comfort\s*wrap|wrap\s*series/.test(text);
    if(productHasProfile(product,'Oversize / Reduced Grip Pressure Player'))boost+=8;
    if(hasOversizeSignal)boost+=10;
    if(sizeScore>=44)boost+=12;
    else if(sizeScore>=18)boost+=5;
    else if(target&&target!=='Standard')boost-=12;
    if(brand==='JumboMax')boost+=6;
  }

  if(customerNearProfile(customerProfiles,'Maximum Comfort Player',3)||customerNearProfile(customerProfiles,'Arthritis / Joint Pain Player',3)){
    var comfortModel=/dri[-\s]*tac|excel|cpx|cp2|revl\s*comfort|cross\s*comfort|chamois|comfort\s*wrap|wrap\s*series|soft\s*wrap|traxion\s*wrap|tour\s*wrap/.test(text);
    if(s&&s.feel==='soft')boost+=16;
    else if(s&&s.feel==='firm')boost-=14;
    if(comfortModel)boost+=12;
    if(brand==='Winn')boost+=10;
    if(brand==='Golf Pride'&&/cpx|cp2/.test(text))boost+=10;
    if(brand==='SuperStroke'&&/comfort|wrap/.test(text))boost+=6;
  }

  if(customerNearProfile(customerProfiles,'High-Traction Player',3)||customerNearProfile(customerProfiles,'Humid / Sweaty Hands Player',3)||customerNearProfile(customerProfiles,'All-Weather Player',3)){
    var strongTraction=/cord|corded|half[-\s]*cord|full[-\s]*cord|bct|z[-\s]*grip|mcc|multi\s*compound|new\s*decade|element|revl\s*element/.test(text);
    if(strongTraction)boost+=18;
    if(s&&s.weather==='all-weather')boost+=8;
    if(s&&s.tack==='high'&&!strongTraction)boost+=3;
    if((quizAnswers||{}).sweat==='wet'&&(s&&s.weather==='all-weather'))boost+=8;
    if((quizAnswers||{}).texture==='corded'&&!strongTraction)boost-=10;
  }

  if(customerNearProfile(customerProfiles,'Control / Shotmaker Player',3)){
    /* 2026-07-08: ALIGN/ribbed/reminder/calibrate branding should only get the
       full +10 "this is a control/precision grip" credit when the customer
       actually asked for alignment help or explicitly prioritized control on
       this track (club: a.alignment==='yes' or a.priority==='control'; putter:
       a.ppriority==='control'). Before this gate, any customer who merely
       landed in/near the Control bucket for unrelated reasons (e.g. firm feel,
       "both" track dilution from putter answers) could get ALIGN-branded club
       grips pushed to the top even when alignment was "no preference" — this
       is what caused Case 10's club recommendations to be dominated by ALIGN
       models despite alignment=nopref and priority=traction. Non-alignment
       "control" branding (PRO Only, S-Tech, REVL Player) still gets a smaller,
       unconditional credit since those are genuinely firmer/control-oriented
       products regardless of alignment intent. */
    var alignmentRequested=(qa.alignment==='yes')||(qa.priority==='control')||(qa.ppriority==='control');
    if(alignmentRequested&&productHasAlignmentAid(s))boost+=10;
    if(/pro\s*only|s[-\s]*tech|revl\s*player/.test(text))boost+=4;
    if(s&&s.feel==='firm')boost+=5;
  }

  /* Keep the existing color/style merchandising behavior, but make it active in
     the profile-map-only ranker too. */
  boost+=styleColorBoost(s,quizAnswers,customerProfiles,why,target);

  if(boost>0&&why){
    var msg='Ranked higher within this profile bucket because its specs better match your detailed answers';
    if(why.indexOf(msg)===-1)why.push(msg);
  }
  return Math.max(-30,Math.min(36,boost));
}

/* Second-layer spec fit tie-breaker.
   The profile map is still the main recommendation engine. This function only
   separates products that share the same broad mapped profiles by reusing the
   detailed grip-spec answer fit logic (size, feel, texture, alignment, putter
   shape/size/weight, etc.). It is intentionally capped so it cannot override a
   clearly better profile match. */
function neutralProfileForSpecTieBreak(){
  return {primaryProfile:'__profile_tiebreak_only__',secondaryProfile:'__profile_tiebreak_only__',allProfileScores:{}};
}
function scoreToSpecTieBreakPoints(raw,max,strong){
  raw=Number(raw);max=Number(max);
  if(isNaN(raw)||isNaN(max)||max<=0)return 0;
  var ratio=raw/max;
  /* 2026-07-09: putter tie-break uses a stronger scale (see `strong` below).
     Putter answers (stroke/shape, psize, pweight, pfeel) are direct, specific
     fit signals the golfer explicitly gave — they should be able to compete
     with the generic profile-map bucket score, not just nudge within it. Club
     grips keep the original, gentler scale. */
  if(strong){
    if(ratio>=0.92)return 62;
    if(ratio>=0.84)return 52;
    if(ratio>=0.76)return 42;
    if(ratio>=0.68)return 32;
    if(ratio>=0.60)return 22;
    if(ratio>=0.52)return 12;
    if(ratio>=0.44)return 2;
    if(ratio>=0.34)return -12;
    return -24;
  }
  /* Good exact-answer fits get meaningful lift; clear contradictions get a penalty.
     Cap range keeps this as a tie-breaker, not the primary ranking engine. */
  if(ratio>=0.92)return 42;
  if(ratio>=0.84)return 36;
  if(ratio>=0.76)return 30;
  if(ratio>=0.68)return 24;
  if(ratio>=0.60)return 18;
  if(ratio>=0.52)return 10;
  if(ratio>=0.44)return 4;
  if(ratio>=0.34)return -6;
  return -14;
}
function specAnswerFitTieBreakBoost(s,customerProfiles,quizAnswers,target,why){
  quizAnswers=quizAnswers||ans||{};
  var neutral=neutralProfileForSpecTieBreak();
  var raw=0,max=0,points=0;
  var isPutter=!!(s&&s.type==='putter');

  if(isPutter){
    var pr=scorePutter(s,quizAnswers,neutral);
    raw=pr&&pr.score!=null?pr.score:0;
    max=maxScorePutter(quizAnswers);
  }else{
    var cr=scoreClub(s,quizAnswers,target,neutral);
    raw=cr&&cr.score!=null?cr.score:0;
    max=maxScoreClub(quizAnswers,target);
  }

  points=scoreToSpecTieBreakPoints(raw,max,isPutter);

  /* Size gets a small extra voice for club grips so one family chooses the right
     Standard/Midsize/Jumbo version and generic profile matches don't beat the
     customer's recommended size. */
  if(s&&s.type!=='putter'&&target){
    var sz=sizeTieBreakScore(s,target);
    if(sz>=60)points+=8;
    else if(sz>=44)points+=6;
    else if(sz>=18)points+=2;
    else if(target!=='Standard')points-=8;
  }

  /* 2026-07-09: putter cap raised from +/-50 to +/-70 to match the stronger
     scale above. The map match is typically 100/70/50/35 for putters same as
     clubs, but putter answers (shape/size/weight/feel) are direct fit
     questions, not indirect signals — a golfer who explicitly says "oversize,
     heavy, soft" should get a putter that matches all three over one that
     merely shares a broad profile bucket. Club cap stays at +/-50 (unchanged
     — the club-side hard-preference fixes to texture/alignment above already
     address the reported club issues directly in scoreClub itself). */
  var cap=isPutter?70:50;
  points=Math.max(-cap,Math.min(cap,points));

  if(points>=18&&why){
    var msg='Ranked higher because its grip specs match your exact answers within this profile bucket';
    if(why.indexOf(msg)===-1)why.push(msg);
  }
  return points;
}

/* 2026-07-09: club-side "hard preference" layer, added directly to the main
   profile-map score instead of being squeezed through the bounded (+/-50)
   specAnswerFitTieBreakBoost the same way every other scoreClub factor is.
   Texture (an explicit corded/wrap request) and alignment (an explicit
   yes/round request) are answers golfers describe as near-deal-breakers, not
   "would be nice." Raising their weight inside scoreClub alone (see the
   2026-07-09 comments in scoreClub above) was NOT enough on its own —
   scoreClub's entire raw score gets compressed into a ratio and binned into
   a capped +/-50 tie-break tier alongside size, feel, comfort, etc., so a
   stronger internal weight did not reliably change who wins the overall
   profile-map ranking. Verified before this fix: a texture=corded request
   was still topped by "Golf Pride Dual Durometer" (texture: textured), with
   a genuinely corded alternative (Alpha Golf Alpha Full) buried at the
   bottom of the visible list. This layer is club-only (s.type!=='putter')
   and applies on top of everything else, uncapped by the tie-break ceiling,
   so an explicit texture/alignment request can decisively win the top slot
   instead of merely nudging a tie-break score most other factors already
   dominate. */
function alignmentAidType(s){
  if(!s)return 'unknown';
  var curated=String(s.alignment_type||s.alignmentType||'').toLowerCase().trim();
  if(curated==='raised_ridge'||curated==='ridge'||curated==='ribbed'||curated==='reminder')return 'ridge';
  if(curated==='round'||curated==='none_round'||curated==='none')return 'round';
  if(curated==='varies')return 'varies';

  /* Backward-compatible fallback for older sheets. SPYNE, ALIGN, Calibrate,
     ribbed, and reminder technologies are all physical raised ridges. */
  var field=[s.alignment,s.alignment_technology,s.alignmentTechnology,s.alignment_description].filter(Boolean).join(' ');
  var model=[s.model,s.display_name,s.displayName,s.product_title,s.productTitle,s.title,s.name].filter(Boolean).join(' ');
  var all=field+' '+model;
  if(/align|calibrate|spyne|reminder|\bribbed\b|raised[-\s]*ridge|alignment[-\s]*ridge/i.test(all))return 'ridge';
  if(/\bround\b|no[-\s]*ridge|standard[-\s]*round/i.test(all))return 'round';
  return 'unknown';
}
function productHasAlignmentAid(s){return alignmentAidType(s)==='ridge';}
function productHasAlignmentRidge(s){return alignmentAidType(s)==='ridge';}
function isSuperStrokeTourTraxionClub(s){
  if(!s)return false;
  var brand=String(s.brand||'').toLowerCase().replace(/[^a-z0-9]+/g,'');
  var parts=[s.model,s.display_name,s.displayName,s.product_title,s.productTitle,s.title,s.name];
  (s.variants||[]).forEach(function(v){
    if(v)parts.push(v.handle,v.url,v.title,v.name);
  });
  var text=parts.filter(Boolean).join(' ').toLowerCase();
  return (brand==='superstroke'||brand==='superstrokeusa'||/super[\s-]*stroke/.test(text))&&
    (/tour[\s-]*traxion[\s-]*club/.test(text)||/tourtraxionclub/.test(text.replace(/[^a-z0-9]+/g,'')));
}
function applyTourTraxionSpecCorrection(){
  (window.GRIP_SPECS||[]).forEach(function(s){
    if(!isSuperStrokeTourTraxionClub(s))return;
    /* SPYNE is an embossed physical ridge. Keep the quiz's normalized
       two-category alignment taxonomy as raised_ridge, while preserving the
       accurate customer-facing construction wording. */
    s.alignment='Embossed ridge';
    s.alignment_type='raised_ridge';
    s.alignment_aid_type='raised_ridge';
    s.alignment_technology='SPYNE';
    s.taper_profile='reduced';
  });
}
function clubAlignmentDisplay(s){
  if(isSuperStrokeTourTraxionClub(s))return 'Embossed ridge';
  return s&&(s.alignment_display||s.alignmentDisplay||s.alignment||s.alignment_type||s.alignmentType)||'';
}
function alignmentAidPhrase(s){
  if(isSuperStrokeTourTraxionClub(s))return 'embossed alignment ridge';
  var t=alignmentAidType(s);
  if(t==='ridge')return 'raised alignment ridge';
  if(t==='round')return 'standard round profile';
  if(t==='varies')return 'optional raised-ridge version';
  return 'unconfirmed alignment profile';
}
function productHasCord(s){
  if(!s)return false;
  var cov=String(s.cord_coverage||s.cordCoverage||'').toLowerCase();
  if(cov==='full'||cov==='partial')return true;
  if(cov==='none')return false;
  var fam=String(s.texture_family||s.textureFamily||'').toLowerCase();
  if(fam==='full_cord'||fam==='partial_cord')return true;
  if(fam==='smooth_rubber'||fam==='textured_rubber'||fam==='wrap'||fam==='microtexture')return false;
  var text=[s.texture,s.model,s.display_name,s.displayName,s.product_title,s.productTitle].filter(Boolean).join(' ');
  return /cord/i.test(text);
}
function productIsWrap(s){
  if(!s)return false;
  var fam=String(s.texture_family||s.textureFamily||'').toLowerCase();
  if(fam==='wrap')return true;
  if(fam&&fam!=='unknown')return false;
  var text=[s.texture,s.model,s.display_name,s.displayName,s.product_title,s.productTitle].filter(Boolean).join(' ');
  return /wrap/i.test(text);
}
function isReducedTaperGrip(s){
  if(!s)return false;
  /* Prefer a curated spec-sheet field. Recommended values:
     standard, reduced, no-taper, larger-lower-hand, or unknown. */
  var curated=s.taper_profile!=null?s.taper_profile:(s.taperProfile!=null?s.taperProfile:(s.reduced_taper!=null?s.reduced_taper:s.reducedTaper));
  if(curated===true||curated===1||String(curated).toLowerCase()==='true')return true;
  if(curated===false||curated===0||String(curated).toLowerCase()==='false')return false;
  var cv=String(curated||'').toLowerCase();
  if(/reduced|less[-\s]*taper|no[-\s]*taper|larger[-\s]*lower[-\s]*hand|parallel|straight/.test(cv))return true;
  if(/standard|traditional|normal/.test(cv))return false;
  /* Backward-compatible fallback until every product has the curated field. */
  var text=[s.model,s.display_name,s.displayName,s.product_title,s.productTitle,s.title,s.name,s.material,s.shopify_description].filter(Boolean).join(' ');
  return /plus\s*4|plus4|reduced[-\s]*taper|less[-\s]*taper|no[-\s]*taper|lower[-\s]*hand|str8|straight[-\s]*taper/i.test(text);
}
function clubMustHaveActive(a){return !!(a&&a.musthave&&a.musthave!=='none');}
function clubMustHaveMatch(s,a,target){
  a=normalizeQuizAnswers(a||{});
  if(!clubMustHaveActive(a))return true;
  if(a.musthave==='corded')return productHasCord(s);
  if(a.musthave==='cordedalign')return productHasCord(s)&&productHasAlignmentAid(s);
  if(a.musthave==='wrap')return productIsWrap(s);
  if(a.musthave==='align')return productHasAlignmentAid(s);
  /* Unknown alignment is not an exact round match. */
  if(a.musthave==='round')return alignmentAidType(s)==='round';
  if(a.musthave==='reducedtaper')return isReducedTaperGrip(s);
  if(a.musthave==='style')return isStyleForwardGrip(s,target);
  return true;
}
function isStyleForwardGrip(s,target){
  if(!s)return false;
  var level=String(s.style_level||s.styleLevel||'').toLowerCase();
  var count=Number(s.non_black_color_count!=null?s.non_black_color_count:s.nonBlackColorCount)||0;
  var info=gripStyleInfo(s,target);
  if(level==='special_edition')return true;
  if(level==='style_forward')return !target||info.optionLabels.length>0||info.styleKeyword;
  if(level==='multiple_colors')return target?info.optionLabels.length>0:count>0;
  if(level==='basic')return false;
  return info.nonBlackColors.length>0||info.optionLabels.length>0||info.styleKeyword||mappedStyleProfileMatch(s);
}
function clubHardPreferenceScore(s,a,why,target){
  if(!s||s.type==='putter'||!a)return 0;
  a=normalizeQuizAnswers(a);
  var pts=0;
  var prefText=(s.model||'')+' '+(s.display_name||'')+' '+(s.displayName||'')+' '+(s.product_title||'')+' '+(s.productTitle||'')+' '+(s.title||'')+' '+(s.name||'');
  if(a.texture==='corded'){
    if(productHasCord(s)){
      pts+=82;
      if(why){var m1='This corded texture is a decisive match for the extra-traction feel you specifically asked for';if(why.indexOf(m1)===-1)why.push(m1);}
    }else pts-=60;
  }else if(a.texture==='wrap'){
    if(productIsWrap(s)){
      pts+=82;
      if(why){var m2='This wrap-style texture is a decisive match for the classic wrapped feel you specifically asked for';if(why.indexOf(m2)===-1)why.push(m2);}
    }else pts-=48;
  }

  var alignmentField=(s.alignment||'');
  var aidType=alignmentAidType(s);
  if(a.alignment==='yes'){
    if(aidType==='ridge')pts+=55;
    else if(aidType==='varies')pts+=12;
    else pts-=40;
  }else if(a.alignment==='round'&&aidType==='ridge'){
    pts-=55;
    if(why){var m3='This model includes a raised alignment ridge, which is the opposite of the standard round profile you asked for';if(why.indexOf(m3)===-1)why.push(m3);}
  }
  /* Must-have features are handled by clubMustHaveMatch() and the ranking
     comparator, not by additive points here. This prevents a construction
     feature from being counted once as eligibility and again as score. */
  return pts;
}
function profileMapScoreProduct(s,customerProfiles,why,quizAnswers,target){
  customerProfiles=customerProfiles||getCustomerProfiles(ans);
  var product=getMappedGripProfiles(s);
  var usedFallback=false;
  var score=0,matched=[];

  /* 2026-07-08 fix: models missing from the exact profile map used to get a flat -500
     and were effectively unrecommendable. Fall back to the keyword-based
     inferGripProfiles() heuristic instead — it already tries the exact map first
     internally, so reaching this branch means it will score by brand/model keywords
     or default to Beginner/Casual if nothing matches. Penalized below so verified
     exact-map models still win ties against heuristic-matched ones. */
  if(!product||!product.primaryProfile){
    product=inferGripProfiles(s);
    usedFallback=true;
    if(!product||!product.primaryProfile){
      if(why)why.push('No profile could be determined for this model (no map entry, no keyword match), so it is held below scored products');
      return {score:-500,why:why||[],productProfiles:null};
    }
    if(why)why.push('This model is not yet in the verified profile map — matched using keyword-based profile detection instead');
  }

  var secs=product.secondaryProfiles||[];
  if(product.primaryProfile===customerProfiles.primaryProfile){
    score+=100;matched.push(customerProfiles.primaryProfile);
  }
  if(secs.indexOf(customerProfiles.primaryProfile)>=0){
    score+=70;matched.push(customerProfiles.primaryProfile);
  }
  if(product.primaryProfile===customerProfiles.secondaryProfile){
    score+=50;matched.push(customerProfiles.secondaryProfile);
  }
  if(secs.indexOf(customerProfiles.secondaryProfile)>=0){
    score+=35;matched.push(customerProfiles.secondaryProfile);
  }

  /* Confidence score comes from the profile-mapping workbook, so it is still
     considered part of the mapped-profile system rather than spec inference. */
  score+=mapConfidencePoints(product);

  if(matched.length&&why){
    var primaryMsg='Mapped to your '+customerProfiles.primaryProfile.replace(/ Player$/,'').toLowerCase()+' profile';
    if(matched.indexOf(customerProfiles.primaryProfile)>=0&&why.indexOf(primaryMsg)===-1)why.push(primaryMsg);
    if(matched.indexOf(customerProfiles.secondaryProfile)>=0){
      var secondaryMsg='Also matches your '+customerProfiles.secondaryProfile.replace(/ Player$/,'').toLowerCase()+' secondary profile';
      if(why.indexOf(secondaryMsg)===-1)why.push(secondaryMsg);
    }
  }

  /* Profile-bucket tie-breakers only refine ordering after the mapped-profile match. */
  score+=profileBucketTieBreakBoost(s,product,customerProfiles,quizAnswers||ans,target,why);

  /* Second scoring layer: use the original grip-spec fit engine as a tie-breaker
     inside broad profile buckets. Profile mapping still decides the bucket; this
     decides which grip inside that bucket better matches the customer's exact
     answers (soft vs firm, cord vs wrap, alignment, putter size/shape/weight, etc.). */
  score+=specAnswerFitTieBreakBoost(s,customerProfiles,quizAnswers||ans,target,why);

  /* Club-only hard-preference layer (texture, alignment) — see comment above
     clubHardPreferenceScore(). Added uncapped so an explicit corded/wrap or
     alignment request can decisively win the top slot. */
  score+=clubHardPreferenceScore(s,quizAnswers||ans,why,target);

  /* Putter-only hard style/color layer — keeps true color/style grips ahead of
     black-only performance grips when the customer explicitly chose style/color. */
  score+=putterStyleColorPreferenceScore(s,quizAnswers||ans,customerProfiles,why);

  /* Putter value/default polish: avoid niche stability grips winning generic
     value or beginner/default putter paths when mainstream putter grips fit. */
  score+=putterDefaultValuePreferenceScore(s,quizAnswers||ans,customerProfiles,why);

  /* Exact wrap products are further separated by moisture/traction performance
     when the customer requires a wrap and chooses a traction-oriented path. */
  score+=wrapTractionPreferenceScore(s,quizAnswers||ans,why);

  /* Brand preference is useful for normal recommendations, but it conflicts
     with an explicit Best Value request. Value paths are reranked after live
     prices are confirmed, so brand receives no bonus in those cases. */
  var valuePriority=(s.type==='putter')
    ? ((putterScoringAnswers(quizAnswers||ans)||{}).ppriority==='value')
    : ((clubScoringAnswers(quizAnswers||ans)||{}).priority==='value');
  if(!valuePriority)score+=preferredBrandBoost(s,customerProfiles,score);

  /* Keep novelty/training penalties so oddball products do not headline normal results. */
  score+=noveltyPenalty(s);
  score+=oddballPenalty(s);
  if(usedFallback)score-=15; /* keep verified exact-map models ahead of keyword-matched ones on ties */
  return {score:score,why:why||[],productProfiles:product};
}
/* 2026-07-08 size-gating fix.
   Pre-filter candidates to the recommended size before scoring, instead of relying only
   on sizeTieBreakScore()/specAnswerFitTieBreakBoost() to (imperfectly) discourage the
   wrong size. Falls back to adjacent-size-eligible (then, for putters, to the full pool)
   only when the exact-size pool is too thin to safely fill a 5-item, max-2-per-brand
   result set, so Undersize/Jumbo-Oversize customers never hit empty results. */
var GQ_MIN_SIZE_POOL=40;
function sizeEligibleClub(s,target){
  if(!target)return true;
  var sizes=(s&&s.sizes_available)||[];
  if(!sizes.length)return true; /* no size data at all — do not penalize for a data gap */
  if(sizes.indexOf('Unspecified')>=0)return true;
  return sizes.indexOf(target)>=0;
}
function sizeEligibleClubAdjacent(s,target){
  if(sizeEligibleClub(s,target))return true;
  var sizes=(s&&s.sizes_available)||[];
  return sizes.some(function(x){return adjacent(x,target);});
}
var PUTTER_SIZE_ORDER=['standard','midsize','oversize'];
function putterSizeClass(raw){
  var t=(raw||'').toLowerCase();
  if(/3\.0|4\.0|5\.0|oversize|jumbo|fatso/.test(t))return 'oversize';
  if(/2\.0|midsize/.test(t))return 'midsize';
  if(/1\.0|slim|standard/.test(t))return 'standard';
  return '';
}
/* 2026-07-09 fix: the putter result's target size ("tgt", used for the
   formats/variant lookup and shown alongside the recommendation) used to be
   read from the WINNING PRODUCT's own sizes_available[0] — i.e. whatever
   size happened to be listed first on the top-ranked item — completely
   ignoring the golfer's actual psize answer. Since ~70% of putter records'
   sizes_available is just "Unspecified", this was mostly a meaningless
   label, and on the ~30% where it wasn't, it could contradict what the
   customer actually asked for (e.g. show "Standard" for a customer who
   picked Oversize, just because that's what the winning product's own
   sizes_available happened to list first). Map psize directly to the same
   size vocabulary used elsewhere (SIZE_ORDER / sizes_available strings) so
   the target reflects the customer's actual answer; falls back to null
   (caller uses the old product-derived value) only when psize is
   'nopref' or unanswered, since there's no explicit preference to map. */
function putterTargetSize(a){
  var m={standard:'Standard',midsize:'Midsize',oversize:'Jumbo/Oversize'};
  return (a&&m[a.psize])||null;
}

/* Customer-facing putter-size explanation. An explicit thickness choice is a
   preference the quiz respects, not a size it pretends to calculate. The other
   putter answers explain which models are favored inside that selected size.
   Only “No preference” produces a genuinely inferred size recommendation.
   This is a display layer only; it does not alter ranking, eligibility, or the
   selected product. */
function putterSizeRecommendation(a,s,target){
  a=a||{};
  var selected=(a.psize&&a.psize!=='nopref')?a.psize:'';
  var productClass=resolvedPutterSizeClass(s,target);
  var cls=selected||productClass;
  /* No-preference rows with truly missing size metadata still need a
     customer-facing recommendation. Infer the band from the same hand-
     stability signals already used by the putter scoring/copy layer. */
  if(!cls&&!selected){
    if(a.wristaction==='wristy'||a.pcomfort==='yes'||a.ppriority==='stability'||a.pweight==='heavy')cls='oversize';
    else if(a.wristaction==='quiet'||a.ppriority==='control'||a.pweight==='light')cls='standard';
    else cls='midsize';
  }

  var labels={standard:'Standard / slim',midsize:'Midsize',oversize:'Oversize / jumbo'};
  var label=labels[cls]||cap(cls);
  var details=[];

  if(a.wristaction==='wristy')details.push('help calm active wrists');
  else if(a.wristaction==='quiet')details.push('preserve feedback for your naturally quiet hands');
  else if(a.wristaction==='neutral')details.push('keep a balanced amount of stability and feel');

  if(a.pcomfort==='yes')details.push('reduce hand tension');
  else if(a.pcomfort==='no')details.push('keep a more connected feel');

  if(a.pweight==='light')details.push('preserve more putter-head feel');
  else if(a.pweight==='heavy')details.push('add more overall stability');
  else if(a.pweight==='medium')details.push('maintain a balanced weight');

  if(a.pfeel==='soft')details.push('favor softer, tackier models');
  else if(a.pfeel==='firm')details.push('favor firmer, more responsive models');

  if(a.ppriority==='stability')details.push('prioritize stability');
  else if(a.ppriority==='control')details.push('prioritize face control and feedback');
  else if(a.ppriority==='comfort')details.push('prioritize soft comfort');
  else if(a.ppriority==='style')details.push('favor stronger color and design options');
  else if(a.ppriority==='value')details.push('favor lower-priced qualified options');

  /* Keep the explanation focused instead of repeating every answer. */
  var chosen=[];
  details.forEach(function(x){if(chosen.indexOf(x)===-1&&chosen.length<3)chosen.push(x);});

  if(selected){
    var intro='You selected '+label+', so we kept your recommendations in that size range.';
    var follow=chosen.length?' Within that category, we favored models that '+joinNatural(chosen)+'.':'';
    return {
      size:label,
      selected:true,
      noteText:intro+follow,
      whyText:intro+follow
    };
  }

  var basis=[];
  if(cls==='oversize'){
    if(a.wristaction==='wristy')basis.push('your wrists getting too active');
    if(a.pcomfort==='yes')basis.push('your goal of reducing hand tension');
    if(a.ppriority==='stability')basis.push('stability being your main priority');
    if(!basis.length)basis.push('the stronger hand-stability signals in your answers');
  }else if(cls==='midsize'){
    if(a.wristaction==='neutral')basis.push('your average wrist action');
    if(a.pweight==='medium'||a.pweight==='nopref')basis.push('your preference for a balanced setup');
    if(a.ppriority==='stability')basis.push('your desire for more stability without going fully jumbo');
    if(!basis.length)basis.push('the balanced mix of stability and feedback in your answers');
  }else if(cls==='standard'){
    if(a.wristaction==='quiet')basis.push('your naturally quiet hands');
    if(a.pweight==='light')basis.push('your preference for more putter-head feel');
    if(a.ppriority==='control')basis.push('face control and feedback being your main priority');
    if(!basis.length)basis.push('the stronger feel-and-feedback signals in your answers');
  }

  var why=joinNatural(basis);
  return {
    size:label,
    selected:false,
    why:why,
    noteText:'Based on '+why+', we recommend '+label+'.',
    whyText:'Based on '+why+', your recommended putter grip size is '+label+'.'
  };
}
function putterSizeAdjacent(a,b){var i=PUTTER_SIZE_ORDER.indexOf(a),j=PUTTER_SIZE_ORDER.indexOf(b);return i>=0&&j>=0&&Math.abs(i-j)===1;}
/* Resolve a putter's actual size band from the most reliable available data.
   A confirmed curated putter_size/putter_size_class wins. When that band is
   unconfirmed, use explicit catalog/variant size labels instead of treating
   the product as compatible with every requested size. */
function putterSizeEvidenceClasses(s){
  if(!s)return [];
  var direct=putterSizeClass(s.putter_size_class||s.putterSizeClass)||putterSizeClass(s.putter_size);
  if(direct)return [direct];

  var out=[];
  function add(raw){
    if(raw==null)return;
    if(Array.isArray(raw)){raw.forEach(add);return;}
    var text=String(raw).trim();
    if(!text||/^(?:unknown|unconfirmed|unspecified|varies|n\/?a)$/i.test(text))return;
    var cls=putterSizeClass(text);
    if(cls&&out.indexOf(cls)===-1)out.push(cls);
  }

  add(s.sizes_available);
  add(s.manufacturer_size_labels);
  add(s.live_sizes_available);
  (s.variants||[]).forEach(function(v){add(v&&v.size);});

  /* Last-resort catalog evidence for older rows whose exported size is still
     Unspecified even though the product title/tags identify the band. */
  if(!out.length){
    add([s.model,s.display_name,s.product_title,s.source_tags,s.url].filter(Boolean).join(' '));
  }
  return out;
}
function resolvedPutterSizeClass(s,target){
  var targetClass=putterSizeClass(target);
  if(targetClass)return targetClass;
  var classes=putterSizeEvidenceClasses(s);
  return classes.length===1?classes[0]:'';
}
function sizeEligiblePutter(s,pref){
  if(!pref||pref==='nopref')return true;
  return putterSizeEvidenceClasses(s).indexOf(pref)>=0;
}
function sizeEligiblePutterAdjacent(s,pref){
  if(sizeEligiblePutter(s,pref))return true;
  return putterSizeEvidenceClasses(s).some(function(cls){return putterSizeAdjacent(cls,pref);});
}
/* 2026-07-08: track-scoped profile inputs for "both" (regrip clubs + putter
   together). getCustomerProfiles() reads every answer field it recognizes,
   club and putter alike, into ONE shared scores object. That is correct for
   the headline "you are a ___ player" summary, but it is wrong to feed the
   SAME combined profile into club-only ranking: a customer's putter answers
   (e.g. ppriority='control', pfeel='firm', stroke='arc') can drag the club
   track's primary/secondary profile toward Control/Shotmaker even when the
   club-specific answers clearly say priority='traction' and alignment=
   'nopref'. That is exactly what caused Case 10's club recommendations to be
   dominated by ALIGN models. Club ranking should only "see" club-relevant
   answers, and putter ranking should only "see" putter-relevant answers. */
var GQ_CLUB_ANSWER_KEYS=['regrip','hand','finger','tension','musthave','pressure','sweat','feel','comfort','texture','alignment','priority'];
var GQ_PUTTER_ANSWER_KEYS=['regrip','stroke','wristaction','psize','pweight','pfeel','pcomfort','ppriority'];
function scopeAnswers(a,keys){
  var o={};
  keys.forEach(function(k){if(a&&a[k]!=null)o[k]=a[k];});
  return o;
}
function clubScoringAnswers(a){return (a&&a.regrip==='both')?scopeAnswers(a,GQ_CLUB_ANSWER_KEYS):a;}
function putterScoringAnswers(a){return (a&&a.regrip==='both')?scopeAnswers(a,GQ_PUTTER_ANSWER_KEYS):a;}
function cmpClubMustHaveWithSizeTarget(target,a){
  var baseCmp=cmpRankedWithSizeTarget(target);
  return function(x,y){
    if(clubMustHaveActive(a)){
      var xc=x&&x.must_have_complete_match===true?2:(x&&x.must_have_match===true?1:0);
      var yc=y&&y.must_have_complete_match===true?2:(y&&y.must_have_match===true?1:0);
      if(yc!==xc)return yc-xc;
    }
    return baseCmp(x,y);
  };
}
function canFillStrictBrandCapSpecs(specs,count,maxPerBrand){
  var counts={},total=0;
  (specs||[]).some(function(s){
    var b=normBrandName(s&&s.brand)||'';
    if((counts[b]||0)>=maxPerBrand)return false;
    counts[b]=(counts[b]||0)+1;total++;
    return total>=count;
  });
  return total>=count;
}
function rankClub(a,t){
  a=normalizeQuizAnswers(a);
  var customerProfiles=getCustomerProfiles(clubScoringAnswers(a));
  var base=(window.GRIP_SPECS||[]).filter(function(s){return s.type==='club'&&isRecommendationEligible(s)&&!isJunk(s)&&!isExcludedGripBrand(s)&&!isSpecialtyBuildupGrip(s)&&!isNonGripAccessory(s)&&(!window.GRIP_QUIZ_TOP75_SET||isInGripQuizTop75(s));});
  var pool=t?base.filter(function(s){return sizeEligibleClub(s,t);}):base;
  if(t&&pool.length<GQ_MIN_SIZE_POOL)pool=base.filter(function(s){return sizeEligibleClubAdjacent(s,t);});
  if(t&&pool.length<GQ_MIN_SIZE_POOL)pool=base; /* last-resort relax so the quiz never dead-ends */
  var clubCmp=cmpClubMustHaveWithSizeTarget(t,a);
  var scored=pool
    .map(function(s){var r=profileMapScoreProduct(s,customerProfiles,[],a,t);var mh=clubMustHaveMatch(s,a,t),xs=sizeEligibleClub(s,t);return {s:s,score:r.score,why:r.why,customerProfiles:customerProfiles,productProfiles:r.productProfiles,must_have_match:mh,exact_size_match:xs,must_have_complete_match:mh&&xs};})
    .sort(clubCmp);
  scored=dedup(scored,t).sort(clubCmp);
  return applyScoreBasedPct(diversify(scored),false);
}
function rankPutter(a){
  var pa=putterScoringAnswers(a);
  var customerProfiles=getCustomerProfiles(pa);
  var base=(window.GRIP_SPECS||[]).filter(function(s){return s.type==='putter'&&isRecommendationEligible(s)&&!isJunk(s)&&!isExcludedGripBrand(s)&&!isSpecialtyBuildupGrip(s)&&!isNonGripAccessory(s)&&!isUnsupportedSpecialtyPutter(s,pa)&&(!window.GRIP_QUIZ_TOP75_SET||isInGripQuizTop75(s));});
  var pref=a&&a.psize;
  var hasExplicitPutterSize=!!(pref&&pref!=='nopref');
  var pool=hasExplicitPutterSize?base.filter(function(s){return sizeEligiblePutter(s,pref);}):base;
  /* Explicit putter thickness is a hard eligibility requirement. Do not
     relax to an adjacent band or the full pool: weight, feel, value, or style
     scoring may only reorder products inside the requested size band. */

  /* 2026-07-09 fix: if the customer is in a putter style/color path, restrict
     the candidate pool to real style/color options when there are enough of
     them to fill the visible list. This keeps black-only control grips like
     Golf Pride PRO Only out of style/color results while still allowing a
     fallback if the catalog has too few matching color-forward items. */
  if(stylePriorityActive(pa,customerProfiles)){
    var stylePool=pool.filter(function(s){return isPutterStyleColorCandidate(s,pa,customerProfiles);});
    if(stylePool.length>=4&&canFillStrictBrandCapSpecs(stylePool,4,2))pool=stylePool;
  }

  var scored=pool
    .map(function(s){var r=profileMapScoreProduct(s,customerProfiles,[],a,null);return {s:s,score:r.score,why:r.why,customerProfiles:customerProfiles,productProfiles:r.productProfiles};})
    .sort(cmpRanked);
  scored=dedup(scored,null).sort(cmpRanked);
  return applyScoreBasedPct(diversify(scored),true);
}

/* Fallback-path guard: true when the live checks that DID complete before the
   timeout already proved every variant of this spec is dead (404/unpublished).
   Unknown/unchecked products are kept — this only filters confirmed-dead ones. */
function specPublicationStatusSync(s){
  var vs=(s&&s.variants)||[];
  if(!vs.length)return null;
  var sawVerifiedDead=false,sawUnknown=false;
  for(var i=0;i<vs.length;i++){
    var h=vs[i].handle||getProductHandleFromUrl(vs[i].url||'');
    if(!h){sawUnknown=true;continue;}
    var page=publicProductPageStatusSync(h);
    if(page===true)return true;
    if(page===false){sawVerifiedDead=true;continue;}
    /* Sitemap absence alone is not proof of a 404; valid direct-access pages
       can be intentionally omitted. Wait for the direct HTML check. */
    sawUnknown=true;
  }
  if(sawUnknown)return null;
  return sawVerifiedDead?false:null;
}
function specKnownDead(s){
  var pub=specPublicationStatusSync(s);
  if(pub===false)return true;
  var vs=(s&&s.variants)||[];
  if(!vs.length)return false;
  var sawResult=false;
  for(var i=0;i<vs.length;i++){
    var h=vs[i].handle||getProductHandleFromUrl(vs[i].url||'');
    if(!h)return false;
    var cached=GQ_STOCK_CACHE[gqProductJsonCacheKey(h)];
    if(cached===undefined)return false; /* not checked yet — keep it */
    sawResult=true;
    if(!(cached&&cached.__missing===true))return false; /* at least one live */
  }
  return sawResult;
}
function buildResult(){
  ans=normalizeQuizAnswers(ans);
  var trk=ans.regrip,out={track:trk,customerProfiles:getCustomerProfiles(ans)};
  if(trk==='set'||trk==='both'){var sz=recommendSize(ans),r=finalRecommendationList(rankClub(ans,sz.size).filter(function(x){return !specKnownDead(x.s);}),5);
    out.club=annotateClubMustHaveResult({size:sz,top:r[0],rest:r.slice(1,5),formats:buildFormats(r[0].s,sz.size,true),color_options:buildColorOptionsFromVariants(variantsForSize(r[0].s,sz.size),true,r[0].s,stylePriorityActive(ans),buildFormats(r[0].s,sz.size,true))},ans);}
  if(trk==='putter'||trk==='both'){var rp=finalRecommendationList(rankPutter(ans).filter(function(x){return !specKnownDead(x.s);}),4),wantTgt=putterTargetSize(ans),tgt=wantTgt||(rp[0].s.sizes_available||['Unspecified'])[0];
    out.putter={top:rp[0],rest:rp.slice(1,4),formats:buildFormats(rp[0].s,tgt,false),color_options:buildColorOptionsFromVariants(variantsForSize(rp[0].s,tgt),false,rp[0].s,stylePriorityActive(ans),buildFormats(rp[0].s,tgt,false)),tgt:tgt};}
  return out;
}


/* Timeout/error fallback: only use products whose public product handles were
   verified by the public sitemap or a successful direct public HTML check. Never fall back to the
   raw spec export in theme preview, because stale export rows can still resolve
   through preview JSON while the public customer URL is a 404. */
/* 2026-07-22 fix: this used to be a real fallback that rendered ranked cards
   whenever the live pass timed out or threw. It only ever checked PUBLICATION
   (specPublicationStatusSync) — never stock — and it pulled formats and colors
   straight out of the cached grip-specs.js export via buildFormats /
   variantsForSize, with no live availability call anywhere in the path. That is
   how a sold-out grip reached the recommendations screen: nothing in this
   function could tell in-stock from sold-out.

   It now renders nothing. An empty result object makes renderFinalResults show
   the "No in-stock matches found" panel, which is the correct outcome: if the
   quiz cannot prove a grip is in stock, it must not recommend it. The ranking
   and scoring functions are intentionally no longer called here — this changes
   only what is DISPLAYED when live verification is unavailable, not how any
   product is scored or ordered when it is. */
function buildResultPublishedFallback(){
  ans=normalizeQuizAnswers(ans);
  return {track:ans.regrip,customerProfiles:getCustomerProfiles(ans),_gqUnverified:true};
}

/* ================================================================== *  DOM HELPERS  */
function el(h){var d=document.createElement('div');d.innerHTML=h.trim();return d.firstChild;}
function gqClearCollapseStyles(el){
  if(!el)return;
  ['height','max-height','opacity','overflow','transform'].forEach(function(p){el.style.removeProperty(p);});
  el.classList.remove('gq-collapse-animating');
}
function gqSetCollapse(el,open,done){
  if(!el)return;
  if(el._gqCollapseTimer)clearTimeout(el._gqCollapseTimer);

  var isShowMoreBox=el.hasAttribute&&el.hasAttribute('data-alts');
  var isDetails=el.classList&&el.classList.contains('gq-alt__details');
  var isMobile=window.matchMedia&&window.matchMedia('(max-width: 859px)').matches;

  function clearLite(){
    el.classList.remove('gq-collapse-lite','gq-collapse-lite-enter','gq-collapse-lite-exit','gq-collapse-lite-in');
  }

  function liteCollapse(openLite,ms){
    gqClearCollapseStyles(el);
    clearLite();

    if(openLite){
      el.hidden=false;
      el.classList.add('gq-collapse-open','gq-collapse-lite','gq-collapse-lite-enter');
      requestAnimationFrame(function(){
        el.classList.add('gq-collapse-lite-in');
      });
      el._gqCollapseTimer=setTimeout(function(){
        el.classList.remove('gq-collapse-lite-enter');
        if(done)done();
      },ms||240);
    }else{
      el.classList.add('gq-collapse-lite','gq-collapse-lite-exit');
      el.classList.remove('gq-collapse-open','gq-collapse-lite-in','gq-collapse-lite-enter');
      el._gqCollapseTimer=setTimeout(function(){
        el.hidden=true;
        clearLite();
        if(done)done();
      },ms||170);
    }
  }

  /* Keep the already-good mobile improvement for the big Show More dropdown,
     and also use it for product detail dropdowns on mobile. Product detail
     cards are smaller, but on phones animating height still causes a visible hitch. */
  if(isMobile&&(isShowMoreBox||isDetails)){
    liteCollapse(open,isShowMoreBox?240:220);
    return;
  }

  /* Desktop opens are fine. The lag you were seeing is mostly on retraction,
     so keep the nice height expand on open, but close with a lighter fade/slide
     to avoid forcing the browser to recalculate a large section while it shrinks. */
  if(!open&&(isShowMoreBox||isDetails)){
    liteCollapse(false,isShowMoreBox?170:150);
    return;
  }

  clearLite();
  var finish=function(){gqClearCollapseStyles(el);if(done)done();};

  if(open){
    el.hidden=false;
    el.classList.add('gq-collapse-animating','gq-collapse-open');
    el.style.setProperty('overflow','hidden','important');
    el.style.setProperty('height','0px','important');
    el.style.setProperty('max-height','0px','important');
    el.style.setProperty('opacity','0','important');
    el.style.setProperty('transform','translate3d(0,-6px,0)','important');

    requestAnimationFrame(function(){
      void el.offsetHeight;
      var h=el.scrollHeight;
      requestAnimationFrame(function(){
        el.style.setProperty('height',h+'px','important');
        el.style.setProperty('max-height',h+'px','important');
        el.style.setProperty('opacity','1','important');
        el.style.setProperty('transform','translate3d(0,0,0)','important');
      });
    });
    el._gqCollapseTimer=setTimeout(finish,380);
  }else{
    el.classList.add('gq-collapse-animating');
    el.classList.remove('gq-collapse-open');
    var start=el.scrollHeight;
    el.style.setProperty('overflow','hidden','important');
    el.style.setProperty('height',start+'px','important');
    el.style.setProperty('max-height',start+'px','important');
    el.style.setProperty('opacity','1','important');
    el.style.setProperty('transform','translate3d(0,0,0)','important');
    requestAnimationFrame(function(){
      void el.offsetHeight;
      requestAnimationFrame(function(){
        el.style.setProperty('height','0px','important');
        el.style.setProperty('max-height','0px','important');
        el.style.setProperty('opacity','0','important');
        el.style.setProperty('transform','translate3d(0,-6px,0)','important');
      });
    });
    el._gqCollapseTimer=setTimeout(function(){
      el.hidden=true;
      finish();
    },380);
  }
}
function esc(s){return (s==null?'':''+s).replace(/[&<>"]/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c];});}
function cleanVal(s){s=(s==null?'':''+s);return (/^\s*(unconfirmed|unspecified|—|-)?\s*$/i.test(s))?'':s;}
function detailVal(s){s=cleanVal(s);return (/unconfirmed|unspecified|not\s*available|n\/?a/i.test(s))?'':s;}
function cap(s){s=cleanVal(s);return s?s.charAt(0).toUpperCase()+s.slice(1):s;}
function fmtPrice(p){return p==null?'':'$'+(Math.round(p*100)/100).toFixed(2);}
function stripFormatFromName(name){
  name=cleanVal(name);
  if(!name)return '';

  return name
    .replace(/\([^)]*(?:\d+\s*pc|\d+\s*pcs|grip\s*kit|kit|bundle)[^)]*\)/ig,'')
    .replace(/\b\d+\s*(?:pc|pcs|piece|pieces)\b[^|–—-]*$/ig,'')
    .replace(/\b(?:golf\s*)?grip\s*kit\b/ig,'')
    .replace(/\bbundle\b/ig,'')
    .replace(/\s+\/\s+/g,' ')
    .replace(/\s*[|–—-]\s*$/g,'')
    .replace(/\s*\/\s*$/g,'')
    .replace(/^\s*\/\s*/g,'')
    .replace(/\s+\/\s+/g,' ')
    .replace(/\s{2,}/g,' ')
    .trim();
}

function displayNameFromHandleForGenericSpec(s){
  var h=getProductHandleFromSpec(s);
  if(!h)return '';

  /* 2026-07-09 fix: this product's spec export can be parsed as brand="Tacki-Mac",
     model="Tacki", which displayed as the unhelpful "Tacki-Mac Tacki". The
     product handle has the real customer-facing name, so use it for this known
     truncated parse. */
  if(/tacki-mac-perforated-tour-pro-wrap/i.test(h))return 'Tacki-Mac Perforated Tour Pro Wrap Standard';

  /* 2026-07-10 fix: same brand="Tacki-Mac"/model="Tacki" truncated-parse issue,
     different product (id "tacki-mac-tacki"). Its Shopify handle is
     tacki-mac-itomic-wrap-black-jumbo-grip-black-cap-with-white-cap — the
     "Black Cap With White Cap" tail is the grip's two-tone end-cap color
     description (a real, legitimate naming pattern used elsewhere in this
     catalog — see the isNonGripAccessory() comment above), but it's too long
     and confusing to show as the primary customer-facing name. Requested
     shorter display name: "Tacki-Mac Itomic Wrap Black Jumbo Grip". */
  if(/^tacki-mac-itomic-wrap-black-jumbo\b/i.test(h))return 'Tacki-Mac Itomic Wrap Black Jumbo Grip';

  return '';
}

function displayGripName(s){
  s=s||{};

  var handleDisplayName=displayNameFromHandleForGenericSpec(s);
  if(handleDisplayName)return handleDisplayName;

  var candidates=[
    s.display_name,
    s.displayName,
    s.product_title,
    s.productTitle,
    s.title,
    s.name,
    s.full_title,
    s.fullTitle
  ];

  if(s.variants&&s.variants.length){
    for(var i=0;i<s.variants.length;i++){
      var v=s.variants[i]||{};
      candidates.push(v.product_title,v.productTitle,v.title,v.name,v.full_title,v.fullTitle);
    }
  }

  for(var j=0;j<candidates.length;j++){
    var c=stripFormatFromName(candidates[j]);
    if(c && c.length>3 && !/^(unconfirmed|unspecified)$/i.test(c))return c;
  }

  var brand=cleanVal(s.brand), model=cleanVal(s.model);
  var joined=stripFormatFromName((brand+' '+model).trim());

  /* Fix bad parsed names like brand="Excel" model="/" by using brand hints.
     The real product family is Winn Excel, so keep a customer-safe display name
     instead of showing "Excel /". */
  if(/^excel\s*\/?$/i.test(joined))return 'Winn Excel';
  if(/^winn\s+excel\s*\/?$/i.test(joined))return 'Winn Excel';

  /* Some source records parse the original Dri-Tac family as brand="Winn",
     model="Dri" even though the material/product family is WinnDry / Dri-Tac.
     Show the customer-safe family name instead of a cut-off looking "Winn Dri".

     2026-07-08 fix: the old third condition here (`/\bwinn\s*dri\b/.test(displayText)
     && /winndry|dri[-\s]*tac/.test(displayText)`) was meant to catch only this narrow
     bad-parse case, but `\bwinn\s*dri\b` also matches "Winn Dri-Tac", "Winn Dri-Tac
     WRAP", "Winn Dri-Tac 2.0", etc. — and the material field says "WinnDry polymer"
     on every real Dri-Tac product, so the second half of that condition was true for
     the whole family too. Net effect: 12 distinct catalog entries (Dri-Tac, Dri-Tac
     WRAP, Dri-Tac 2.0, Dri-Tac LT, ...) all displayed as generic "Winn Dri-Tac",
     hiding which variant a customer was actually being shown. Narrowed to only the
     two conditions that target the real bad-parse case: joined text is exactly
     "winn dri", or model is exactly "dri". */
  if(/^winn\s+dri$/i.test(joined) || (brand.toLowerCase()==='winn' && /^dri$/i.test(model))){
    return 'Winn Dri-Tac';
  }

  return joined || brand || model || 'Grip';
}


/* ================================================================== *  RENDER — questions  */
var GQ_PREFETCH_TIMER=null;
var GQ_PREFETCH_SIGNATURE='';
function gqPrefetchLikelyCandidates(){
  var a=normalizeQuizAnswers(ans||{}),jobs=[],signature='';
  try{signature=JSON.stringify(a);}catch(e){signature=String(Date.now());}
  if(signature===GQ_PREFETCH_SIGNATURE)return Promise.resolve([]);
  GQ_PREFETCH_SIGNATURE=signature;

  /* v33: warm the whole fast finalist pool's stock in one batched request and
     preload the publication index while the shopper is still answering, so the
     results screen mostly resolves from cache. */
  jobs.push(gqEnsureFastBatchPrimed(a).catch(function(){return null;}));

  if(a.regrip==='set'||a.regrip==='both'){
    var size=recommendSize(a).size,clubRanked=rankClub(a,size).slice(0,4);
    clubRanked.forEach(function(item){jobs.push(buildPrimaryProductOptionLive(item.s,size,true).catch(function(){return null;}));});
  }
  if(a.regrip==='putter'||a.regrip==='both'){
    var tgt=putterTargetSize(a),putterRanked=rankPutter(a).slice(0,4);
    putterRanked.forEach(function(item){jobs.push(buildPrimaryProductOptionLive(item.s,tgt,false).catch(function(){return null;}));});
  }
  return Promise.all(jobs);
}
function scheduleLikelyCandidatePrefetch(qid){
  var late=['feel','musthave','priority','psize','pweight','pfeel','pcomfort','ppriority'];
  if(late.indexOf(qid)<0)return;
  if(GQ_PREFETCH_TIMER)clearTimeout(GQ_PREFETCH_TIMER);
  GQ_PREFETCH_TIMER=setTimeout(function(){gqPrefetchLikelyCandidates().catch(function(){});},90);
}
function activeQuestions(){if(ans.regrip==='putter')return PUTTER;if(ans.regrip==='both')return CLUB.concat(PUTTER);if(ans.regrip==='set')return CLUB;return [];}
function rebuildOrder(){order=['regrip'].concat(activeQuestions().map(function(q){return q.id;}));}

/* Smooth question-to-question transition + scroll the viewport to the answer box */
var gqQuestionTimer=null;
var gqCenterTimer=null;
var gqScrollFrame=null;

function gqEaseOutCubic(t){
  return 1-Math.pow(1-t,3);
}

function cancelSmoothScroll(){
  if(gqScrollFrame){
    try{cancelAnimationFrame(gqScrollFrame);}catch(e){}
    gqScrollFrame=null;
  }
}

function smoothScrollToY(targetY,duration){
  try{
    cancelSmoothScroll();

    var startY=window.pageYOffset||document.documentElement.scrollTop||0;
    var distance=targetY-startY;

    if(Math.abs(distance)<4){
      window.scrollTo(0,targetY);
      return;
    }

    duration=duration||680;
    var startTime=null;

    function step(ts){
      if(!startTime)startTime=ts;
      var progress=Math.min((ts-startTime)/duration,1);
      var eased=gqEaseOutCubic(progress);
      window.scrollTo(0,startY+(distance*eased));
      if(progress<1){
        gqScrollFrame=requestAnimationFrame(step);
      }else{
        gqScrollFrame=null;
      }
    }

    gqScrollFrame=requestAnimationFrame(step);
  }catch(e){
    window.scrollTo(0,targetY);
  }
}

function centerQuestionOnAnswers(){
  if(!root||root.classList.contains('gq-results-mode'))return;
  clearTimeout(gqCenterTimer);

  gqCenterTimer=setTimeout(function(){
    var box=root.querySelector('.gq-opts')||root.querySelector('#gqCard');
    if(!box)return;

    requestAnimationFrame(function(){
      try{
        var rect=box.getBoundingClientRect();
        var vh=window.innerHeight||document.documentElement.clientHeight||800;
        var current=window.pageYOffset||document.documentElement.scrollTop||0;
        var target;

        /* Center normal-sized answer boxes. If the answer box is very tall,
           align near the top so the first options are not hidden. */
        if(rect.height>vh*0.72){
          target=current+rect.top-92;
        }else{
          target=current+rect.top+(rect.height/2)-(vh/2);
        }

        var maxY=Math.max(0,document.documentElement.scrollHeight-vh);
        target=Math.max(0,Math.min(target,maxY));

        /* Custom eased scroll feels smoother than browser-native smooth scroll,
           especially while the quiz box is also animating. */
        smoothScrollToY(target,720);
      }catch(e){}
    });
  }, root&&root.classList.contains('gq-is-changing-question') ? 260 : 110);
}
function animateToStep(newIdx,direction){
  direction=direction||'next';
  if(newIdx<0)newIdx=0;
  if(newIdx>=order.length)newIdx=order.length-1;
  var card=root&&root.querySelector('#gqCard');
  if(!card){idx=newIdx;renderStep(direction);return;}

  clearTimeout(gqQuestionTimer);
  clearTimeout(gqCenterTimer);
  cancelSmoothScroll();

  /* Freeze only during the transition so the old box can fade out cleanly
     without the page collapsing, then remove it once the new question settles. */
  try{
    var h=Math.ceil(card.getBoundingClientRect().height);
    if(h>0)card.style.minHeight=h+'px';
  }catch(e){}

  root.classList.add('gq-is-changing-question');
  card.classList.remove('gq-q-enter-next','gq-q-enter-back','gq-q-exit-next','gq-q-exit-back');
  card.classList.add(direction==='back'?'gq-q-exit-back':'gq-q-exit-next');

  gqQuestionTimer=setTimeout(function(){
    idx=newIdx;
    renderStep(direction);
    setTimeout(function(){
      if(root)root.classList.remove('gq-is-changing-question');
      if(card)card.style.minHeight='';
    },330);
  },150);
}

function renderStep(transitionDir){
  setQuizMode('question');
  var qid=order[idx],q=ALLQ[qid],total=order.length,know=total>1;
  var sectionTag='';
  if(ans.regrip==='both'&&qid!=='regrip')sectionTag=PUTTER.some(function(x){return x.id===qid;})?'Putter':'Clubs';
  var card=root.querySelector('#gqCard'); card.innerHTML='';
  card.appendChild(el(
    '<div class="gq-card" data-num="'+('0'+(idx+1)).slice(-2)+'">'+
      '<div class="gq-card__eyrow"><span class="gq-card__eye">'+esc(q.eye)+(know?' · '+(idx+1)+' of '+total:'')+'</span>'+
      (sectionTag?'<span class="gq-card__sect">'+sectionTag+'</span>':'')+'</div>'+
      '<div class="gq-card__q">'+esc(q.q)+'</div>'+
      (q.hint?'<div class="gq-card__hint">'+esc(q.hint)+'</div>':'')+
      (q.measure?'<button type="button" class="gq-help" data-help>'+icon('help')+'<span>How to measure</span></button>'+
        '<div class="gq-helpbox" data-helpbox hidden>'+esc(q.measure)+'</div>':'')+
    '</div>'));
  var opts=el('<div class="gq-opts'+(q.options.length>5?' gq-opts--dense':'')+'"></div>');
  q.options.forEach(function(o){
    var b=el('<button type="button" class="gq-ob'+(ans[qid]===o.v?' sel':'')+'">'+
        '<span class="gq-ob__icon" aria-hidden="true">'+emojiIcon(o.icon)+'</span>'+
        '<span class="gq-ob__text"><span class="gq-ob__label">'+esc(o.label)+'</span>'+
        (o.desc?'<span class="gq-ob__desc">'+esc(o.desc)+'</span>':'')+'</span>'+
        '<span class="gq-ob__check">'+icon('plus')+'</span></button>');
    b.addEventListener('click',function(){
      ans[qid]=o.v;
      if(qid==='tension'||qid==='musthave')syncDerivedQuizAnswers(ans);
      scheduleLikelyCandidatePrefetch(qid);
      /* Do not re-render the first/router question when switching between
         Full set / Putter / Both. Re-rendering here caused the transition
         to restart every time a different first answer was clicked. */
      opts.querySelectorAll('.gq-ob').forEach(function(x){x.classList.remove('sel');});
      b.classList.add('sel');
      var nextBtn=root.querySelector('#gqNext');
      if(nextBtn)nextBtn.classList.add('rdy');

      if(qid==='regrip'){
        rebuildOrder();
        /* Update the progress text/count in place, without animating or
           rebuilding the answer box. */
        var eye=card.querySelector('.gq-card__eye');
        if(eye)eye.textContent=q.eye+' · '+(idx+1)+' of '+order.length;
        setProgress(progressPct());
        root.querySelector('#gqLabel').textContent=(idx+1)+' / '+order.length;
        return;
      }
    });
    opts.appendChild(b);
  });
  card.appendChild(opts);
  var hb=card.querySelector('[data-help]');
  if(hb)hb.addEventListener('click',function(){var box=card.querySelector('[data-helpbox]');if(box){box.hidden=!box.hidden;hb.classList.toggle('open',!box.hidden);}});
  var nav=el('<div class="gq-nav"></div>');
  if(idx>0){var back=el('<button type="button" class="gq-back">'+icon('rotate')+' Back</button>');back.addEventListener('click',function(){animateToStep(idx-1,'back');});nav.appendChild(back);}
  var isLast=(qid!=='regrip'&&idx===order.length-1);
  var next=el('<button type="button" id="gqNext" class="gq-next'+(ans[qid]?' rdy':'')+'">'+(isLast?'See my recommendation':'Continue')+'</button>');
  next.addEventListener('click',function(){if(!ans[qid])return;if(isLast)showResults();else{animateToStep(idx+1,'next');}});
  nav.appendChild(next); card.appendChild(nav);
  setProgress(progressPct());
  root.querySelector('#gqLabel').textContent=know?((idx+1)+' / '+order.length):'Get started';

  if(transitionDir){
    card.classList.remove('gq-q-exit-next','gq-q-exit-back','gq-q-enter-next','gq-q-enter-back');
    card.classList.add(transitionDir==='back'?'gq-q-enter-back':'gq-q-enter-next');
    setTimeout(function(){card.classList.remove('gq-q-enter-next','gq-q-enter-back');},330);
  }
  /* Do not auto-scroll on the very first page load.
     Only center the answer box after an actual question transition. */
  if(transitionDir){
    centerQuestionOnAnswers();
  }
}

/* ================================================================== *  RENDER — results  */
var _seq=0;
function fmtShort(f){if(f.n<=1)return 'Single';if(/kit/i.test(f.key))return f.n+' pc + Kit';if(f.rank===3)return f.n+' pc';return f.n+'pc';}
function chip(t){t=cleanVal(t);return t?'<span class="gq-chip">'+esc(t)+'</span>':'';}
function pillButtonsHTML(formats,cid){return (formats||[]).map(function(f){
    var onSale=f.compareAt!=null&&f.compareAt>f.price;
    return '<button type="button" class="gq-pill'+(f.primary?' is-active':'')+(onSale?' is-sale':'')+'" data-card="'+cid+'" data-url="'+esc(f.url)+'" data-price="'+(f.price!=null?f.price:'')+'" data-was="'+(onSale?f.compareAt:'')+'" data-label="'+esc(f.label)+'" data-format="'+esc(f.key)+'">'+
      '<span class="gq-pill__n">'+esc(fmtShort(f))+'</span>'+(f.price!=null?'<span class="gq-pill__p">'+(onSale?'<span class="gq-pill__was">'+fmtPrice(f.compareAt)+'</span> ':'')+fmtPrice(f.price)+'</span>':'')+'</button>';
  }).join('');}
function pillsHTML(formats,cid){if(!formats||!formats.length)return '';
  return '<div class="gq-pills" data-card="'+cid+'">'+pillButtonsHTML(formats,cid)+'</div>';}
function colorOptionsHTML(colors,cid){
  colors=colors||[];
  if(!colors.length)return '';
  return '<div class="gq-colors" data-color-card="'+cid+'"><div class="gq-colors__head">Available colors</div><div class="gq-colors__list">'+colors.map(function(c){
    var json='';try{json=JSON.stringify(c.formats||[]);}catch(e){json='[]';}
    return '<button type="button" class="gq-color'+(c.primary?' is-active':'')+'" data-color-card="'+cid+'" data-color-label="'+esc(c.label)+'" data-color-formats="'+esc(json)+'" aria-pressed="'+(c.primary?'true':'false')+'"><span class="gq-color__swatch" style="'+esc(c.swatch||'')+'"></span><span class="gq-color__label">'+esc(c.label)+'</span></button>';
  }).join('')+'</div></div>';
}
function buyHTML(formats,cid,model,slot,sm){var p=(formats&&(formats.filter(function(f){return f.primary;})[0]||formats[0]))||{};
  var onSale=p.compareAt!=null&&p.compareAt>p.price;
  return '<a class="gq-buy'+(sm?' gq-buy--sm':'')+(onSale?' is-sale':'')+'" data-cta="'+cid+'" data-model="'+esc(model)+'" data-slot="'+slot+'" data-format="'+esc(p.key||'')+'" href="'+esc(absoluteProductUrl(p.url))+'" target="_blank" rel="noopener noreferrer">'+
    '<span class="gq-buy__txt">Shop <span data-buylabel>'+esc(p.label||'this grip')+'</span></span>'+(p.price!=null?'<span class="gq-buy__price"><span class="gq-buy__was" data-was>'+(onSale?fmtPrice(p.compareAt):'')+'</span><span data-price>'+fmtPrice(p.price)+'</span></span>':'')+'</a>';}
function gqResultItemKey(s){
  if(!s)return '';
  try{return lineKey(s)||String(s.id||s.family_key||s.familyId||displayGripName(s)).toLowerCase().replace(/[^a-z0-9]+/g,'');}
  catch(e){return String(s.id||s.family_key||s.familyId||displayGripName(s)).toLowerCase().replace(/[^a-z0-9]+/g,'');}
}
function gqPurchaseOptionsHTML(item,formats,colors,cid,model,slot,sm,trackType){
  var key=(trackType||'')+'|'+gqResultItemKey(item&&item.s);
  var pending=item&&item._gqOptionsPending;
  return '<div class="gq-purchase-options" data-gq-purchase-key="'+esc(key)+'" data-gq-cid="'+esc(cid)+'" data-gq-model="'+esc(model)+'" data-gq-slot="'+esc(slot)+'" data-gq-sm="'+(sm?'1':'0')+'">'+
    colorOptionsHTML(colors||[],cid)+pillsHTML(formats||[],cid)+buyHTML(formats||[],cid,model,slot,sm)+
    (pending?'<div class="gq-options-loading" data-gq-options-loading><span class="gq-options-loading__dot"></span>Loading more colors and pack options…</div>':'')+
    '</div>';
}
function bindResultProductLinks(container,trackType){
  if(!container||!container.querySelectorAll)return;
  container.querySelectorAll('a[href]').forEach(function(a){
    var fixedHref=absoluteProductUrl(a.getAttribute('href')||'');
    if(fixedHref&&fixedHref!=='#')a.setAttribute('href',fixedHref);
    a.setAttribute('target','_blank');
    a.setAttribute('rel','noopener noreferrer');
    if(a.getAttribute('data-gq-link-bound')==='1')return;
    a.setAttribute('data-gq-link-bound','1');
    a.addEventListener('click',function(ev){
      var href=absoluteProductUrl(a.getAttribute('href')||'');
      if(href&&href!=='#')a.setAttribute('href',href);
      a.setAttribute('target','_blank');
      a.setAttribute('rel','noopener noreferrer');
      track('grip_quiz_product_clicked',{
        model:a.getAttribute('data-model')||'',
        product_title:a.getAttribute('data-model')||'',
        format:a.getAttribute('data-format')||'',
        slot:a.getAttribute('data-slot')||'',
        product_handle:getProductHandleFromUrl(href),
        url:href,
        track:trackType||ans.regrip||''
      });
      ev.stopPropagation();
    },true);
  });
}
function gqCollectHydrationItems(res){
  var map={};
  function add(track,item){if(item&&item.s)map[track+'|'+gqResultItemKey(item.s)]=item;}
  if(res&&res.club){add('club',res.club.top);(res.club.rest||[]).forEach(function(x){add('club',x);});}
  if(res&&res.putter){add('putter',res.putter.top);(res.putter.rest||[]).forEach(function(x){add('putter',x);});}
  return map;
}
/* Background option hydration is optional enrichment. A recommendation may be
   absent from the full result (for example, a fallback card or a live result
   that changed while the second pass was running), or a product may have no
   additional verified formats. In either case the initial working purchase
   option should remain, but the loading message must always be cleared. */
function settleResultPurchaseOptionLoaders(status){
  var R=root&&root.querySelector?root.querySelector('#gqResult'):null;
  if(!R)return 0;
  var cleared=0;
  R.querySelectorAll('[data-gq-options-loading]').forEach(function(node){
    if(node&&node.parentNode){node.parentNode.removeChild(node);cleared++;}
  });
  R.querySelectorAll('[data-gq-purchase-key]').forEach(function(wrap){
    wrap.classList.add('gq-options-settled');
    wrap.setAttribute('data-gq-options-status',status||'complete');
  });
  return cleared;
}
function hydrateResultPurchaseOptions(fullRes){
  var R=root&&root.querySelector?root.querySelector('#gqResult'):null;
  if(!R)return 0;
  if(!fullRes){settleResultPurchaseOptionLoaders('unavailable');return 0;}
  var map=gqCollectHydrationItems(fullRes),updated=0;
  R.querySelectorAll('[data-gq-purchase-key]').forEach(function(wrap){
    var item=map[wrap.getAttribute('data-gq-purchase-key')||''];
    if(item&&item.formats&&item.formats.length){
      item._gqOptionsPending=false;
      var cid=wrap.getAttribute('data-gq-cid')||('gqHydrated'+updated);
      var model=wrap.getAttribute('data-gq-model')||displayGripName(item.s);
      var slot=wrap.getAttribute('data-gq-slot')||'';
      var sm=wrap.getAttribute('data-gq-sm')==='1';
      wrap.innerHTML=colorOptionsHTML(item.color_options||[],cid)+pillsHTML(item.formats,cid)+buyHTML(item.formats,cid,model,slot,sm);
      updated++;
    }else{
      /* Keep the already verified primary option and simply stop showing the
         background-loading state when no additional formats were found. */
      var loader=wrap.querySelector('[data-gq-options-loading]');
      if(loader&&loader.parentNode)loader.parentNode.removeChild(loader);
    }
  });
  settleResultPurchaseOptionLoaders('complete');
  bindResultProductLinks(R,fullRes.track||ans.regrip||'');
  if(updated)R.classList.add('gq-options-hydrated');
  return updated;
}
function matchCard(s,chips,badge){
  var name=displayGripName(s);
  var brand=cleanVal(s.brand);
  var modelOnly=stripFormatFromName(cleanVal(s.model));

  if(modelOnly==='/'||/^\/?$/.test(modelOnly))modelOnly='';
  if(brand&&modelOnly&&name.toLowerCase().indexOf(brand.toLowerCase())===0){
    name=name;
  }

  return '<div class="gq-match">'+
    '<div class="gq-match__media">'+(s.image?'<img src="'+esc(s.image)+'" alt="'+esc(name)+'" loading="lazy">':icon('club'))+'</div>'+
    '<div class="gq-match__body">'+(badge?'<span class="gq-badge">'+esc(badge)+'</span>':'')+
      '<div class="gq-match__brand">'+esc(brand||'Recommended grip')+'</div><div class="gq-match__name">'+esc(name)+'</div>'+
      '<div class="gq-match__tags">'+chips.map(chip).join('')+'</div></div></div>';
}
function joinNatural(items){
  items=(items||[]).filter(Boolean);
  if(!items.length)return '';
  if(items.length===1)return items[0];
  if(items.length===2)return items[0]+' and '+items[1];
  return items.slice(0,-1).join(', ')+', and '+items[items.length-1];
}
function clubMatchPhrases(s,a,target){
  a=normalizeQuizAnswers(a);
  var matches=[],sizes=(s&&s.sizes_available)||[];
  if(target&&sizes.indexOf(target)>=0)matches.push('it is available in your recommended '+target+' size');
  if(a.feel==='soft'&&s.feel==='soft')matches.push('its softer construction matches the cushioned feel you chose');
  else if(a.feel==='firm'&&s.feel==='firm')matches.push('its firmer construction matches the responsive feel you chose');
  else if(a.feel==='balanced'&&s.feel==='medium')matches.push('its medium feel matches your balanced preference');

  if(a.sweat==='wet'){
    if(productHasCord(s))matches.push('the corded surface provides the wet-weather traction you need');
    else if(/maximum_wet|all_weather|all-weather/i.test(String(s.weather_performance||s.weather||'')))matches.push('its all-weather design suits the rain and damp conditions you mentioned');
  }else if(a.sweat==='sweaty'&&(productHasCord(s)||/humid_sweat|all_weather|maximum_wet|all-weather/i.test(String(s.weather_performance||s.weather||''))||/high|very_high/i.test(String(s.tack_level||s.tack||'')))){
    matches.push('its added traction helps when your hands get sweaty');
  }

  if(a.comfort==='yes'&&(s.feel==='soft'||has(/dampening|polymer|elastomer|winndry|shock/i,(s.material||'')+' '+(s.shopify_description||'')))){
    matches.push('its cushioning and vibration-dampening traits address the hand or wrist discomfort you reported');
  }
  if(a.pressure==='tight'&&isReducedTaperGrip(s))matches.push('its reduced-taper lower hand can help you hold the club with less tension');

  if(a.musthave==='cordedalign'&&productHasCord(s)&&productHasAlignmentAid(s))matches.push('it combines corded traction with the '+alignmentAidPhrase(s)+' you required');
  else if(a.musthave==='corded'&&productHasCord(s))matches.push('it satisfies your must-have corded texture');
  else if(a.musthave==='wrap'&&productIsWrap(s))matches.push('it satisfies your must-have wrap-style surface');
  else if(a.musthave==='align'&&productHasAlignmentAid(s))matches.push('it includes the raised alignment ridge you said was essential');
  else if(a.musthave==='round'&&alignmentAidType(s)==='round')matches.push('it keeps the standard round, ridge-free shape you requested');
  else if(a.musthave==='reducedtaper'&&isReducedTaperGrip(s))matches.push('it has the reduced-taper or larger lower-hand shape you required');
  else if(a.musthave==='style'&&isStyleForwardGrip(s,target))matches.push('it offers the color or special-design character you required');

  return matches.filter(function(x,i,arr){return arr.indexOf(x)===i;});
}
function clubTradeoffPhrases(s,a,target){
  a=normalizeQuizAnswers(a);
  var misses=[],sizes=(s&&s.sizes_available)||[];
  if(target&&sizes.length&&sizes.indexOf(target)<0)misses.push('it is not as exact a match for your recommended '+target+' size');
  if(a.feel==='soft'&&s.feel&&s.feel!=='soft')misses.push('its feel is not as soft as your first choice');
  else if(a.feel==='firm'&&s.feel&&s.feel!=='firm')misses.push('its feel is not as firm and responsive as your first choice');
  if(a.sweat==='wet'&&!(productHasCord(s)||/maximum_wet|all_weather|all-weather/i.test(String(s.weather_performance||s.weather||''))))misses.push('it gives up some wet-weather traction');
  if(a.sweat==='sweaty'&&!(productHasCord(s)||/humid_sweat|all_weather|maximum_wet|all-weather/i.test(String(s.weather_performance||s.weather||''))||/high|very_high/i.test(String(s.tack_level||s.tack||''))))misses.push('it is not as traction-focused for sweaty hands');
  if(a.musthave==='cordedalign'&&(!productHasCord(s)||!productHasAlignmentAid(s)))misses.push('it does not combine corded traction and an alignment aid as completely as the top match');
  else if(a.musthave==='corded'&&!productHasCord(s))misses.push('it does not match your corded must-have as directly');
  else if(a.musthave==='wrap'&&!productIsWrap(s))misses.push('it does not match your wrap-style must-have as directly');
  else if(a.musthave==='align'&&!productHasAlignmentAid(s))misses.push('it does not provide the alignment aid you requested');
  else if(a.musthave==='round'&&productHasAlignmentRidge(s))misses.push('it includes a ridge even though you preferred a standard round grip');
  else if(a.musthave==='reducedtaper'&&!isReducedTaperGrip(s))misses.push('it does not emphasize the larger lower-hand shape as strongly');
  else if(a.musthave==='style'&&!isStyleForwardGrip(s,target))misses.push('it is less color- or design-forward than your top match');
  return misses;
}
function putterMatchPhrases(s,a,target){
  var matches=[],shape=putterShapeClass(s&&s.putter_shape),size=putterSizeClass(s&&s.putter_size),w=avgWeight(s||{});
  if(a.psize&&a.psize!=='nopref'&&size===a.psize)matches.push('its '+a.psize+' thickness matches the size you selected');
  if(a.wristaction==='wristy'&&size==='oversize')matches.push('the larger profile helps quiet the wrist action you described');
  if(a.pfeel==='soft'&&s.feel==='soft')matches.push('its softer feel matches your comfort preference');
  else if(a.pfeel==='firm'&&s.feel==='firm')matches.push('its firmer feel gives the feedback you requested');
  if(a.pweight==='light'&&w!=null&&w<=60)matches.push('its lighter weight preserves more putter-head feel');
  else if(a.pweight==='heavy'&&w!=null&&w>=85)matches.push('its heavier weight adds the stability you requested');
  else if(a.pweight==='medium'&&w!=null&&w>60&&w<85)matches.push('its mid-range weight gives you the balanced feel you selected');
  if(a.stroke==='straight'&&shape==='FLAT')matches.push('its flat-front shape matches the straight-back, straight-through stroke answer');
  else if(a.stroke==='slight'&&shape==='PISTOL')matches.push('its pistol shape suits the slight-arc stroke you selected');
  else if(a.stroke==='arc'&&(shape==='ROUND'||shape==='PISTOL'))matches.push('its shape allows the face to release through the stronger arc you described');
  if(stylePriorityActive(a,getCustomerProfiles(a))&&isStyleForwardGrip(s,target))matches.push('it also fits the color and style importance you selected');
  return matches.filter(function(x,i,arr){return arr.indexOf(x)===i;});
}
function putterTradeoffPhrases(s,a,target){
  var misses=[],shape=putterShapeClass(s&&s.putter_shape),size=putterSizeClass(s&&s.putter_size),w=avgWeight(s||{});
  if(a.psize&&a.psize!=='nopref'&&size&&size!==a.psize)misses.push('its thickness is not as exact a match for the size you chose');
  if(a.pfeel==='soft'&&s.feel&&s.feel!=='soft')misses.push('it is not as soft as your top match');
  else if(a.pfeel==='firm'&&s.feel&&s.feel!=='firm')misses.push('it is not as firm and responsive as your top match');
  if(a.pweight==='light'&&w!=null&&w>60)misses.push('it is heavier than your stated preference');
  else if(a.pweight==='heavy'&&w!=null&&w<85)misses.push('it is lighter than your stated preference');
  if(a.stroke==='straight'&&shape&&shape!=='FLAT')misses.push('its shape is a less direct match for your straighter stroke');
  else if(a.stroke==='arc'&&shape==='FLAT')misses.push('its flatter shape is a less direct match for your stronger arc');
  if(stylePriorityActive(a,getCustomerProfiles(a))&&!isStyleForwardGrip(s,target))misses.push('it is less style-forward than the top recommendation');
  return misses;
}
function priorityPhrase(a,track){
  if(track==='club'){
    var m={comfort:'maximum comfort',traction:'traction',control:'control and feedback',size:'reduced hand tension',style:'color and style',value:'overall value'};
    return m[a.priority]||'overall fit';
  }
  var p={stability:'stability',control:'face control',comfort:'soft comfort',style:'color and style',value:'overall value'};
  return p[a.ppriority]||'overall fit';
}
function topDecisionSentence(item,track,target,a){
  var s=item&&item.s;if(!s)return '';
  if(track==='club'){
    var exact=clubMustHaveMatch(s,a,target),p=a.priority;
    if(clubMustHaveActive(a)&&(!exact||item.exact_size_match===false))return item.exact_size_match===false&&exact
      ?'No live option combined your required feature with the exact recommended size, so this is the closest feature match and the size compromise is shown above.'
      :'No exact in-stock match satisfied every must-have requirement, so this is the closest available option after preserving your recommended size and strongest remaining fit signals.';
    if(p==='comfort'&&s.feel==='soft')return 'It earned the top spot because it delivered the strongest comfort match among the products that satisfied your required feature and size.';
    if(p==='traction'&&(productHasCord(s)||/humid_sweat|all_weather|maximum_wet|all-weather/i.test(String(s.weather_performance||s.weather||''))))return 'It earned the top spot because it provided the strongest traction package among the products that satisfied your required feature and size.';
    if(p==='control'&&(s.feel==='firm'||productHasAlignmentAid(s)))return 'It earned the top spot because its responsive feel and hand-placement support best matched your control priority after your required feature was applied.';
    if(p==='size'&&(isReducedTaperGrip(s)||((s.sizes_available||[]).indexOf(target)>=0)))return 'It earned the top spot because its size and lower-hand profile best addressed the hand tension you described while preserving your required feature.';
    if(p==='style'&&isStyleForwardGrip(s,target))return 'It earned the top spot because it combined a true color/design option with the strongest overall fit to your size and required feature.';
    if(p==='value')return 'It earned the top spot because it combined strong answer-fit with one of the better live per-grip prices among the eligible recommendations.';
    return 'It earned the top spot because it was the strongest overall match after your required feature, size, feel, and playing conditions were applied.';
  }
  if(a.ppriority==='value')return 'It earned the top spot because it combined a dependable putter-grip fit with one of the better current prices among the live options.';
  if(a.ppriority==='style')return 'It earned the top spot because it offered the strongest color/design match without giving up the putter size and feel signals you selected.';
  if(a.ppriority==='stability')return 'It earned the top spot because its size and weight profile best addressed the wrist activity and stability you described.';
  if(a.ppriority==='control')return 'It earned the top spot because its shape and responsive feel gave the strongest match to your face-control priority.';
  if(a.ppriority==='comfort')return 'It earned the top spot because its softer feel and hand-calming profile best matched your comfort priority.';
  return 'It earned the top spot because it matched more of your putter size, feel, weight, and stroke answers than the other live options.';
}
function alternativeRoleCandidates(item,track,target,a){
  var s=item&&item.s||{},out=[];
  if(track==='club'){
    if(clubMustHaveActive(a)&&clubMustHaveMatch(s,a,target))out.push('Exact-feature alternative');
    if(s.feel==='soft')out.push('Comfort alternative');
    if(has(/cord/i,s.texture)||s.weather==='all-weather'||s.tack==='high')out.push('Traction alternative');
    if(productHasAlignmentAid(s))out.push('Alignment alternative');
    if(isReducedTaperGrip(s))out.push('Reduced-taper alternative');
    if(isStyleForwardGrip(s,target))out.push('Style alternative');
    out.push('Balanced alternative');
  }else{
    var cls=putterSizeClass(s.putter_size),w=avgWeight(s);
    if(cls==='oversize'||(w!=null&&w>=85))out.push('Stability alternative');
    if(s.feel==='soft')out.push('Comfort alternative');
    if(s.feel==='firm')out.push('Feedback alternative');
    if(isStyleForwardGrip(s,target))out.push('Style alternative');
    if(liveUnitPrice(item)!=null)out.push('Value alternative');
    out.push('Balanced alternative');
  }
  return out;
}
function assignAlternativeRoles(rest,track,target){
  var a=track==='club'?normalizeQuizAnswers(clubScoringAnswers(ans)):putterScoringAnswers(ans),used={};
  (rest||[]).forEach(function(item,idx){
    var choices=alternativeRoleCandidates(item,track,target,a),role='Strong overall alternative';
    for(var i=0;i<choices.length;i++){if(!used[choices[i]]){role=choices[i];break;}}
    used[role]=true;item.alt_role=role;
  });
  return rest;
}
function topPersonalizedWhy(item,track,target){
  if(!item||!item.s)return '';
  var s=item.s,name=displayGripName(s),a=track==='club'?normalizeQuizAnswers(clubScoringAnswers(ans)):putterScoringAnswers(ans);
  var matches=track==='club'?clubMatchPhrases(s,a,target):putterMatchPhrases(s,a,target);
  var sentences=[];
  if(track==='club'){
    var sizeInputs=[];
    if(a.hand==='small')sizeInputs.push('smaller hands');
    else if(a.hand==='average')sizeInputs.push('average-size hands');
    else if(a.hand==='large')sizeInputs.push('larger hands');
    else if(a.hand==='verylarge')sizeInputs.push('very large hands');
    else sizeInputs.push('an uncertain hand-size starting point');
    if(a.finger==='thin')sizeInputs.push('your current grips feeling too thin');
    else if(a.finger==='thick')sizeInputs.push('your current grips feeling too thick');
    if(a.tension==='tight'||a.tension==='both')sizeInputs.push('your tendency to squeeze tightly');
    if(target)sentences.push('Based on '+joinNatural(sizeInputs.slice(0,3))+', your recommended grip size is '+target+'.');

    var customer=[];
    if(a.feel)customer.push(labelOf('feel',a.feel).toLowerCase()+' feel');
    if(a.sweat==='sweaty')customer.push('extra traction for sweaty hands');
    else if(a.sweat==='wet')customer.push('wet-weather traction');
    if(a.tension==='pain')customer.push('more hand and wrist comfort');
    else if(a.tension==='both')customer.push('more cushioning as well as less tension');
    if(a.musthave&&a.musthave!=='none')customer.push(labelOf('musthave',a.musthave).toLowerCase()+' as a must-have');
    if(customer.length)sentences.push('You also told us you want '+joinNatural(customer.slice(0,4))+'.');
  }else{
    var putterSizeInfo=putterSizeRecommendation(a,s,target);
    if(putterSizeInfo)sentences.push(putterSizeInfo.whyText||putterSizeInfo.noteText||'');

    var pc=[];
    if(a.stroke)pc.push(labelOf('stroke',a.stroke).toLowerCase()+' stroke fit');
    if(a.wristaction==='wristy')pc.push('more help quieting your wrists');
    if(a.pfeel&&a.pfeel!=='nopref')pc.push(labelOf('pfeel',a.pfeel).toLowerCase()+' feel');
    if(a.pweight&&a.pweight!=='nopref')pc.push(labelOf('pweight',a.pweight).toLowerCase()+' weight');
    if(a.pcomfort==='yes')pc.push('less hand tension');
    if(!pc.length)pc.push('a balanced, easy-to-fit putter grip');
    sentences.push('You also told us you want '+joinNatural(pc.slice(0,4))+'.');
  }
  if(matches.length)sentences.push(name+' fits because '+joinNatural(matches.slice(0,4))+'.');
  var topTradeoffs=track==='club'?clubTradeoffPhrases(s,a,target):putterTradeoffPhrases(s,a,target);
  if(topTradeoffs.length)sentences.push('The main compromise is that '+joinNatural(topTradeoffs.slice(0,2))+'.');
  sentences.push(topDecisionSentence(item,track,target,a));
  return sentences.join(' ');
}
function alternativePersonalizedWhy(item,topItem,track,target){
  if(!item||!item.s)return '';
  var s=item.s,name=displayGripName(s),topName=topItem&&topItem.s?displayGripName(topItem.s):'the top match';
  var a=track==='club'?normalizeQuizAnswers(clubScoringAnswers(ans)):putterScoringAnswers(ans);
  var matches=track==='club'?clubMatchPhrases(s,a,target):putterMatchPhrases(s,a,target);
  var tradeoffs=track==='club'?clubTradeoffPhrases(s,a,target):putterTradeoffPhrases(s,a,target);
  var role=(item.alt_role||'Strong alternative').toLowerCase();
  var first=matches.length
    ? name+' is your '+role+' because '+joinNatural(matches.slice(0,3))+'.'
    : name+' is your '+role+' because it still matches your broader player profile and several of your scoring preferences.';
  var valueMode=track==='putter'?(a.ppriority==='value'):(a.priority==='value');
  var itemFit=Number(fitPct(item)),topFit=Number(fitPct(topItem));
  var second;
  if(valueMode&&isFinite(itemFit)&&isFinite(topFit)&&itemFit>topFit){
    var itemPrice=Number(item.live_value_price),topPrice=Number(topItem&&topItem.live_value_price);
    var priceUnit=track==='club'?' per grip':'';
    if(isFinite(itemPrice)&&itemPrice>0&&isFinite(topPrice)&&topPrice>0&&itemPrice>topPrice){
      var savings=itemPrice-topPrice;
      second='It has the higher pure Fit % ('+itemFit+'% versus '+topFit+'%), but it ranks lower because Best Value also weighs verified price. '+topName+' costs about '+fmtPrice(savings)+' less'+priceUnit+', giving it the stronger price-to-fit balance.';
    }else{
      second='It has the higher pure Fit % ('+itemFit+'% versus '+topFit+'%), but it ranks lower because Best Value also weighs verified price and '+topName+' offered the stronger overall price-to-fit balance.';
    }
  }else{
    second=tradeoffs.length
      ? 'It ranks behind '+topName+' because '+joinNatural(tradeoffs.slice(0,2))+'.'
      : 'It ranks just behind '+topName+' because the top match combined more of your exact answers and your '+priorityPhrase(a,track)+' priority at the same time.';
  }
  return first+' '+second;
}

function fullProductDescription(item,target){
  var s=item.s||{};
  var custom=cleanVal(s.description||s.product_description||s.productDescription||s.body||s.summary||s.desc||'');
  var parts=[];
  var reasons=(item.why||[]).map(whySentence).filter(Boolean).slice(0,3);

  if(custom){
    parts.push(custom);
  } else if(reasons.length){
    parts.push(reasons.join(' '));
  }

  var details=[];
  var size=detailVal(target);
  var shape=detailVal(s.putter_shape);
  var psize=detailVal(s.putter_size);
  var material=detailVal(s.material);
  var feel=detailVal(s.feel);
  var texture=detailVal(s.texture);
  var weather=detailVal(s.weather);
  var alignment=detailVal(s.alignment);

  if(size)details.push('it is offered in your recommended '+size+' size');
  if(shape)details.push('the putter profile is '+cap(shape));
  if(psize)details.push('the putter grip size is '+cap(psize));
  if(material)details.push('the material is '+cap(material));
  if(feel)details.push('the feel is '+cap(feel));
  if(texture)details.push('the texture is '+cap(texture));
  if(weather)details.push('it is built for '+weather+' conditions');
  if(alignment)details.push('the alignment style is '+cap(alignment));

  if(details.length){
    var detailText='Key details to know: '+details.map(function(x,i){
      if(i===0)return x.charAt(0).toUpperCase()+x.slice(1);
      return x;
    }).join('; ');
    if(!/[.!?]$/.test(detailText))detailText+='.';
    parts.push(detailText);
  }

  return parts.join(' ') || 'Tap the shop button to view the full product page, available options, and current pricing.';
}
function altCard(item,target,wantSet,slot,topItem,track){
  var s=item.s,cid='alt'+(++_seq),formats=item.formats||buildFormats(s,target,wantSet);
  var desc=alternativePersonalizedWhy(item,topItem,track,target)||fullProductDescription(item,target);
  var name=displayGripName(s);
  var shownPct=fitPct(item);
  var fitLabel=confidenceLabel(shownPct);
  var fitPctText=shownPct?(shownPct+'% fit'):'';
  var fitHTML='<div class="gq-alt__fit"><span class="gq-alt__fit-label">'+esc(fitLabel)+'</span>'+
    (fitPctText?'<span class="gq-alt__fit-sep">·</span><span class="gq-alt__fit-pct">'+esc(fitPctText)+'</span>':'')+'</div>';
  return '<div class="gq-alt" data-alt-card data-gq-item-key="'+esc(gqResultItemKey(s))+'">'+
    '<div class="gq-alt__top" data-alt-toggle role="button" tabindex="0" aria-expanded="false" title="View product details">'+(s.image?'<img class="gq-alt__img" src="'+esc(s.image)+'" alt="" loading="lazy">':'<span class="gq-alt__img">'+icon('club')+'</span>')+
      '<div class="gq-alt__info"><div class="gq-alt__name" title="'+esc(name)+'">'+esc(name)+'</div>'+ 
      '<div class="gq-alt__meta">'+esc(cap(s.material)||'Grip')+(cleanVal(s.feel)?' · '+esc(cap(s.feel))+' feel':'')+'</div>'+ 
      fitHTML+'</div>'+ 
      '<span class="gq-alt__chev" aria-hidden="true">'+icon('moon')+'</span></div>'+ 
    '<div class="gq-alt__details" hidden><span class="gq-alt__details-k">Why this match works</span><p>'+esc(desc)+'</p></div>'+ 
    gqPurchaseOptionsHTML(item,formats,item.color_options||[],cid,name,slot,true,track)+'</div>';
}
function humanizeSpecValue(v){
  v=cleanVal(v);
  if(!v)return '';
  v=v.replace(/_/g,' ').replace(/\s+/g,' ').trim();
  return cap(v);
}
function specGrid(items){return '<div class="gq-specs">'+items.map(function(it){var v=humanizeSpecValue(it[1]);return '<div class="gq-spec"><div class="gq-spec__label">'+esc(it[0])+'</div><div class="gq-spec__val">'+esc(v||'—')+'</div></div>';}).join('')+'</div>';}
function clubExactMatchText(c){
  if(!c||!c.must_have_active)return '';
  var count=Number(c.exact_complete_count||0);
  return count===0?'No exact match':count+' exact match'+(count===1?'':'es');
}
function clubExactDesktopBadge(c){
  /* Desktop exact-match badge intentionally removed. It competed for space
     with the purchase controls and could overlap the Why Size explanation.
     The detailed exact-match/fallback notice remains available on mobile. */
  return '';
}
function whySentence(t){
  t=(t==null?'':''+t).trim();
  if(!t)return '';
  t=t.charAt(0).toUpperCase()+t.slice(1);
  if(!/[.!?]$/.test(t))t+='.';
  return t;
}
function whyHTML(item,track,target){
  var personalized=topPersonalizedWhy(item,track,target);
  if(personalized)return '<div class="gq-why"><span class="gq-why__k">Why this fits you</span><p>'+esc(personalized)+'</p></div>';
  var why=((item&&item.why)||[]).map(whySentence).filter(Boolean).slice(0,4);
  return why.length?'<div class="gq-why"><span class="gq-why__k">Why this fits you</span><p>'+esc(why.join(' '))+'</p></div>':'';
}
function altsBlock(rest,target,wantSet,slot,topItem,track){
  if(!rest||!rest.length)return '';assignAlternativeRoles(rest,track,target);var id='alts'+(++_seq);
  return '<div class="gq-more"><button type="button" class="gq-more__btn" data-toggle="'+id+'" aria-expanded="false" data-closed-text="Show '+rest.length+' more strong matches">'+
      '<span data-more-text>Show '+rest.length+' more strong matches</span>'+icon('moon')+'</button>'+
    '<div class="gq-alts" data-alts="'+id+'" hidden>'+rest.map(function(r){return altCard(r,target,wantSet,slot,topItem,track);}).join('')+'</div></div>';
}

function clubMustHaveNotice(c){
  if(!c||!c.must_have_active||!c.must_have_fallback)return '';
  var a=normalizeQuizAnswers(clubScoringAnswers(ans));
  var label=labelOf('musthave',a.musthave).toLowerCase();
  if(c.no_exact_must_have){
    return '<div class="gq-mobile-match-notice gq-exact-mobile"><span>'+icon('help')+'</span><span><b>No exact live match found.</b> We could not confirm an in-stock '+esc(c.size.size)+' grip with '+esc(label)+'. The recommendations below are the closest available options, and each explanation identifies the compromise.</span></div>';
  }
  return '<div class="gq-mobile-match-notice gq-exact-mobile"><span>'+icon('help')+'</span><span><b>'+esc(String(c.exact_complete_count))+' exact size-and-feature match'+(c.exact_complete_count===1?'':'es')+'.</b> Remaining products are shown only as closest alternatives in case you are flexible.</span></div>';
}
function clubPanel(c){
  var s=c.top.s,cid='heroClub';
  var chips=[cap(s.material),s.feel?cap(s.feel)+' feel':'',cap(s.weather),'Size: '+c.size.size];
  return '<div class="gq-panelhead"><span class="gq-panelhead__eye">Your club grip</span>'+
      '<h3 class="gq-panelhead__h">Best fit — '+esc(c.size.size)+'</h3>'+
      '<p class="gq-panelhead__sub">Matched to your size, feel, playing conditions, must-have feature, and main priority.</p></div>'+
    matchCard(s,chips,((ans.priority==='value')?'Best value':'Best match')+(fitPct(c.top)?' · '+fitPct(c.top)+'% fit':''))+clubMustHaveNotice(c)+whyHTML(c.top,'club',c.size.size)+
    '<div class="gq-buybox"><div class="gq-buybox__head">Pick your pack — single, bundle or grip kit</div>'+
      gqPurchaseOptionsHTML(c.top,c.formats,c.top.color_options||c.color_options||[],cid,displayGripName(s),'club_hero',false,'club')+'</div>'+
    '<div class="gq-sizenote gq-size-explanation">'+icon('ruler')+'<span><b>Why '+esc(c.size.size)+'?</b> Based on '+esc(c.size.why)+'.</span></div>'+
    specGrid([['Material',s.material],['Feel',s.feel],['Weather',s.weather],['Texture',s.texture],['Alignment',clubAlignmentDisplay(s)],['Taper',s.taper_profile||s.taperProfile||'']])+
    altsBlock(c.rest,c.size.size,true,'club_alt',c.top,'club');
}
function putterPanel(p){
  var s=p.top.s,cid='heroPutt',sizeInfo=putterSizeRecommendation(putterScoringAnswers(ans),s,p.tgt);
  var chips=[cap(s.putter_shape||''),cap(s.putter_size||''),s.feel?cap(s.feel)+' feel':'',cap(s.material)];
  var sizeNote=sizeInfo?'<div class="gq-sizenote gq-size-explanation">'+icon('ruler')+'<span><b>Why '+esc(sizeInfo.size)+'?</b> '+esc(sizeInfo.noteText||'')+'</span></div>':'';
  return '<div class="gq-panelhead"><span class="gq-panelhead__eye">Your putter grip</span>'+ 
      '<h3 class="gq-panelhead__h">Best fit — '+esc(cap(s.putter_shape)||'Putter')+(cleanVal(s.putter_size)?' · '+esc(cap(s.putter_size)):'')+'</h3>'+ 
      '<p class="gq-panelhead__sub">Matched to your stroke, hand action, size, feel, and main priority.</p></div>'+ 
    matchCard(s,chips,((ans.ppriority==='value')?'Best value':'Best match')+(fitPct(p.top)?' · '+fitPct(p.top)+'% fit':''))+whyHTML(p.top,'putter',p.tgt)+
    '<div class="gq-buybox"><div class="gq-buybox__head">Get this grip</div>'+ 
      gqPurchaseOptionsHTML(p.top,p.formats,p.top.color_options||p.color_options||[],cid,displayGripName(s),'putter_hero',false,'putter')+'</div>'+ 
    sizeNote+
    specGrid([['Shape',s.putter_shape],['Size',s.putter_size],['Feel',s.feel],['Material',s.material],['Weather',s.weather],['Tack',s.tack]])+
    altsBlock(p.rest,p.tgt,false,'putter_alt',p.top,'putter');
}

/* Collect every recommended product handle from the rendered result DOM
   (hero buy buttons, format pills, alt links) and persist the quiz context
   to localStorage + cart attributes so downstream layers can attribute
   add-to-cart / checkout / purchase events to this quiz session. */
function persistGripQuizResults(res,profile){
  try{
    var R=root&&root.querySelector?root.querySelector('#gqResult'):null;
    if(!R)return;

    var recHandles=[], recObjects=[], seen={};
    function addHandle(h,title){
      if(!h||seen[h])return;
      seen[h]=true;
      recHandles.push(h);
      recObjects.push({handle:h,title:title||'',rank:recHandles.length});
    }
    /* Product links carry the most reliable handle + model name. */
    R.querySelectorAll('a[href]').forEach(function(a){
      var h=getProductHandleFromUrl(absoluteProductUrl(a.getAttribute('href')||''));
      if(h)addHandle(h,a.getAttribute('data-model')||'');
    });
    /* Format pills hold variant URLs that may not be on a link yet. */
    R.querySelectorAll('.gq-pill[data-url]').forEach(function(p){
      var h=getProductHandleFromUrl(absoluteProductUrl(p.getAttribute('data-url')||''));
      if(h)addHandle(h,'');
    });

    var sessionId=getGripQuizSessionId();
    var phDistinctId=(window.posthog&&typeof posthog.get_distinct_id==='function')?posthog.get_distinct_id():sessionId;

    var recTitles=recObjects.map(function(r){return r.title;}).filter(Boolean);

    try{
      localStorage.setItem('grip_quiz_ph_distinct_id',phDistinctId);
      localStorage.setItem('grip_quiz_completed_at',String(Date.now()));
      localStorage.setItem('grip_quiz_rec_handles',JSON.stringify(recHandles));
      localStorage.setItem('grip_quiz_recs',JSON.stringify(recObjects));
      localStorage.setItem('grip_quiz_rec_count',String(recHandles.length));
      localStorage.setItem('grip_quiz_atc_tracked','[]');
      localStorage.setItem('grip_quiz_buynow_tracked','[]');
    }catch(e){}

    /* Register super properties so every later grip_quiz_* event carries
       the recommendation context. */
    registerGripQuizPostHogProps({
      grip_quiz_completed:true,
      grip_quiz_track:(profile&&profile.track)||'',
      grip_quiz_club_model:(profile&&profile.club_model)||'',
      grip_quiz_club_size:(profile&&profile.club_size)||'',
      grip_quiz_putter_model:(profile&&profile.putter_model)||'',
      grip_quiz_primary_profile:(profile&&profile.primary_player_profile)||'',
      grip_quiz_secondary_profile:(profile&&profile.secondary_player_profile)||'',
      recommended_count:recHandles.length,
      recommended_handles:recHandles.slice(0,5).join('|'),
      recommended_handle_1:recHandles[0]||'',
      recommended_handle_2:recHandles[1]||'',
      recommended_handle_3:recHandles[2]||''
    });

    /* Stamp the cart so the Shopify checkout pixel can read the session even
       across the checkout domain. */
    fetch('/cart/update.js',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({attributes:{
        grip_quiz_session_id:sessionId,
        grip_quiz_ph_distinct_id:phDistinctId,
        grip_quiz_completed:'yes',
        grip_quiz_track:(profile&&profile.track)||'',
        grip_quiz_club_model:(profile&&profile.club_model)||'',
        grip_quiz_club_size:(profile&&profile.club_size)||'',
        grip_quiz_putter_model:(profile&&profile.putter_model)||'',
        grip_quiz_primary_profile:(profile&&profile.primary_player_profile)||'',
        grip_quiz_secondary_profile:(profile&&profile.secondary_player_profile)||'',
        grip_quiz_rec_handles:recHandles.join(','),
        grip_quiz_rec_count:String(recHandles.length),
        grip_quiz_top_rec_1:recHandles[0]||'',
        grip_quiz_top_rec_2:recHandles[1]||'',
        grip_quiz_top_rec_3:recHandles[2]||''
      }})
    }).catch(function(){});
  }catch(e){}
}


function removeAddonPopup(){
  var old=document.getElementById('gqAddonPopup');
  if(old&&old._gqInlineWiggleTimer)clearInterval(old._gqInlineWiggleTimer);
  if(old&&old._gqDesktopBounceTimer)clearInterval(old._gqDesktopBounceTimer);
  if(old&&old.parentNode)old.parentNode.removeChild(old);

  var floating=document.getElementById('gqAddonFloatingPopup');
  if(floating&&floating._gqDesktopBounceTimer)clearInterval(floating._gqDesktopBounceTimer);
  if(floating&&floating.parentNode)floating.parentNode.removeChild(floating);
}

function gqAddonDesktopBounce(pop,delay){
  try{
    if(!pop)return;
    var desktop=(window.innerWidth||document.documentElement.clientWidth||0)>760;
    if(!desktop)return;

    delay=delay||0;
    setTimeout(function(){
      if(!pop||!pop.parentNode||pop.classList.contains('is-closing'))return;

      var baseBottom=22;
      var duration=1180;
      var startTime=null;

      function easeOutCubic(t){return 1-Math.pow(1-t,3);}
      function easeInCubic(t){return t*t*t;}
      function easeOutBack(t){
        var c1=1.70158;
        var c3=c1+1;
        return 1+c3*Math.pow(t-1,3)+c1*Math.pow(t-1,2);
      }
      function lerp(a,b,t){return a+(b-a)*t;}

      function stateAt(p){
        var bottom=baseBottom, sx=1, sy=1, rot=0, glow=0;

        /* Crouch → jump → land/squash → recoil → settle */
        if(p < .12){
          var t=p/.12;
          bottom=lerp(baseBottom,baseBottom-5,easeInCubic(t));
          sx=lerp(1,1.045,t);
          sy=lerp(1,.94,t);
          rot=lerp(0,-.35,t);
          glow=.25;
        }else if(p < .42){
          var t1=(p-.12)/.30;
          bottom=lerp(baseBottom-5,baseBottom+58,easeOutBack(t1));
          sx=lerp(1.045,.985,t1);
          sy=lerp(.94,1.045,t1);
          rot=lerp(-.35,.45,t1);
          glow=.55;
        }else if(p < .62){
          var t2=(p-.42)/.20;
          bottom=lerp(baseBottom+58,baseBottom+10,easeInCubic(t2));
          sx=lerp(.985,1.01,t2);
          sy=lerp(1.045,.985,t2);
          rot=lerp(.45,-.15,t2);
          glow=.45;
        }else if(p < .72){
          var t3=(p-.62)/.10;
          bottom=lerp(baseBottom+10,baseBottom-7,easeInCubic(t3));
          sx=lerp(1.01,1.075,t3);
          sy=lerp(.985,.90,t3);
          rot=lerp(-.15,0,t3);
          glow=.78;
        }else if(p < .86){
          var t4=(p-.72)/.14;
          bottom=lerp(baseBottom-7,baseBottom+16,easeOutCubic(t4));
          sx=lerp(1.075,.985,t4);
          sy=lerp(.90,1.035,t4);
          rot=lerp(0,.25,t4);
          glow=.42;
        }else{
          var t5=(p-.86)/.14;
          bottom=lerp(baseBottom+16,baseBottom,easeOutCubic(t5));
          sx=lerp(.985,1,t5);
          sy=lerp(1.035,1,t5);
          rot=lerp(.25,0,t5);
          glow=.18*(1-t5);
        }

        return {bottom:bottom,sx:sx,sy:sy,rot:rot,glow:glow};
      }

      function frame(ts){
        if(!startTime)startTime=ts;
        var p=Math.min((ts-startTime)/duration,1);
        var s=stateAt(p);

        pop.style.setProperty('bottom',s.bottom+'px','important');
        pop.style.setProperty(
          'transform',
          'translate3d(0,0,0) rotate('+s.rot+'deg) scale('+s.sx+','+s.sy+')',
          'important'
        );
        pop.style.setProperty('transform-origin','50% 100%','important');

        var glowA=Math.max(0,Math.min(1,s.glow));
        pop.style.setProperty(
          'box-shadow',
          '0 '+(24+Math.round(10*glowA))+'px '+(70+Math.round(22*glowA))+'px rgba(16,20,17,'+(0.20+0.06*glowA).toFixed(2)+'), '+
          '0 0 0 1px rgba(255,255,255,.78) inset, '+
          '0 0 0 '+Math.round(2+6*glowA)+'px rgba(183,242,102,'+(0.08+0.12*glowA).toFixed(2)+'), '+
          '0 0 '+Math.round(20+34*glowA)+'px rgba(40,163,90,'+(0.14+0.18*glowA).toFixed(2)+')',
          'important'
        );

        if(p<1){
          requestAnimationFrame(frame);
        }else{
          pop.style.setProperty('bottom',baseBottom+'px','important');
          pop.style.setProperty('transform','translate3d(0,0,0) rotate(0deg) scale(1,1)','important');
          pop.style.setProperty('transform-origin','50% 100%','important');
          pop.style.removeProperty('box-shadow');
        }
      }

      requestAnimationFrame(frame);
    },delay);
  }catch(e){}
}

function gqAddonInlineMobileMotion(card,mode,delay){
  try{
    if(!card)return;
    var mobile=window.matchMedia&&window.matchMedia('(max-width: 760px)').matches;
    if(!mobile)return;

    delay=delay||0;
    setTimeout(function(){
      if(!card||!card.parentNode)return;

      var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(reduce)return;

      var icon=card.querySelector('.gq-addon-inline__icon');
      var duration=mode==='wiggle'?820:760;
      var startTime=null;

      card.style.setProperty('position','relative','important');
      card.style.setProperty('will-change','top,left,box-shadow','important');

      if(icon){
        icon.style.setProperty('position','relative','important');
        icon.style.setProperty('will-change','top','important');
      }

      function easeOutBack(t){
        var c1=1.70158;
        var c3=c1+1;
        return 1+c3*Math.pow(t-1,3)+c1*Math.pow(t-1,2);
      }

      function easeOutCubic(t){
        return 1-Math.pow(1-t,3);
      }

      function setGlow(strong){
        card.style.setProperty('box-shadow',
          strong
            ? '0 16px 42px rgba(16,20,17,.13), 0 0 0 1px rgba(255,255,255,.82) inset, 0 0 0 5px rgba(183,242,102,.16), 0 0 28px rgba(40,163,90,.18)'
            : '0 12px 34px rgba(16,20,17,.08), 0 0 0 1px rgba(255,255,255,.78) inset',
          'important'
        );
      }

      function frame(ts){
        if(!startTime)startTime=ts;
        var p=Math.min((ts-startTime)/duration,1);

        if(mode==='wiggle'){
          var x=0;
          if(p<.18)x=-6*easeOutCubic(p/.18);
          else if(p<.36)x=-6+(12*easeOutCubic((p-.18)/.18));
          else if(p<.54)x=6-(10*easeOutCubic((p-.36)/.18));
          else if(p<.72)x=-4+(7*easeOutCubic((p-.54)/.18));
          else x=3-(3*easeOutCubic((p-.72)/.28));

          card.style.setProperty('left',x+'px','important');
          card.style.setProperty('top',(p<.45?'-2px':'0px'),'important');

          if(icon){
            var iy=p<.5 ? -4*Math.sin(Math.PI*(p/.5)) : 0;
            icon.style.setProperty('top',iy+'px','important');
          }

          setGlow(p<.75);
        }else{
          var y=0;
          if(p<.55){
            y=14-(24*easeOutBack(p/.55)); /* 14px down -> about 10px up */
          }else{
            var q=(p-.55)/.45;
            y=-10+(10*easeOutCubic(q));
          }

          card.style.setProperty('top',y+'px','important');
          card.style.setProperty('left','0px','important');

          if(icon){
            var iy2=p<.65 ? -5*Math.sin(Math.PI*(p/.65)) : 0;
            icon.style.setProperty('top',iy2+'px','important');
          }

          setGlow(p<.75);
        }

        if(p<1){
          requestAnimationFrame(frame);
        }else{
          card.style.setProperty('top','0px','important');
          card.style.setProperty('left','0px','important');
          card.style.removeProperty('will-change');
          card.style.removeProperty('box-shadow');
          if(icon){
            icon.style.setProperty('top','0px','important');
            icon.style.removeProperty('will-change');
          }
        }
      }

      requestAnimationFrame(frame);
    },delay);
  }catch(e){}
}

function showAddonPopup(res){
  try{
    removeAddonPopup();

    var trackType=(res&&res.track)||ans.regrip||'set';
    var title=trackType==='putter'?'Complete your putting setup':'Complete your golf setup';
    var body=trackType==='putter'
      ? 'Pair your new putter grip with gloves or small accessories for your next round.'
      : 'Your grip match is ready — add gloves or accessories to round out your order.';

    var glovesUrl='https://www.grips4less.com/collections/golf-gloves';
    var accessoriesUrl='https://www.grips4less.com/collections/rog-golf-collection';
    var vw=window.innerWidth||document.documentElement.clientWidth||9999;
    var useFloatingDesktop=vw>760;

    function bindAddonClicks(container,mode){
      if(!container)return;
      container.querySelectorAll('[data-addon]').forEach(function(a){
        a.addEventListener('click',function(ev){
          ev.preventDefault();
          ev.stopPropagation();

          var url=a.getAttribute('href')||a.href||'';
          track('grip_quiz_addon_popup_clicked',{
            addon:a.getAttribute('data-addon')||'',
            url:url,
            track:trackType,
            mode:mode||''
          });

          if(url){
            try{
              var opened=window.open(url,'_blank','noopener,noreferrer');
              if(opened)opened.opener=null;
              else window.location.href=url;
            }catch(e){
              window.location.href=url;
            }
          }
        });
      });
    }

    function createInlineCard(){
      var R=root&&root.querySelector?root.querySelector('#gqResult'):null;
      if(!R)return null;

      var oldInline=R.querySelector('#gqAddonPopup');
      if(oldInline&&oldInline.parentNode)oldInline.parentNode.removeChild(oldInline);

      var inline=document.createElement('div');
      inline.id='gqAddonPopup';
      inline.className='gq-addon-inline';
      inline.setAttribute('aria-live','polite');
      inline.innerHTML=
        '<div class="gq-addon-inline__icon">✨</div>'+
        '<div class="gq-addon-inline__content">'+
          '<div class="gq-addon-inline__kicker">Recommended add-ons</div>'+
          '<div class="gq-addon-inline__title">'+esc(title)+'</div>'+
          '<div class="gq-addon-inline__body">'+esc(body)+'</div>'+
          '<div class="gq-addon-inline__links">'+
            '<a class="gq-addon-inline__btn" href="'+glovesUrl+'" target="_blank" rel="noopener noreferrer" data-addon="gloves">Shop Gloves</a>'+
            '<a class="gq-addon-inline__btn gq-addon-inline__btn--ghost" href="'+accessoriesUrl+'" target="_blank" rel="noopener noreferrer" data-addon="accessories">Accessories</a>'+
          '</div>'+
        '</div>';

      var cta=R.querySelector('.gq-cta');
      if(cta&&cta.parentNode)cta.parentNode.insertBefore(inline,cta);
      else R.appendChild(inline);

      requestAnimationFrame(function(){inline.classList.add('is-visible');});

      gqAddonInlineMobileMotion(inline,'pop',140);
      gqAddonInlineMobileMotion(inline,'wiggle',2350);

      if(inline._gqInlineWiggleTimer)clearInterval(inline._gqInlineWiggleTimer);
      inline._gqInlineWiggleTimer=setInterval(function(){
        if(!inline||!inline.parentNode){
          if(inline&&inline._gqInlineWiggleTimer)clearInterval(inline._gqInlineWiggleTimer);
          return;
        }
        gqAddonInlineMobileMotion(inline,'wiggle',0);
      },6500);

      bindAddonClicks(inline,'inline_mobile');
      return inline;
    }

    /* Always create the inline card in the results. CSS hides it on desktop and
       shows it on mobile. This avoids viewport-detection bugs where the mobile
       card never gets created. */
    createInlineCard();

    if(!useFloatingDesktop){
      track('grip_quiz_addon_popup_shown',{track:trackType,mode:'inline_mobile'});
      return;
    }

    var pop=document.createElement('div');
    pop.id='gqAddonFloatingPopup';
    pop.className='gq-addon-pop';
    pop.setAttribute('role','dialog');
    pop.setAttribute('aria-live','polite');
    pop.innerHTML=
      '<button type="button" class="gq-addon-pop__x" aria-label="Close add-on suggestion">×</button>'+
      '<div class="gq-addon-pop__kicker">Recommended add-ons</div>'+
      '<div class="gq-addon-pop__title">✨ '+esc(title)+'</div>'+
      '<div class="gq-addon-pop__body">'+esc(body)+'</div>'+
      '<div class="gq-addon-pop__links">'+
        '<a class="gq-addon-pop__btn" href="'+glovesUrl+'" target="_blank" rel="noopener noreferrer" data-addon="gloves">Shop Gloves</a>'+
        '<a class="gq-addon-pop__btn gq-addon-pop__btn--ghost" href="'+accessoriesUrl+'" target="_blank" rel="noopener noreferrer" data-addon="accessories">Shop Accessories</a>'+
      '</div>'+
      '<button type="button" class="gq-addon-pop__later">Maybe later</button>';

    document.body.appendChild(pop);

    requestAnimationFrame(function(){
      pop.classList.add('is-visible');
    });

    gqAddonDesktopBounce(pop,180);
    gqAddonDesktopBounce(pop,2800);

    if(pop._gqDesktopBounceTimer)clearInterval(pop._gqDesktopBounceTimer);
    pop._gqDesktopBounceTimer=setInterval(function(){
      if(!pop||!pop.parentNode||pop.classList.contains('is-closing')){
        if(pop&&pop._gqDesktopBounceTimer)clearInterval(pop._gqDesktopBounceTimer);
        return;
      }
      gqAddonDesktopBounce(pop,0);
    },6500);

    track('grip_quiz_addon_popup_shown',{track:trackType,mode:'floating_desktop'});

    function close(reason){
      if(!pop||pop.classList.contains('is-closing'))return;
      if(pop._gqDesktopBounceTimer)clearInterval(pop._gqDesktopBounceTimer);
      pop.classList.add('is-closing');
      pop.classList.remove('is-visible');
      track('grip_quiz_addon_popup_dismissed',{reason:reason||'closed',track:trackType,mode:'floating_desktop'});
      setTimeout(function(){if(pop&&pop.parentNode)pop.parentNode.removeChild(pop);},260);
    }

    pop.querySelector('.gq-addon-pop__x').addEventListener('click',function(){close('x');});
    pop.querySelector('.gq-addon-pop__later').addEventListener('click',function(){close('maybe_later');});

    bindAddonClicks(pop,'floating_desktop');

    if(root&&root._gqAddonTimer)clearTimeout(root._gqAddonTimer);
  }catch(e){}
}


function showResults(){
  completed=true;
  setQuizMode('loading');
  setProgress('100%');
  root.querySelector('#gqLabel').textContent='Checking stock…';
  root.querySelector('#gqCard').innerHTML='<div class="gq-loading gq-loading--results"><span class="gq-spinner"></span><span>Verifying your best live matches…</span></div>';
  var R=root.querySelector('#gqResult'); R.classList.remove('active'); R.innerHTML='';

  function fallbackResult(){
    try{return buildResultPublishedFallback();}catch(e){return {track:ans.regrip||'set'};}
  }
  var rendered=false,renderedProfile=null,renderedEmpty=false;
  function resultHasCards(res){return !!(res&&(res.club||res.putter));}
  /* The fallback no longer produces cards, so the 10s timeout can paint an
     empty "no in-stock matches" screen while the live pass is still running.
     That screen is allowed to be REPLACED once verification finishes — locking
     it in would tell the golfer nothing is available when stock was simply
     slow to confirm. A screen that already has verified cards is never
     re-rendered, so the ranked list still cannot shuffle under the user. */
  function safeRender(res){
    if(rendered&&!(renderedEmpty&&resultHasCards(res)))return;
    rendered=true;
    renderedEmpty=!resultHasCards(res);
    if(root&&root._gqResultsTimer)clearTimeout(root._gqResultsTimer);
    renderFinalResults(res||fallbackResult());
  }

  /* v22 renders after one verified primary purchasing destination per
     recommendation, then fills in the rest of the live colors and pack formats
     in the background. The ranked product cards do not change during hydration. */
  var hydrationStarted=false;
  function startFullOptionHydration(){
    if(hydrationStarted)return;
    hydrationStarted=true;
    setTimeout(function(){
      /* Background enrichment must never leave a permanent loading message.
         If Shopify is slow or the second-pass result no longer contains a
         particular card, retain the working primary option and clear the
         status after a bounded wait. A late successful response can still
         replace the controls afterward. */
      var settled=false;
      var optionTimer=setTimeout(function(){
        if(settled)return;
        settleResultPurchaseOptionLoaders('timeout');
      },12000);
      buildResultLive().then(function(fullRes){
        settled=true;
        clearTimeout(optionTimer);
        /* If the screen currently shows the empty "no in-stock matches" state
           because live verification had not finished in time, promote the now
           fully verified result into a real render instead of trying to hydrate
           purchase controls that were never drawn. */
        if(renderedEmpty&&resultHasCards(fullRes))safeRender(fullRes);
        else hydrateResultPurchaseOptions(fullRes);
        try{persistGripQuizResults(fullRes,renderedProfile);}catch(e){}
      }).catch(function(){
        settled=true;
        clearTimeout(optionTimer);
        settleResultPurchaseOptionLoaders('failed');
      });
    },40);
  }

  /* The fast path still fails closed on public-page and stock verification.
     The shorter timeout only controls the loading screen; it does not re-enable
     unverified raw-spec links. */
  root._gqResultsTimer=setTimeout(function(){safeRender(fallbackResult());startFullOptionHydration();},10000);

  buildResultLiveFast()
    .then(function(res){safeRender(res);startFullOptionHydration();})
    .catch(function(){safeRender(fallbackResult());startFullOptionHydration();});

  function renderFinalResults(res){
    setQuizMode('results');
    setProgress('100%');
    root.querySelector('#gqLabel').textContent='Your results';
    root.querySelector('#gqCard').innerHTML='';
    R.classList.add('active'); R.innerHTML='';

    var html='';
    if(res.club&&res.putter){
      html+='<div class="gq-tabs" role="tablist">'+
          '<button type="button" class="gq-tab is-active" data-tab="club">'+icon('club')+'Club grips</button>'+
          '<button type="button" class="gq-tab" data-tab="putter">'+icon('putter')+'Putter</button></div>'+
        '<div class="gq-tabpanel" data-panel="club">'+clubPanel(res.club)+'</div>'+
        '<div class="gq-tabpanel" data-panel="putter" hidden>'+putterPanel(res.putter)+'</div>';
    } else if(res.club){ html+='<div class="gq-tabpanel">'+clubPanel(res.club)+'</div>'; }
    else if(res.putter){ html+='<div class="gq-tabpanel">'+putterPanel(res.putter)+'</div>'; }
    else { html+='<div class="gq-tabpanel"><div class="gq-why"><span class="gq-why__k">No in-stock matches found</span><p>We could not find an in-stock match for your answers right now. Browse all grips below or try slightly different answers.</p></div></div>'; }

    var shop=res.track==='putter'?'https://www.grips4less.com/collections/putter-grips':'https://www.grips4less.com/collections/golf-grips';
    html+='<div class="gq-cta"><a class="gq-shop" href="'+shop+'" data-slot="shop_all" target="_blank" rel="noopener noreferrer">Browse all grips</a>'+ 
          '<button type="button" class="gq-restart" id="gqRestart">'+icon('rotate')+' Start over</button></div>';
    R.innerHTML=html;

    setTimeout(function(){showAddonPopup(res);},650);

    /* Direct binding for Show More buttons so they work even if nested elements are clicked. */
    R.querySelectorAll('.gq-more__btn').forEach(function(btn){
      btn.addEventListener('click',function(ev){
        ev.preventDefault(); ev.stopPropagation();
        var id=btn.getAttribute('data-toggle');
        var box=R.querySelector('[data-alts="'+id+'"]');
        if(!box)return;
        var open=box.hidden || !box.classList.contains('gq-collapse-open');
        gqSetCollapse(box,open);
        btn.classList.toggle('open',open);
        btn.setAttribute('aria-expanded',open?'true':'false');
        var txt=btn.querySelector('[data-more-text]');
        if(txt)txt.textContent=open?'Hide strong matches':(btn.getAttribute('data-closed-text')||txt.textContent);
      });
    });

    function toggleAltDetails(card){
      if(!card)return;
      var details=card.querySelector('.gq-alt__details');
      if(!details)return;
      var open=details.hidden || !card.classList.contains('is-open');
      if(open){
        card.classList.add('is-open');
        gqSetCollapse(details,true);
      }else{
        gqSetCollapse(details,false,function(){card.classList.remove('is-open');});
      }
      card.querySelectorAll('[aria-expanded]').forEach(function(x){x.setAttribute('aria-expanded',open?'true':'false');});
      if(open)track('grip_quiz_alt_details_opened',{model:(card.querySelector('.gq-alt__name')||{}).textContent||'',track:res.track});
    }
    R.querySelectorAll('[data-alt-toggle]').forEach(function(toggle){
      toggle.addEventListener('click',function(ev){
        ev.preventDefault(); ev.stopPropagation();
        toggleAltDetails(toggle.closest('.gq-alt'));
      });
      toggle.addEventListener('keydown',function(ev){
        if(ev.key==='Enter'||ev.key===' '){ev.preventDefault();toggleAltDetails(toggle.closest('.gq-alt'));}
      });
    });
    R.querySelectorAll('.gq-tab').forEach(function(t){t.addEventListener('click',function(){
      R.querySelectorAll('.gq-tab').forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active');
      var name=t.getAttribute('data-tab');
      R.querySelectorAll('.gq-tabpanel').forEach(function(p){p.hidden=(p.getAttribute('data-panel')!==name);});
      track('grip_quiz_tab_switched',{tab:name});
    });});

    R.addEventListener('click',function(ev){
      var tg=ev.target.closest?ev.target.closest('[data-toggle]'):null;
      if(tg){var id=tg.getAttribute('data-toggle'),box=R.querySelector('[data-alts="'+id+'"]');if(box){var open=box.hidden||!box.classList.contains('gq-collapse-open');gqSetCollapse(box,open);tg.classList.toggle('open',open);tg.setAttribute('aria-expanded',open?'true':'false');var mt=tg.querySelector('[data-more-text]');if(mt)mt.textContent=open?'Hide strong matches':(tg.getAttribute('data-closed-text')||mt.textContent);}return;}
      var colorBtn=ev.target.closest?ev.target.closest('.gq-color'):null;
      if(colorBtn){
        ev.preventDefault();
        var colorCard=colorBtn.getAttribute('data-color-card');
        var formats=[];try{formats=JSON.parse(colorBtn.getAttribute('data-color-formats')||'[]');}catch(e){formats=[];}
        R.querySelectorAll('.gq-color[data-color-card="'+colorCard+'"]').forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-pressed','false');});
        colorBtn.classList.add('is-active');colorBtn.setAttribute('aria-pressed','true');
        var pillWrap=R.querySelector('.gq-pills[data-card="'+colorCard+'"]');
        if(pillWrap&&formats.length)pillWrap.innerHTML=pillButtonsHTML(formats,colorCard);
        var primary=(formats.filter(function(f){return f.primary;})[0]||formats[0]);
        if(primary){
          var ctaColor=R.querySelector('.gq-buy[data-cta="'+colorCard+'"]');
          if(ctaColor){
            ctaColor.setAttribute('href',absoluteProductUrl(primary.url));ctaColor.setAttribute('data-format',primary.key||'');
            var blc=ctaColor.querySelector('[data-buylabel]');if(blc)blc.textContent=primary.label||'this grip';
            var prc=ctaColor.querySelector('[data-price]');if(prc)prc.textContent=primary.price!=null?fmtPrice(+primary.price):'';
            var saleColor=primary.compareAt!=null&&primary.price!=null&&(+primary.compareAt>+primary.price);
            ctaColor.classList.toggle('is-sale',!!saleColor);var wc=ctaColor.querySelector('[data-was]');if(wc)wc.textContent=saleColor?fmtPrice(+primary.compareAt):'';
          }
        }
        track('grip_quiz_color_selected',{card:colorCard,color:colorBtn.getAttribute('data-color-label')||'',track:res.track});
        return;
      }
      var pill=ev.target.closest?ev.target.closest('.gq-pill'):null;
      if(!pill)return; ev.preventDefault();
      var card=pill.getAttribute('data-card');
      R.querySelectorAll('.gq-pill[data-card="'+card+'"]').forEach(function(x){x.classList.remove('is-active');});
      pill.classList.add('is-active');
      var url=pill.getAttribute('data-url'),price=pill.getAttribute('data-price'),was=pill.getAttribute('data-was'),label=pill.getAttribute('data-label'),fmt=pill.getAttribute('data-format');
      var cta=R.querySelector('.gq-buy[data-cta="'+card+'"]');
      if(cta){if(url)cta.setAttribute('href',absoluteProductUrl(url));cta.setAttribute('target','_blank');cta.setAttribute('rel','noopener noreferrer');cta.setAttribute('data-format',fmt);var bl=cta.querySelector('[data-buylabel]');if(bl)bl.textContent=label;var pr=cta.querySelector('[data-price]');if(pr)pr.textContent=price?fmtPrice(+price):'';var onSale=was&&price&&(+was>+price);cta.classList.toggle('is-sale',!!onSale);var wEl=cta.querySelector('[data-was]');if(wEl)wEl.textContent=onSale?fmtPrice(+was):'';}
      track('grip_quiz_format_selected',{card:card,format:fmt,price:price?+price:null,track:res.track});
    });

    /* Normalize and track current result links. The same helper is called
       again after background pack/color hydration so newly inserted links are
       bound without duplicate event listeners. */
    bindResultProductLinks(R,res.track);
    var restart=document.getElementById('gqRestart'); if(restart)restart.addEventListener('click',resetQuiz);

    var profile={track:res.track};
    var customerProfiles=res.customerProfiles||getCustomerProfiles(ans);
    profile.primary_player_profile=customerProfiles.primaryProfile;
    profile.secondary_player_profile=customerProfiles.secondaryProfile;
    profile.primary_profile_score=customerProfiles.primaryScore;
    profile.secondary_profile_score=customerProfiles.secondaryScore;
    try{profile.profile_scores=JSON.stringify(customerProfiles.allProfileScores||{});}catch(e){}
    Object.keys(ans).forEach(function(k){profile['answer_'+k]=labelOf(k,ans[k]);});
    if(res.club){profile.club_model=res.club.top.s.brand+' '+res.club.top.s.model;profile.club_size=res.club.size.size;profile.club_match_pct=res.club.top.pct||null;}
    if(res.putter){profile.putter_model=res.putter.top.s.brand+' '+res.putter.top.s.model;profile.putter_match_pct=res.putter.top.pct||null;}
    renderedProfile=profile;

    /* Persist recommendation context so cart, checkout, and purchase tracking
       remain tied to the initially rendered recommendation set. Background
       purchase-option hydration updates URLs without changing the ranked cards. */
    persistGripQuizResults(res,profile);

    track('grip_quiz_completed',profile);
    track('grip_quiz_recommendation_shown',{track:res.track,primary_player_profile:profile.primary_player_profile||'',secondary_player_profile:profile.secondary_player_profile||'',club_model:res.club?profile.club_model:'',club_size:res.club?res.club.size.size:'',putter_model:res.putter?profile.putter_model:''});
    if(res.club)track('grip_quiz_format_recommended',{model:profile.club_model,primary_format:(res.club.formats.filter(function(f){return f.primary;})[0]||{}).key||'',formats:res.club.formats.map(function(f){return f.key;})});
  }
}

/* ================================================================== *  RESET / INIT / ABANDON  */
function resetQuiz(){track('grip_quiz_restart',{});ans={};order=['regrip'];idx=0;completed=false;GQ_PREFETCH_SIGNATURE='';if(GQ_PREFETCH_TIMER)clearTimeout(GQ_PREFETCH_TIMER);
  root.querySelector('#gqResult').classList.remove('active');root.querySelector('#gqResult').innerHTML='';renderStep('back');}

var specWaits=0;
function ensureGripQuizColorStyles(){
  var previousColorStyles=document.getElementById('gqColorOptionStyles');
  if(previousColorStyles&&previousColorStyles.parentNode)previousColorStyles.parentNode.removeChild(previousColorStyles);
  var st=document.createElement('style');st.id='gqColorOptionStyles';
  st.textContent='.gq-colors{margin:14px 0 12px}.gq-colors__head{font-size:12px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;margin-bottom:8px}.gq-colors__list{display:flex;gap:8px;overflow-x:auto;padding:2px 1px 7px;scrollbar-width:thin}.gq-color{display:inline-flex;align-items:center;gap:7px;flex:0 0 auto;border:1px solid rgba(30,45,35,.16);background:#fff;border-radius:999px;padding:7px 10px;cursor:pointer;font:inherit;color:inherit}.gq-color:hover,.gq-color.is-active{border-color:#1f7a45;box-shadow:0 0 0 2px rgba(31,122,69,.10)}.gq-color.is-active{background:#f4fbf6}.gq-color__swatch{width:18px;height:18px;border-radius:50%;border:1px solid rgba(0,0,0,.18);box-shadow:inset 0 0 0 1px rgba(255,255,255,.35)}.gq-color__label{font-size:12px;font-weight:700;white-space:nowrap}#gripQuiz .gq-more{grid-column:1/-1;min-width:0;width:100%;max-width:100%;box-sizing:border-box}#gripQuiz .gq-more__btn{width:100%;max-width:100%;min-width:0;box-sizing:border-box}#gripQuiz .gq-more__btn [data-more-text]{min-width:0;overflow:hidden;text-overflow:ellipsis}#gripQuiz .gq-alts{min-width:0;width:100%;max-width:100%;box-sizing:border-box}.gq-buybox__top{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:2px}.gq-buybox__top .gq-buybox__head{margin-bottom:0}.gq-exact-desktop{display:inline-flex;align-items:center;gap:6px;flex:0 0 auto;padding:7px 10px;border:1px solid rgba(31,122,69,.22);border-radius:999px;background:#f4fbf6;color:#176b3a;font-size:11px;font-weight:800;letter-spacing:.02em;white-space:nowrap}.gq-exact-desktop svg{width:15px;height:15px}.gq-exact-desktop.is-zero{border-color:rgba(174,107,24,.25);background:#fff8eb;color:#9a5b10}#gripQuiz .gq-exact-mobile{display:none!important;visibility:hidden!important;pointer-events:none!important}#gripQuiz .gq-mobile-match-notice{box-sizing:border-box;width:100%;align-items:flex-start;gap:10px;padding:13px 16px;border-top:1px solid rgba(31,122,69,.14);border-bottom:1px solid rgba(31,122,69,.14);background:#f8fcf9;color:#405048;font-size:13px;line-height:1.45}#gripQuiz .gq-mobile-match-notice svg{width:18px;height:18px;flex:0 0 auto;color:#1f7a45}@media(min-width:641px){#gripQuiz .gq-exact-mobile{display:none!important;visibility:hidden!important;position:absolute!important;left:-99999px!important;top:auto!important;width:0!important;height:0!important;min-width:0!important;min-height:0!important;max-width:0!important;max-height:0!important;margin:0!important;padding:0!important;border:0!important;overflow:hidden!important;opacity:0!important;grid-column:auto!important;grid-row:auto!important}#gripQuiz .gq-size-explanation{display:flex!important;visibility:visible!important;position:static!important;inset:auto!important;clear:both!important;float:none!important;transform:none!important;grid-column:2!important;grid-row:auto!important;align-self:stretch!important;width:100%!important;max-width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;margin:0!important;box-sizing:border-box!important;overflow:visible!important;z-index:1!important;isolation:isolate!important}#gripQuiz .gq-size-explanation::before,#gripQuiz .gq-size-explanation::after{content:none!important;display:none!important}#gripQuiz .gq-size-explanation>span{display:block!important;min-width:0!important;max-width:100%!important;overflow-wrap:anywhere!important;white-space:normal!important;position:static!important;transform:none!important}}@media(min-width:641px){#gripQuiz .gq-buybox{height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important;position:relative!important;display:flex!important;flex-direction:column!important}#gripQuiz .gq-buybox__top{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:start!important;gap:10px 14px!important;width:100%!important;min-width:0!important;box-sizing:border-box!important}#gripQuiz .gq-buybox__top .gq-buybox__head{min-width:0!important;overflow-wrap:anywhere!important}#gripQuiz .gq-exact-desktop{position:static!important;float:none!important;transform:none!important;align-self:start!important;max-width:100%!important;box-sizing:border-box!important}#gripQuiz .gq-buybox + .gq-sizenote{position:relative!important;clear:both!important;float:none!important;z-index:2!important;width:100%!important;max-width:100%!important;min-width:0!important;height:auto!important;box-sizing:border-box!important;margin-top:0!important;transform:none!important}#gripQuiz .gq-buybox + .gq-sizenote span{min-width:0!important;overflow-wrap:anywhere!important}}.gq-exact-desktop{display:none!important}@media(max-width:640px){.gq-color{padding:6px 9px}.gq-colors__list{margin-right:-8px}.gq-buybox__top{display:block}.gq-exact-desktop{display:none!important}.gq-exact-mobile{display:flex!important;visibility:visible!important;position:static!important;left:auto!important;width:100%!important;height:auto!important;max-width:100%!important;max-height:none!important;margin:0!important;padding:13px 16px!important;border-top:1px solid rgba(31,122,69,.14)!important;border-bottom:1px solid rgba(31,122,69,.14)!important;overflow:visible!important;opacity:1!important;grid-column:1/-1!important}#gripQuiz .gq-more{position:relative!important;left:auto!important;right:auto!important;transform:none!important;margin-left:0!important;margin-right:0!important;padding-left:0!important;padding-right:0!important;overflow:visible!important}#gripQuiz .gq-more__btn{display:flex!important;justify-content:center!important;align-items:center!important;gap:8px!important;width:100%!important;max-width:100%!important;min-width:0!important;margin:0!important;padding-left:14px!important;padding-right:14px!important;box-sizing:border-box!important}#gripQuiz .gq-alts{width:100%!important;max-width:100%!important;min-width:0!important;margin-left:0!important;margin-right:0!important;box-sizing:border-box!important}#gripQuiz .gq-alt{max-width:100%;min-width:0;box-sizing:border-box}}';
  st.textContent+='@media(min-width:641px){#gripQuiz .gq-mobile-match-notice.gq-exact-mobile{display:none!important;visibility:hidden!important;position:absolute!important;left:-99999px!important;top:auto!important;width:0!important;height:0!important;min-width:0!important;min-height:0!important;max-width:0!important;max-height:0!important;margin:0!important;padding:0!important;border:0!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;grid-column:auto!important;grid-row:auto!important}#gripQuiz .gq-buybox + .gq-sizenote.gq-size-explanation{display:flex!important;visibility:visible!important;position:static!important;inset:auto!important;clear:both!important;float:none!important;transform:none!important;grid-column:2!important;grid-row:auto!important;align-self:stretch!important;width:100%!important;max-width:100%!important;min-width:0!important;height:auto!important;min-height:0!important;margin:0!important;padding:16px 20px!important;box-sizing:border-box!important;overflow:visible!important;opacity:1!important;z-index:3!important;isolation:isolate!important}#gripQuiz .gq-buybox + .gq-sizenote.gq-size-explanation>span{display:block!important;position:static!important;transform:none!important;min-width:0!important;max-width:100%!important;width:auto!important;white-space:normal!important;overflow-wrap:anywhere!important;line-height:1.45!important}#gripQuiz .gq-buybox + .gq-sizenote.gq-size-explanation::before,#gripQuiz .gq-buybox + .gq-sizenote.gq-size-explanation::after{content:none!important;display:none!important}}@media(max-width:640px){#gripQuiz .gq-mobile-match-notice.gq-exact-mobile{display:flex!important;visibility:visible!important;position:static!important;left:auto!important;top:auto!important;width:100%!important;height:auto!important;min-width:0!important;max-width:100%!important;max-height:none!important;margin:0!important;padding:13px 16px!important;border-top:1px solid rgba(31,122,69,.14)!important;border-bottom:1px solid rgba(31,122,69,.14)!important;overflow:visible!important;opacity:1!important;pointer-events:auto!important;grid-column:1/-1!important;grid-row:auto!important}}';
  st.textContent+='#gripQuiz .gq-purchase-options{min-width:0;width:100%}#gripQuiz .gq-options-loading{display:flex;align-items:center;gap:7px;margin-top:9px;color:#68766f;font-size:11px;font-weight:700;line-height:1.35}#gripQuiz .gq-options-loading__dot{width:7px;height:7px;border-radius:50%;background:#1f7a45;box-shadow:0 0 0 0 rgba(31,122,69,.35);animation:gqOptionPulse 1.35s ease-out infinite}@keyframes gqOptionPulse{0%{box-shadow:0 0 0 0 rgba(31,122,69,.35)}70%{box-shadow:0 0 0 7px rgba(31,122,69,0)}100%{box-shadow:0 0 0 0 rgba(31,122,69,0)}}';
  /* v24 mobile overflow guard. The color scroller previously used a
     negative right margin and decorative background elements could paint past
     the quiz root. On narrow screens that increased document.scrollWidth and
     created a blank strip to the right of the page. Keep horizontal scrolling
     inside the color row, but clip all quiz-level visual overflow. */
  st.textContent+='@media(max-width:640px){html.gq-mobile-page-lock,body.gq-mobile-page-lock{width:100%!important;max-width:100%!important;overflow-x:hidden!important;overscroll-behavior-x:none!important}body.gq-mobile-page-lock{position:relative!important;touch-action:pan-y pinch-zoom}html.gq-mobile-page-lock #gripQuiz{position:relative!important;display:block!important;width:100%!important;max-width:100%!important;min-width:0!important;margin-left:0!important;margin-right:0!important;box-sizing:border-box!important;overflow-x:hidden!important;overflow-x:clip!important;contain:paint}html.gq-mobile-page-lock #gripQuiz *,html.gq-mobile-page-lock #gripQuiz *::before,html.gq-mobile-page-lock #gripQuiz *::after{box-sizing:border-box}#gripQuiz .gq-bg{left:0!important;right:0!important;width:100%!important;max-width:100%!important;box-sizing:border-box!important;overflow:hidden!important;overflow:clip!important}#gripQuiz .gq-blob,#gripQuiz .gq-ring{max-width:100%!important}#gripQuiz .gq-hero,#gripQuiz .gq-outer,#gripQuiz #gqCard,#gripQuiz #gqResult,#gripQuiz .gq-result,#gripQuiz .gq-tabs,#gripQuiz .gq-tabpanel,#gripQuiz .gq-panelhead,#gripQuiz .gq-match,#gripQuiz .gq-buybox,#gripQuiz .gq-sizenote,#gripQuiz .gq-specs,#gripQuiz .gq-more,#gripQuiz .gq-alts,#gripQuiz .gq-cta{width:100%!important;max-width:100%!important;min-width:0!important;box-sizing:border-box!important}#gripQuiz .gq-colors,#gripQuiz .gq-purchase-options{max-width:100%!important;min-width:0!important;box-sizing:border-box!important}#gripQuiz .gq-colors__list{width:100%!important;max-width:100%!important;min-width:0!important;margin-left:0!important;margin-right:0!important;padding-left:1px!important;padding-right:1px!important;box-sizing:border-box!important;overflow-x:auto!important;overscroll-behavior-x:contain;touch-action:pan-x pan-y}#gripQuiz .gq-panelhead__h,#gripQuiz .gq-panelhead__sub,#gripQuiz .gq-buybox__head,#gripQuiz .gq-alt__name{min-width:0!important;max-width:100%!important;overflow-wrap:anywhere!important}}';
  document.head.appendChild(st);
}
function applyMobilePageOverflowLock(){
  var active=false;
  try{active=window.matchMedia&&window.matchMedia('(max-width:640px)').matches;}catch(e){active=(window.innerWidth||9999)<=640;}
  if(document.documentElement)document.documentElement.classList.toggle('gq-mobile-page-lock',!!active);
  if(document.body)document.body.classList.toggle('gq-mobile-page-lock',!!active);
  if(active){
    /* Some Shopify theme wrappers calculate slightly wider than the visual
       viewport. Pin the document back to the layout viewport so a child or
       pseudo-element cannot create a blank horizontal scroll area. */
    try{
      document.documentElement.style.setProperty('overflow-x','hidden','important');
      document.body.style.setProperty('overflow-x','hidden','important');
    }catch(e){}
  }else{
    try{
      document.documentElement.style.removeProperty('overflow-x');
      document.body.style.removeProperty('overflow-x');
    }catch(e){}
  }
}

function mount(){
  root=document.getElementById('gripQuiz'); if(!root)return;
  applyMobilePageOverflowLock();
  ensureGripQuizColorStyles();
  if(!window.GRIP_SPECS||!window.GRIP_SPECS.length){
    if(specWaits++<25){root.innerHTML='<div class="gq-loading"><span class="gq-spinner"></span>Loading grip data…</div>';return setTimeout(mount,200);}
    root.innerHTML='<div class="gq-loading" style="display:block;color:#b00;line-height:1.6"><strong>Grip data didn’t load.</strong><br>Upload <code>grip-specs.js</code> to your theme Assets and load it before grip-quiz.js.</div>';return;}
  /* Correct this known model after whichever compatible grip-specs export is
     loaded, so an older sheet cannot restore the wrong taper/alignment data. */
  applyTourTraxionSpecCorrection();
  /* Start the public product-handle (sitemap) index while the customer takes
     the quiz, so result-time publication verification is a local lookup and
     never needs a per-handle HTML 404 fetch. */
  try{loadPublishedHandleIndex();}catch(e){}
  root.innerHTML=
  '<div class="gq-bg">'+
  '<span class="gq-blob gq-blob--1"></span>'+
  '<span class="gq-blob gq-blob--2"></span>'+
  '<span class="gq-blob gq-blob--3"></span>'+
  '<span class="gq-ring gq-ring--1"></span>'+
  '<span class="gq-ring gq-ring--2"></span>'+
'</div>'+
'<div class="gq-hero"><span class="gq-hero__eyebrow">Grips4Less · Grip Finder</span>'+
  '<h1 class="gq-hero__h1">Find Your <em>Perfect Grip</em></h1>'+
  '<p class="gq-hero__sub">Answer a few quick questions and we\'ll match you to the right grip, the right size, and the best products for your clubs.</p></div>'+
'<div class="gq-outer"><div class="gq-progress"><div class="gq-progress__track"><div class="gq-progress__fill" id="gqFill" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"></div></div>'+
  '<span class="gq-progress__label" id="gqLabel">Get started</span></div>'+
  '<div id="gqCard"></div><div class="gq-result" id="gqResult"></div></div>';
  started=true;
  try{console.log('[grip-quiz] build 2026-07-14-putter-size-hard-filter-v28 loaded');}catch(e){}
  track('grip_quiz_started',{});
  renderStep();
}
var abandonSent=false;
function maybeAbandon(){if(abandonSent||!started||completed)return;abandonSent=true;
  track('grip_quiz_abandoned',{last_step:idx,last_question:order[idx]||'',answered_count:Object.keys(ans).length,track:ans.regrip||''});}
window.addEventListener('pagehide',maybeAbandon);
document.addEventListener('visibilitychange',function(){if(document.visibilityState==='hidden')maybeAbandon();});
window.addEventListener('resize',applyMobilePageOverflowLock,{passive:true});
window.addEventListener('orientationchange',function(){setTimeout(applyMobilePageOverflowLock,80);},{passive:true});

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount); else mount();
window.GripQuiz = {
  buildResult: function(a) {
    ans = normalizeQuizAnswers(a || ans);
    return buildResult();
  },

  buildResultLive: function(a) {
    ans = normalizeQuizAnswers(a || ans);
    return buildResultLive();
  },

  buildResultLiveFast: function(a) {
    ans = normalizeQuizAnswers(a || ans);
    return buildResultLiveFast();
  },

  recommendSize: recommendSize,
  putterSizeRecommendation: putterSizeRecommendation,
  putterSizeEvidenceClasses: putterSizeEvidenceClasses,
  resolvedPutterSizeClass: resolvedPutterSizeClass,
  sizeEligiblePutter: sizeEligiblePutter,
  scoreClub: scoreClub,
  scorePutter: scorePutter,
  displayGripName: displayGripName,
  confidenceLabel: confidenceLabel,
  displayFitPct: displayFitPct,
  fitPct: fitPct,
  applyDisplayFitPct: applyDisplayFitPct,
  cmpVisibleRanked: cmpVisibleRanked,
  cmpValueRanked: cmpValueRanked,
  prepareLiveValueRanking: prepareLiveValueRanking,
  liveUnitPrice: liveUnitPrice,
  maxProfileMapScore: maxProfileMapScore,
  pctOf: pctOf,
  isNonGripAccessory: isNonGripAccessory,
  sortVisibleRanked: sortVisibleRanked,
  chartSize: chartSize,
  getCustomerProfiles: getCustomerProfiles,
  inferGripProfiles: inferGripProfiles,
  getMappedGripProfiles: getMappedGripProfiles,
  mappedProfileFromKey: mappedProfileFromKey,
  preferredBrandBoost: preferredBrandBoost,
  styleColorBoost: styleColorBoost,
  profileBucketTieBreakBoost: profileBucketTieBreakBoost,
  profileMapScoreProduct: profileMapScoreProduct,
  gripStyleInfo: gripStyleInfo,
  lineKey: lineKey,
  modelSizeIntent: modelSizeIntent,
  sizeTieBreakScore: sizeTieBreakScore,
  descriptionSignals: descriptionSignals,
  descriptionBoost: descriptionBoost,
  maxDescriptionBoost: maxDescriptionBoost,
  putterSpecialtyType: putterSpecialtyType,
  isUnsupportedSpecialtyPutter: isUnsupportedSpecialtyPutter,
  wrapTractionPreferenceScore: wrapTractionPreferenceScore,
  customerFacingFitPct: customerFacingFitPct,
  resolveLiveVariantId: resolveLiveVariantId,
  variantUrlForColor: variantUrlForColor,
  normalizeQuizAnswers: normalizeQuizAnswers,
  rankClub: rankClub,
  rankPutter: rankPutter,
  topPersonalizedWhy: topPersonalizedWhy,
  alternativePersonalizedWhy: alternativePersonalizedWhy,
  clubMustHaveMatch: clubMustHaveMatch,
  productHasAlignmentAid: productHasAlignmentAid,
  productHasAlignmentRidge: productHasAlignmentRidge,
  alignmentAidType: alignmentAidType,
  productHasCord: productHasCord,
  productIsWrap: productIsWrap,
  isRecommendationEligible: isRecommendationEligible,
  isReducedTaperGrip: isReducedTaperGrip,
  isStyleForwardGrip: isStyleForwardGrip,
  styleMerchandisingScore: styleMerchandisingScore,
  putterSizeAwareStyleScore: putterSizeAwareStyleScore,
  putterStyleTargetForSpec: putterStyleTargetForSpec,
  meaningfulColorLabelsForSpec: meaningfulColorLabelsForSpec,
  variantsForSize: variantsForSize,
  buildFormats: buildFormats,
  buildColorOptionsFromVariants: buildColorOptionsFromVariants,
  liveUnitPrice: liveUnitPrice,
  loadPublishedHandleIndex: loadPublishedHandleIndex,
  getPublishedHandleStatus: getPublishedHandleStatus,
  publishedHandleStatusSync: publishedHandleStatusSync,
  bulkPrime: gqBulkPrime,
  bulkCatalogInfo: function(){
    var pub=0;for(var h in GQ_BULK_PUBLISHED){if(GQ_BULK_PUBLISHED[h])pub++;}
    var av=0;for(var k in GQ_VARIANT_AVAIL){if(Object.prototype.hasOwnProperty.call(GQ_VARIANT_AVAIL,k))av++;}
    return {done:GQ_BULK_STATE.done,loadedAt:GQ_BULK_STATE.loadedAt,publishedHandles:pub,variantsInMap:av,collections:gqBulkCollectionHandles(),disabled:gqBulkDisabled()};
  },
  variantAvail: function(id){return GQ_VARIANT_AVAIL[String(id)]||null;},
  /* Diagnostic: for a given answer set, report how much of the fast finalist
     pool the bulk availability map + publication set actually cover. If
     coverage is low, the results screen still falls to the per-handle
     waterfall and the bulk feed cannot help — which usually means the
     recommended grips are not in the configured GRIP_QUIZ_BULK_COLLECTIONS. */
  __poolCoverage: function(a){
    a=normalizeQuizAnswers(a||ans||{});
    var gids=[];try{gids=gqCollectFastPoolGids(a);}catch(e){gids=[];}
    var ids=[],seen={},handles={};
    gids.forEach(function(g){var id=String(variantIdFromGid(g));if(id&&!seen[id]){seen[id]=1;ids.push(id);}});
    var inMap=0;ids.forEach(function(id){if(Object.prototype.hasOwnProperty.call(GQ_VARIANT_AVAIL,id))inMap++;});
    /* handle-level publication coverage over the same pool */
    var poolHandles={},pubHit=0,pubTotal=0;
    function addSpec(spec){(spec&&spec.variants||[]).forEach(function(v){var h=getProductHandleFromUrl(v&&v.url);if(h)poolHandles[h]=true;});}
    try{
      if(a.regrip==='set'||a.regrip==='both'){var sz=recommendSize(a);rankClub(a,sz.size).slice(0,28).forEach(function(it){addSpec(it.s);});}
      if(a.regrip==='putter'||a.regrip==='both'){rankPutter(a).slice(0,28).forEach(function(it){addSpec(it.s);});}
    }catch(e){}
    for(var h in poolHandles){if(poolHandles[h]){pubTotal++;if(GQ_BULK_PUBLISHED[h]||publishedHandleStatusSync(h)===true)pubHit++;}}
    return {
      track:a.regrip,
      poolVariantIds:ids.length,
      variantsInBulkMap:inMap,
      variantCoveragePct:ids.length?Math.round(inMap/ids.length*100):0,
      poolHandles:pubTotal,
      handlesPublishedKnown:pubHit,
      handleCoveragePct:pubTotal?Math.round(pubHit/pubTotal*100):0,
      fastPoolWarm:(function(){try{return gqFastPoolWarm(a);}catch(e){return null;}})(),
      bulk:(typeof this.bulkCatalogInfo==='function')?this.bulkCatalogInfo():null
    };
  },
  /* Benchmark-only: wipe warmed maps/caches so the next buildResultLiveFast()
     call measures a controlled start. Options let the benchmark hold the
     mount-time warm-up (publication index / bulk availability map) constant
     across repeats while still forcing the per-handle stock cache cold, so a
     timed run reflects the real results-screen cost rather than re-loading the
     sitemap every iteration. Has no effect on normal shopper flow. */
  __speedReset: function(opts){
    opts=opts||{};
    var keepPub=opts.keepPublication===true;      /* keep sitemap + bulk publication */
    var keepAvail=opts.keepVariantAvail===true;   /* keep bulk availability + price map */
    if(!keepAvail){
      try{for(var k in GQ_VARIANT_AVAIL)delete GQ_VARIANT_AVAIL[k];}catch(e){}
      GQ_VARIANT_AVAIL_SEEDED=false;
      try{sessionStorage.removeItem(GQ_VARIANT_AVAIL_CACHE_KEY);}catch(e){}
    }
    if(!keepPub){
      try{for(var b in GQ_BULK_PUBLISHED)delete GQ_BULK_PUBLISHED[b];}catch(e){}
      GQ_BULK_STATE.promise=null;GQ_BULK_STATE.done=false;GQ_BULK_STATE.loadedAt=0;
      GQ_PUBLICATION_INDEX.promise=null;GQ_PUBLICATION_INDEX.loaded=false;GQ_PUBLICATION_INDEX.failed=false;GQ_PUBLICATION_INDEX.handles=null;GQ_PUBLICATION_INDEX.source='';GQ_PUBLICATION_INDEX.loadedAt=0;
      try{localStorage.removeItem(GQ_PUBLICATION_CACHE_KEY);sessionStorage.removeItem(GQ_PUBLICATION_CACHE_KEY);}catch(e){}
    }
    /* Always clear the per-handle public-page / product.js cache so a timed run
       re-incurs whatever per-handle work its path requires. */
    try{for(var s in GQ_STOCK_CACHE)delete GQ_STOCK_CACHE[s];}catch(e){}
    return true;
  },
  publicationIndexInfo: function(){return {loaded:GQ_PUBLICATION_INDEX.loaded,failed:GQ_PUBLICATION_INDEX.failed,source:GQ_PUBLICATION_INDEX.source,count:gqPublicationMapSize(GQ_PUBLICATION_INDEX.handles)};},
  publicProductPageStatus: function(handle){return verifyPublicProductPage(String(handle||'')).then(function(x){return x;});},
  publicProductPageStatusSync: function(handle){var key=gqPublicPageCacheKey(String(handle||''));return GQ_STOCK_CACHE[key]||null;},
  isPublicHandleVerified: function(handle){return publicProductPageStatusSync(String(handle||''))===true;}
};
})();